// // // // import React, { useState, useRef, useEffect, useCallback, useMemo } from 'react';
// // // // import { motion, AnimatePresence } from 'framer-motion';
// // // // import { Link } from 'react-router-dom';
// // // // import Confetti from 'react-confetti';
// // // // import './AvatarCreator.css';
// // // // //MIN_ZOOM
// // // // const Icon = {
// // // //   Crest: (p) => (
// // // //     <svg viewBox="0 0 48 48" fill="none" stroke="currentColor" strokeWidth="1.3" {...p}>
// // // //       <path d="M24 6c-4 5-9 6-14 5 1 9 4 16 14 21 10-5 13-12 14-21-5 1-10 0-14-5Z" strokeLinejoin="round" />
// // // //       <path d="M18 22c2 2 4 3 6 3s4-1 6-3M24 25v8" strokeLinecap="round" />
// // // //     </svg>
// // // //   ),
// // // //   Upload: (p) => (
// // // //     <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" {...p}>
// // // //       <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4M17 8l-5-5-5 5M12 3v12" strokeLinecap="round" strokeLinejoin="round" />
// // // //     </svg>
// // // //   ),
// // // //   Download: (p) => (
// // // //     <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" {...p}>
// // // //       <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4M7 10l5 5 5-5M12 15V3" strokeLinecap="round" strokeLinejoin="round" />
// // // //     </svg>
// // // //   ),
// // // //   ZoomOut: (p) => (
// // // //     <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" {...p}>
// // // //       <circle cx="11" cy="11" r="7" /><path d="m21 21-4.35-4.35M8 11h6" strokeLinecap="round" />
// // // //     </svg>
// // // //   ),
// // // //   ZoomIn: (p) => (
// // // //     <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" {...p}>
// // // //       <circle cx="11" cy="11" r="7" /><path d="m21 21-4.35-4.35M11 8v6M8 11h6" strokeLinecap="round" />
// // // //     </svg>
// // // //   ),
// // // //   ArrowLeft: (p) => (
// // // //     <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" {...p}>
// // // //       <path d="M19 12H5M12 19l-7-7 7-7" strokeLinecap="round" strokeLinejoin="round" />
// // // //     </svg>
// // // //   ),
// // // //   RoyalVine: (p) => (
// // // //     <svg viewBox="0 0 160 160" fill="none" {...p}>
// // // //       <path d="M14 150 C10 110 28 70 66 46 C90 31 118 24 146 14" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" />
// // // //       <g fill="currentColor">
// // // //         <ellipse cx="34" cy="126" rx="11" ry="5" transform="rotate(-35 34 126)" opacity="0.75" />
// // // //         <ellipse cx="55" cy="98" rx="10" ry="4.5" transform="rotate(-20 55 98)" opacity="0.7" />
// // // //         <ellipse cx="78" cy="70" rx="10" ry="4.5" transform="rotate(5 78 70)" opacity="0.65" />
// // // //         <ellipse cx="103" cy="45" rx="9" ry="4" transform="rotate(25 103 45)" opacity="0.6" />
// // // //         <ellipse cx="128" cy="24" rx="8" ry="3.5" transform="rotate(45 128 24)" opacity="0.55" />
// // // //         <circle cx="146" cy="14" r="3" opacity="0.8" />
// // // //         <circle cx="14" cy="150" r="3" opacity="0.8" />
// // // //       </g>
// // // //     </svg>
// // // //   ),
// // // // };

// // // // const AmbientGlow = ({ secondaryHex }) => (
// // // //   <div style={{ position: 'fixed', inset: 0, overflow: 'hidden', pointerEvents: 'none', zIndex: 0 }}>
// // // //     <div style={{ position: 'absolute', top: '-10%', left: '-10%', width: '60vw', height: '60vw', background: 'radial-gradient(circle, rgba(198, 161, 91, 0.15) 0%, transparent 70%)', filter: 'blur(60px)' }} />
// // // //     <div style={{ position: 'absolute', bottom: '-20%', right: '-10%', width: '70vw', height: '70vw', background: `radial-gradient(circle, ${secondaryHex}40 0%, transparent 70%)`, filter: 'blur(60px)', transition: 'background 0.3s ease' }} />
// // // //     <div style={{ position: 'absolute', top: '30%', left: '50%', transform: 'translateX(-50%)', width: '50vw', height: '50vw', background: 'radial-gradient(circle, rgba(255, 215, 0, 0.08) 0%, transparent 70%)', filter: 'blur(40px)' }} />
// // // //   </div>
// // // // );

// // // // const TEMPLATES = [
// // // //   {
// // // //     id: 'royal-majesty',
// // // //     name: 'Royal Majesty',
// // // //     src: '/assets/photos/ChatGPT_Image_Sep_21_2026_03_11_16_PM.png',
// // // //     width: 1024,
// // // //     height: 1024,
// // // //     hole: { cx: 0.5, cy: 0.46, r: 0.32 }, 
// // // //   }
// // // // ];

// // // // const FRAME_THEMES = [
// // // //   {
// // // //     name: 'Royal Purple',
// // // //     hueShift: 0,
// // // //     hex: '#6b21a8'
// // // //   },
// // // //   {
// // // //     name: 'Sapphire Blue',
// // // //     hueShift: -52,
// // // //     hex: '#2563eb'
// // // //   },
// // // //   {
// // // //     name: 'Emerald Green',
// // // //     hueShift: -112,
// // // //     hex: '#059669'
// // // //   },
// // // //   {
// // // //     name: 'Ruby Red',
// // // //     hueShift: 74,
// // // //     hex: '#e11d48'
// // // //   },
// // // //   {
// // // //     name: 'Rose Pink',
// // // //     hueShift: 60,
// // // //     hex: '#db2777'
// // // //   },
// // // //   {
// // // //     name: 'Luxury Teal',
// // // //     hueShift: -98,
// // // //     hex: '#0d9488'
// // // //   },
// // // //   {
// // // //     name: 'Burnt Orange',
// // // //     hueShift: 108,
// // // //     hex: '#ea580c'
// // // //   },
// // // //   {
// // // //     name: 'Royal Indigo',
// // // //     hueShift: -30,
// // // //     hex: '#4f46e5'
// // // //   },
// // // //   {
// // // //     name: 'Champagne Gold',
// // // //     hueShift: 133,
// // // //     hex: '#d4af37'
// // // //   },
// // // //   {
// // // //     name: 'Midnight Blue',
// // // //     hueShift: -47,
// // // //     hex: '#172554'
// // // //   },
// // // //   {
// // // //     name: 'Royal Fuchsia',
// // // //     hueShift: 21,
// // // //     hex: '#c026d3'
// // // //   },
// // // //   {
// // // //     name: 'Turquoise',
// // // //     hueShift: -81,
// // // //     hex: '#0891b2'
// // // //   },
// // // //   {
// // // //     name: 'Wine',
// // // //     hueShift: 87,
// // // //     hex: '#7f1d1d'
// // // //   },
// // // //   {
// // // //     name: 'Forest Green',
// // // //     hueShift: -130,
// // // //     hex: '#166534'
// // // //   },
// // // //   {
// // // //     name: 'Coral',
// // // //     hueShift: 112,
// // // //     hex: '#f97316'
// // // //   },
// // // //   {
// // // //     name: 'Lavender',
// // // //     hueShift: -15,
// // // //     hex: '#8b5cf6'
// // // //   }
// // // // ];
// // // // //processFrame
// // // // /* ── COLOR MATH UTILITIES ── */
// // // // function rgbToHsl(r, g, b) {
// // // //   r /= 255; g /= 255; b /= 255;
// // // //   const max = Math.max(r, g, b), min = Math.min(r, g, b);
// // // //   let h = 0, s = 0, l = (max + min) / 2;
// // // //   if (max !== min) {
// // // //     const d = max - min;
// // // //     s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
// // // //     switch (max) {
// // // //       case r: h = (g - b) / d + (g < b ? 6 : 0); break;
// // // //       case g: h = (b - r) / d + 2; break;
// // // //       case b: h = (r - g) / d + 4; break;
// // // //       default: break;
// // // //     }
// // // //     h /= 6;
// // // //   }
// // // //   return [h * 360, s, l];
// // // // }

// // // // function hslToRgb(h, s, l) {
// // // //   h /= 360;
// // // //   let r, g, b;
// // // //   if (s === 0) {
// // // //     r = g = b = l;
// // // //   } else {
// // // //     const hue2rgb = (p, q, t) => {
// // // //       if (t < 0) t += 1;
// // // //       if (t > 1) t -= 1;
// // // //       if (t < 1 / 6) return p + (q - p) * 6 * t;
// // // //       if (t < 1 / 2) return q;
// // // //       if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
// // // //       return p;
// // // //     };
// // // //     const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
// // // //     const p = 2 * l - q;
// // // //     r = hue2rgb(p, q, h + 1 / 3);
// // // //     g = hue2rgb(p, q, h);
// // // //     b = hue2rgb(p, q, h - 1 / 3);
// // // //   }
// // // //   return [r * 255, g * 255, b * 255];
// // // // }

// // // // // const MIN_ZOOM = 0.5;
// // // // // const MAX_ZOOM = 3;
// // // // // const EXPORT_SCALE = 1;
// // // // const MIN_ZOOM = 1;
// // // // const MAX_ZOOM = 6;
// // // // const EXPORT_SCALE = 1;

// // // // //holeDiameterPx

// // // // function maxOffsetFrac(naturalDim, minNaturalDim, zoom) {
// // // //   return Math.max(0, (naturalDim * zoom) / minNaturalDim - 1);
// // // // }

// // // // function clamp(value, min, max) {
// // // //   return Math.min(Math.max(value, min), max);
// // // // }

// // // // export default function AvatarCreator() {
// // // //   const template = TEMPLATES[0];
// // // //   const [activeTheme, setActiveTheme] = useState(FRAME_THEMES[0]);
  
// // // //   const [processedFrameSrc, setProcessedFrameSrc] = useState(null);
// // // //   const [isProcessing, setIsProcessing] = useState(true);

// // // //   const [photo, setPhoto] = useState(null);
// // // //   const [zoom, setZoom] = useState(1);
// // // //   const [offset, setOffset] = useState({ x: 0, y: 0 });

// // // //   const [isDownloading, setIsDownloading] = useState(false);
// // // //   const [showConfetti, setShowConfetti] = useState(false);
// // // //   const [errorMessage, setErrorMessage] = useState('');
// // // //   const [previewWidth, setPreviewWidth] = useState(420);

// // // //   const fileInputRef = useRef(null);
// // // //   const dragState = useRef(null);
// // // //   const processedCache = useRef({});

// // // //   useEffect(() => {
// // // //     window.scrollTo(0, 0);
// // // //   }, []);

// // // //   useEffect(() => {
// // // //     const computeWidth = () => {
// // // //       const available = Math.min(window.innerWidth * 0.9, 460);
// // // //       setPreviewWidth(Math.max(260, available));
// // // //     };
// // // //     computeWidth();
// // // //     window.addEventListener('resize', computeWidth);
// // // //     return () => window.removeEventListener('resize', computeWidth);
// // // //   }, []);

// // // //   const previewHeight = previewWidth * (template.height / template.width);
// // // //   const previewHole = {
// // // //     cx: template.hole.cx * previewWidth,
// // // //     cy: template.hole.cy * previewHeight,
// // // //     r: template.hole.r * previewWidth,
// // // //   };

// // // //   //     const img = new Image();
// // // //   //     img.crossOrigin = "anonymous";
// // // //   //     img.onload = () => {
// // // //   //       const canvas = document.createElement('canvas');
// // // //   //       canvas.width = img.width;
// // // //   //       canvas.height = img.height;
// // // //   //       const ctx = canvas.getContext('2d', { willReadFrequently: true });
// // // //   //       ctx.drawImage(img, 0, 0);

// // // //   //       const imgData = ctx.getImageData(0, 0, canvas.width, canvas.height);
// // // //   //       const data = imgData.data;

// // // //   //       const cx = template.hole.cx * canvas.width;
// // // //   //       const cy = template.hole.cy * canvas.height;
// // // //   //       const rSq = (template.hole.r * canvas.width) ** 2;

// // // //   //       for (let i = 0; i < data.length; i += 4) {
// // // //   //         const red = data[i], green = data[i+1], blue = data[i+2], a = data[i+3];
// // // //   //         if (a === 0) continue;
          
// // // //   //         let [h, s, l] = rgbToHsl(red, green, blue);

// // // //   //         const px = (i / 4) % canvas.width;
// // // //   //         const py = Math.floor((i / 4) / canvas.width);
// // // //   //         const distSq = (px - cx) ** 2 + (py - cy) ** 2;

// // // //   //         // 1. CLEAR THE CIRCLE: Make the white center transparent, but protect the Gold Text
// // // //   //         if (distSq < rSq) {
// // // //   //           // White pixels have high lightness and low saturation
// // // //   //           if (l > 0.80 && s < 0.3) {
// // // //   //             data[i + 3] = 0; 
// // // //   //             continue;
// // // //   //           }
// // // //   //         }

// // // //   //         // 2. SHIFT THE THEME: Shift the purples/pinks, but strictly avoid Gold hues (20 to 70)
// // // //   //         const isGold = (h > 15 && h < 75) && s > 0.25;
// // // //   //         const isWhiteOrBlack = l > 0.9 || l < 0.1;

// // // //   //         if (shift !== 0 && !isGold && !isWhiteOrBlack) {
// // // //   //           let newH = (h + shift + 360) % 360;
// // // //   //           const [nR, nG, nB] = hslToRgb(newH, s, l);
// // // //   //           data[i] = nR;
// // // //   //           data[i+1] = nG;
// // // //   //           data[i+2] = nB;
// // // //   //         }
// // // //   //       }

// // // //   //       ctx.putImageData(imgData, 0, 0);
// // // //   //       resolve(canvas.toDataURL('image/png'));
// // // //   //     };
// // // //   //     img.src = template.src;
// // // //   //   });
// // // //   // }, [template]);

// // // // const processFrame = useCallback(async (shift) => {
// // // //   return new Promise((resolve, reject) => {
// // // //     const img = new Image();

// // // //     img.crossOrigin = 'anonymous';

// // // //     img.onload = () => {
// // // //       try {
// // // //         const canvas = document.createElement('canvas');

// // // //         canvas.width = img.naturalWidth || img.width;
// // // //         canvas.height = img.naturalHeight || img.height;

// // // //         const ctx = canvas.getContext('2d', {
// // // //           willReadFrequently: true
// // // //         });

// // // //         if (!ctx) {
// // // //           reject(new Error('Could not create canvas context.'));
// // // //           return;
// // // //         }

// // // //         ctx.drawImage(
// // // //           img,
// // // //           0,
// // // //           0,
// // // //           canvas.width,
// // // //           canvas.height
// // // //         );

// // // //         const imgData = ctx.getImageData(
// // // //           0,
// // // //           0,
// // // //           canvas.width,
// // // //           canvas.height
// // // //         );

// // // //         const data = imgData.data;

// // // //         /* -----------------------------------------
// // // //            CIRCULAR PHOTO OPENING
// // // //         ----------------------------------------- */

// // // //         const cx =
// // // //           template.hole.cx * canvas.width;

// // // //         const cy =
// // // //           template.hole.cy * canvas.height;

// // // //         const radius =
// // // //           template.hole.r * canvas.width;

// // // //         const radiusSq =
// // // //           radius * radius;

// // // //         /*
// // // //           Gives the circular opening a slightly
// // // //           anti-aliased edge instead of a harsh cut.
// // // //         */
// // // //         const feather =
// // // //           Math.max(2, canvas.width * 0.003);

// // // //         /* -----------------------------------------
// // // //            PROCESS EVERY PIXEL
// // // //         ----------------------------------------- */

// // // //         for (let i = 0; i < data.length; i += 4) {
// // // //           const red = data[i];
// // // //           const green = data[i + 1];
// // // //           const blue = data[i + 2];
// // // //           const alpha = data[i + 3];

// // // //           if (alpha === 0) {
// // // //             continue;
// // // //           }

// // // //           let [h, s, l] =
// // // //             rgbToHsl(red, green, blue);

// // // //           const pixelIndex =
// // // //             i / 4;

// // // //           const px =
// // // //             pixelIndex % canvas.width;

// // // //           const py =
// // // //             Math.floor(
// // // //               pixelIndex / canvas.width
// // // //             );

// // // //           const dx =
// // // //             px - cx;

// // // //           const dy =
// // // //             py - cy;

// // // //           const distSq =
// // // //             dx * dx + dy * dy;

// // // //           /*
// // // //              Protect original gold design elements.

// // // //              This allows gold typography/artwork to
// // // //              remain above the person's photograph.
// // // //           */
// // // //           const isGold =
// // // //             h >= 15 &&
// // // //             h <= 75 &&
// // // //             s > 0.20 &&
// // // //             l > 0.15;

// // // //           /*
// // // //              FIX:
// // // //              Make the photo opening genuinely
// // // //              transparent.

// // // //              Previously only WHITE pixels were removed,
// // // //              which meant a purple/dark center could
// // // //              continue covering the uploaded image.
// // // //           */
// // // //           if (distSq < radiusSq && !isGold) {
// // // //             const distance =
// // // //               Math.sqrt(distSq);

// // // //             /*
// // // //                Full transparency throughout almost
// // // //                the entire hole.
// // // //             */
// // // //             if (distance <= radius - feather) {
// // // //               data[i + 3] = 0;
// // // //             }

// // // //             /*
// // // //                Slight feather at edge.
// // // //             */
// // // //             else {
// // // //               const edgeOpacity =
// // // //                 (distance - (radius - feather)) /
// // // //                 feather;

// // // //               data[i + 3] =
// // // //                 Math.round(
// // // //                   alpha *
// // // //                   Math.max(
// // // //                     0,
// // // //                     Math.min(1, edgeOpacity)
// // // //                   )
// // // //                 );
// // // //             }

// // // //             continue;
// // // //           }

// // // //           /* -----------------------------------------
// // // //              COLOR THEME PROCESSING
// // // //           ----------------------------------------- */

// // // //           const isNearWhite =
// // // //             l > 0.92;

// // // //           const isNearBlack =
// // // //             l < 0.08;

// // // //           /*
// // // //              Do NOT recolor:
// // // //              - original gold
// // // //              - pure whites
// // // //              - deep blacks

// // // //              Everything else can follow the selected
// // // //              color theme.
// // // //           */
// // // //           if (
// // // //             shift !== 0 &&
// // // //             !isGold &&
// // // //             !isNearWhite &&
// // // //             !isNearBlack
// // // //           ) {
// // // //             let newHue =
// // // //               (h + shift + 360) % 360;

// // // //             /*
// // // //                Slight saturation boost keeps themes
// // // //                looking rich rather than dull.
// // // //             */
// // // //             const newSaturation =
// // // //               Math.min(
// // // //                 1,
// // // //                 Math.max(
// // // //                   0.15,
// // // //                   s * 1.08
// // // //                 )
// // // //               );

// // // //             const [nr, ng, nb] =
// // // //               hslToRgb(
// // // //                 newHue,
// // // //                 newSaturation,
// // // //                 l
// // // //               );

// // // //             data[i] =
// // // //               Math.round(nr);

// // // //             data[i + 1] =
// // // //               Math.round(ng);

// // // //             data[i + 2] =
// // // //               Math.round(nb);
// // // //           }
// // // //         }

// // // //         ctx.putImageData(
// // // //           imgData,
// // // //           0,
// // // //           0
// // // //         );

// // // //         resolve(
// // // //           canvas.toDataURL(
// // // //             'image/png'
// // // //           )
// // // //         );

// // // //       } catch (error) {
// // // //         console.error(
// // // //           'Frame processing failed:',
// // // //           error
// // // //         );

// // // //         reject(error);
// // // //       }
// // // //     };


// // // //     img.onerror = () => {
// // // //       reject(
// // // //         new Error(
// // // //           `Unable to load frame: ${template.src}`
// // // //         )
// // // //       );
// // // //     };


// // // //     img.src =
// // // //       template.src;
// // // //   });

// // // // }, [template]);
// // // // //handleImageUpload

// // // // function getSmartInitialCrop(naturalWidth, naturalHeight) {
// // // //   const aspect = naturalWidth / naturalHeight;

// // // //   // Portrait photos usually need to be shifted a bit downward
// // // //   // so more of the head shows inside the circle.
// // // //   if (aspect < 0.9) {
// // // //     return {
// // // //       zoom: 1,
// // // //       offset: { x: 0, y: 0.18 }
// // // //     };
// // // //   }

// // // //   // Very wide photos usually need a little extra zoom
// // // //   if (aspect > 1.25) {
// // // //     return {
// // // //       zoom: 1.08,
// // // //       offset: { x: 0, y: 0 }
// // // //     };
// // // //   }

// // // //   // Nearly square photos
// // // //   return {
// // // //     zoom: 1,
// // // //     offset: { x: 0, y: 0.08 }
// // // //   };
// // // // }


// // // //   // useEffect(() => {
// // // //   //   const applyTheme = async () => {
// // // //   //     setIsProcessing(true);
// // // //   //     if (processedCache.current[activeTheme.hueShift]) {
// // // //   //       setProcessedFrameSrc(processedCache.current[activeTheme.hueShift]);
// // // //   //       setIsProcessing(false);
// // // //   //       return;
// // // //   //     }

// // // //   //     // Small timeout allows UI to render loading state
// // // //   //     setTimeout(async () => {
// // // //   //       const processed = await processFrame(activeTheme.hueShift);
// // // //   //       processedCache.current[activeTheme.hueShift] = processed;
// // // //   //       setProcessedFrameSrc(processed);
// // // //   //       setIsProcessing(false);
// // // //   //     }, 50);
// // // //   //   };

// // // //   //   applyTheme();
// // // //   // }, [activeTheme, processFrame]);


// // // //   useEffect(() => {
// // // //   let cancelled = false;

// // // //   const applyTheme = async () => {
// // // //     setIsProcessing(true);
// // // //     setErrorMessage('');

// // // //     try {
// // // //       const cacheKey =
// // // //         `${template.id}-${activeTheme.hueShift}`;

// // // //       /*
// // // //         Use cached image if already generated.
// // // //       */
// // // //       if (
// // // //         processedCache.current[cacheKey]
// // // //       ) {
// // // //         if (!cancelled) {
// // // //           setProcessedFrameSrc(
// // // //             processedCache.current[cacheKey]
// // // //           );

// // // //           setIsProcessing(false);
// // // //         }

// // // //         return;
// // // //       }

// // // //       const processed =
// // // //         await processFrame(
// // // //           activeTheme.hueShift
// // // //         );

// // // //       processedCache.current[cacheKey] =
// // // //         processed;

// // // //       if (!cancelled) {
// // // //         setProcessedFrameSrc(
// // // //           processed
// // // //         );
// // // //       }

// // // //     } catch (error) {
// // // //       console.error(error);

// // // //       if (!cancelled) {
// // // //         /*
// // // //           Fall back to original frame rather
// // // //           than leaving the preview blank.
// // // //         */
// // // //         setProcessedFrameSrc(
// // // //           template.src
// // // //         );

// // // //         setErrorMessage(
// // // //           'Unable to process this frame color.'
// // // //         );
// // // //       }

// // // //     } finally {
// // // //       if (!cancelled) {
// // // //         setIsProcessing(false);
// // // //       }
// // // //     }
// // // //   };


// // // //   applyTheme();


// // // //   return () => {
// // // //     cancelled = true;
// // // //   };

// // // // }, [
// // // //   activeTheme,
// // // //   processFrame,
// // // //   template
// // // // ]);



// // // //   const clampOffset = useCallback(
// // // //   (candidate, currentZoom) => {
// // // //     if (!photo) {
// // // //       return { x: 0, y: 0 };
// // // //     }

// // // //     const safeZoom = Math.max(
// // // //       MIN_ZOOM,
// // // //       currentZoom
// // // //     );

// // // //     /*
// // // //       We don't actually need the preview pixel diameter
// // // //       because these are ratios.
// // // //     */
// // // //     const imageWidth = photo.naturalWidth;
// // // //     const imageHeight = photo.naturalHeight;

// // // //     const minDimension = Math.min(
// // // //       imageWidth,
// // // //       imageHeight
// // // //     );

// // // //     /*
// // // //       At zoom 1, the smallest image dimension exactly
// // // //       covers the avatar diameter.
// // // //     */
// // // //     const renderedWidthRatio =
// // // //       (imageWidth / minDimension) * safeZoom;

// // // //     const renderedHeightRatio =
// // // //       (imageHeight / minDimension) * safeZoom;

// // // //     /*
// // // //       Since offset.x / offset.y are stored as fractions
// // // //       of the circle radius, these values represent the
// // // //       maximum permitted travel.
// // // //     */
// // // //     const maxX = Math.max(
// // // //       0,
// // // //       renderedWidthRatio - 1
// // // //     );

// // // //     const maxY = Math.max(
// // // //       0,
// // // //       renderedHeightRatio - 1
// // // //     );

// // // //     return {
// // // //       x: clamp(
// // // //         candidate.x,
// // // //         -maxX,
// // // //         maxX
// // // //       ),

// // // //       y: clamp(
// // // //         candidate.y,
// // // //         -maxY,
// // // //         maxY
// // // //       )
// // // //     };
// // // //   },
// // // //   [photo]
// // // // );

// // // // //handlePointerMove
// // // //   // const handleZoomChange = (nextZoom) => {
// // // //   //   setZoom(nextZoom);
// // // //   //   setOffset((prev) => clampOffset(prev, nextZoom));
// // // //   // };

// // // //   const handleZoomChange = (nextZoom) => {
// // // //   const safeZoom = clamp(
// // // //     nextZoom,
// // // //     MIN_ZOOM,
// // // //     MAX_ZOOM
// // // //   );

// // // //   setZoom(safeZoom);

// // // //   setOffset((prev) =>
// // // //     clampOffset(prev, safeZoom)
// // // //   );
// // // // };

// // // //   const resetCrop = useCallback(() => {
// // // //     setZoom(1);
// // // //     setOffset({ x: 0, y: 0 });
// // // //   }, []);

// // // //   //   const file = e.target.files[0];
// // // //   //   if (!file) return;
// // // //   //   setErrorMessage('');
    
// // // //   //   const reader = new FileReader();
// // // //   //   reader.onload = (event) => {
// // // //   //     const img = new Image();
// // // //   //     img.onload = () => {
// // // //   //       setPhoto({ src: event.target.result, naturalWidth: img.naturalWidth, naturalHeight: img.naturalHeight });
// // // //   //       resetCrop();
// // // //   //     };
// // // //   //     img.src = event.target.result;
// // // //   //   };
// // // //   //   reader.readAsDataURL(file);
// // // //   // };

// // // //   const handleImageUpload = (e) => {
// // // //   const file =
// // // //     e.target.files?.[0];

// // // //   if (!file) {
// // // //     return;
// // // //   }

// // // //   setErrorMessage('');


// // // //   /* -----------------------------------------
// // // //      Validate image type
// // // //   ----------------------------------------- */

// // // //   if (
// // // //     !file.type.startsWith('image/')
// // // //   ) {
// // // //     setErrorMessage(
// // // //       'Please select a valid image file.'
// // // //     );

// // // //     e.target.value = '';

// // // //     return;
// // // //   }


// // // //   /* -----------------------------------------
// // // //      Maximum 15MB
// // // //   ----------------------------------------- */

// // // //   const MAX_FILE_SIZE =
// // // //     15 * 1024 * 1024;

// // // //   if (
// // // //     file.size > MAX_FILE_SIZE
// // // //   ) {
// // // //     setErrorMessage(
// // // //       'Your image is too large. Please choose an image smaller than 15MB.'
// // // //     );

// // // //     e.target.value = '';

// // // //     return;
// // // //   }


// // // //   const reader =
// // // //     new FileReader();


// // // //   reader.onload = (event) => {
// // // //     const imageSource =
// // // //       event.target?.result;

// // // //     if (!imageSource) {
// // // //       return;
// // // //     }

// // // //     const img =
// // // //       new Image();


// // // //     img.onload = () => {
// // // //       setPhoto({
// // // //         src: imageSource,

// // // //         naturalWidth:
// // // //           img.naturalWidth,

// // // //         naturalHeight:
// // // //           img.naturalHeight
// // // //       });

// // // //       setZoom(1);

// // // //       setOffset({
// // // //         x: 0,
// // // //         y: 0
// // // //       });
// // // //     };


// // // //     img.onerror = () => {
// // // //       setErrorMessage(
// // // //         'We could not read this image. Please select another photo.'
// // // //       );
// // // //     };


// // // //     img.src =
// // // //       imageSource;
// // // //   };


// // // //   reader.onerror = () => {
// // // //     setErrorMessage(
// // // //       'We could not open this file.'
// // // //     );
// // // //   };


// // // //   reader.readAsDataURL(file);


// // // //   /*
// // // //      Allows the user to choose the same image
// // // //      again later.
// // // //   */
// // // //   e.target.value = '';
// // // // };

// // // // //photo-stage

// // // //   const handlePointerDown = (e) => {
// // // //     if (!photo) return;
// // // //     e.target.setPointerCapture(e.pointerId);
// // // //     dragState.current = { startX: e.clientX, startY: e.clientY, startOffset: offset };
// // // //   };



// // // // const handlePointerMove = (e) => {
// // // //   if (!dragState.current || !photo) {
// // // //     return;
// // // //   }

// // // //   /*
// // // //     Convert pointer movement to our normalized
// // // //     radius-based offset system.
// // // //   */
// // // //   const deltaX =
// // // //     e.clientX -
// // // //     dragState.current.startX;

// // // //   const deltaY =
// // // //     e.clientY -
// // // //     dragState.current.startY;

// // // //   const radius =
// // // //     Math.max(
// // // //       previewHole.r,
// // // //       1
// // // //     );

// // // //   const candidate = {
// // // //     x:
// // // //       dragState.current.startOffset.x +
// // // //       deltaX / radius,

// // // //     y:
// // // //       dragState.current.startOffset.y +
// // // //       deltaY / radius
// // // //   };

// // // //   setOffset(
// // // //     clampOffset(
// // // //       candidate,
// // // //       zoom
// // // //     )
// // // //   );
// // // // };


// // // //   const handlePointerUp = (e) => {
// // // //     if (e.target.hasPointerCapture && e.target.hasPointerCapture(e.pointerId)) {
// // // //       e.target.releasePointerCapture(e.pointerId);
// // // //     }
// // // //     dragState.current = null;
// // // //   };

// // // //   // function getPhotoRect(holeDiameterPx) {
// // // //   //   if (!photo) return null;
// // // //   //   const minNaturalDim = Math.min(photo.naturalWidth, photo.naturalHeight);
// // // //   //   const baseScale = holeDiameterPx / minNaturalDim;
// // // //   //   const scale = baseScale * zoom;
// // // //   //   const width = photo.naturalWidth * scale;
// // // //   //   const height = photo.naturalHeight * scale;
// // // //   //   const offsetXPx = offset.x * (holeDiameterPx / 2);
// // // //   //   const offsetYPx = offset.y * (holeDiameterPx / 2);
// // // //   //   return { width, height, offsetXPx, offsetYPx };
// // // //   // }

// // // //   function getPhotoRect(holeDiameterPx) {
// // // //   if (!photo) return null;

// // // //   const imageWidth = photo.naturalWidth;
// // // //   const imageHeight = photo.naturalHeight;

// // // //   /*
// // // //     COVER SCALE

// // // //     We deliberately use Math.max().
// // // //     This guarantees that BOTH dimensions of the circular
// // // //     area are completely covered.

// // // //     The photo may crop on the sides or top/bottom,
// // // //     but you will never see an empty rectangular edge.
// // // //   */
// // // //   const coverScale = Math.max(
// // // //     holeDiameterPx / imageWidth,
// // // //     holeDiameterPx / imageHeight
// // // //   );

// // // //   const finalScale = coverScale * Math.max(1, zoom);

// // // //   const width = imageWidth * finalScale;
// // // //   const height = imageHeight * finalScale;

// // // //   /*
// // // //     Amount the rendered image is allowed to move
// // // //     without exposing empty space inside the circle.
// // // //   */
// // // //   const maxOffsetXPx = Math.max(
// // // //     0,
// // // //     (width - holeDiameterPx) / 2
// // // //   );

// // // //   const maxOffsetYPx = Math.max(
// // // //     0,
// // // //     (height - holeDiameterPx) / 2
// // // //   );

// // // //   const requestedOffsetXPx =
// // // //     offset.x * (holeDiameterPx / 2);

// // // //   const requestedOffsetYPx =
// // // //     offset.y * (holeDiameterPx / 2);

// // // //   const offsetXPx = clamp(
// // // //     requestedOffsetXPx,
// // // //     -maxOffsetXPx,
// // // //     maxOffsetXPx
// // // //   );

// // // //   const offsetYPx = clamp(
// // // //     requestedOffsetYPx,
// // // //     -maxOffsetYPx,
// // // //     maxOffsetYPx
// // // //   );

// // // //   return {
// // // //     width,
// // // //     height,
// // // //     offsetXPx,
// // // //     offsetYPx,
// // // //     maxOffsetXPx,
// // // //     maxOffsetYPx
// // // //   };
// // // // }

// // // // //clampOffset

// // // //   const previewPhotoRect = photo ? getPhotoRect(previewHole.r * 2) : null;

// // // //   const handleDownload = async (e) => {
// // // //     e.preventDefault();
// // // //     if (!photo) {
// // // //       setErrorMessage('Please upload a photo to create your avatar.');
// // // //       setTimeout(() => setErrorMessage(''), 4000);
// // // //       return;
// // // //     }

// // // //     setIsDownloading(true);
// // // //     try {
// // // //       const exportWidth = template.width * EXPORT_SCALE;
// // // //       const exportHeight = template.height * EXPORT_SCALE;
// // // //       const holeCxPx = template.hole.cx * exportWidth;
// // // //       const holeCyPx = template.hole.cy * exportHeight;
// // // //       const holeRPx = template.hole.r * exportWidth;

// // // //       const canvas = document.createElement('canvas');
// // // //       canvas.width = exportWidth;
// // // //       canvas.height = exportHeight;
// // // //       const ctx = canvas.getContext('2d');

// // // //       const photoImg = new Image();
// // // //       photoImg.src = photo.src;
// // // //       await new Promise((resolve) => { photoImg.onload = resolve; });
// // // //       const { width, height, offsetXPx, offsetYPx } = getPhotoRect(holeRPx * 2);
      
// // // //       // 1. Draw User Photo FIRST (So it sits strictly behind the text)
// // // //       ctx.save();
// // // //       ctx.beginPath();
// // // //       ctx.arc(holeCxPx, holeCyPx, holeRPx, 0, Math.PI * 2); 
// // // //       ctx.clip(); // Mask the photo so it doesn't bleed out of the circle
// // // //       ctx.drawImage(
// // // //         photoImg,
// // // //         holeCxPx - width / 2 + offsetXPx,
// // // //         holeCyPx - height / 2 + offsetYPx,
// // // //         width,
// // // //         height
// // // //       );
// // // //       ctx.restore();

// // // //       // 2. Draw Processed Frame ON TOP (The gold text overlaps the photo perfectly!)
// // // //       const frameImg = new Image();
// // // //       frameImg.src = processedFrameSrc || template.src;
// // // //       await new Promise((resolve) => { frameImg.onload = resolve; });
// // // //       ctx.drawImage(frameImg, 0, 0, exportWidth, exportHeight);

// // // //       const dataUrl = canvas.toDataURL('image/png');
// // // //       const link = document.createElement('a');
// // // //       link.download = `Royal_Avatar_${activeTheme.name.replace(/\s+/g, '_')}.png`;
// // // //       link.href = dataUrl;
// // // //       link.click();

// // // //       setShowConfetti(true);
// // // //       setTimeout(() => setShowConfetti(false), 6000);
// // // //     } catch (err) {
// // // //       console.error(err);
// // // //       setErrorMessage('Something went wrong generating your avatar.');
// // // //     } finally {
// // // //       setIsDownloading(false);
// // // //     }
// // // //   };

// // // //   let circleTouchAction = 'auto';
// // // //   if (photo) {
// // // //     const minDim = Math.min(photo.naturalWidth, photo.naturalHeight);
// // // //     const canPanX = maxOffsetFrac(photo.naturalWidth, minDim, zoom) > 0.01;
// // // //     const canPanY = maxOffsetFrac(photo.naturalHeight, minDim, zoom) > 0.01;

// // // //     if (canPanX && canPanY) circleTouchAction = 'none';
// // // //     else if (canPanX) circleTouchAction = 'pan-y';
// // // //     else if (canPanY) circleTouchAction = 'pan-x';
// // // //   }

// // // //   return (
// // // //     <div className="royal-avatar-page">
// // // //       <AmbientGlow secondaryHex={activeTheme.hex} />

// // // //       <div className="royal-nav">
// // // //         <Link to="/" className="back-link">
// // // //           <Icon.ArrowLeft width="16" height="16" /> Back to Home
// // // //         </Link>
// // // //       </div>

// // // //       {showConfetti && (
// // // //         <div className="fixed-confetti-wrapper">
// // // //           <Confetti width={window.innerWidth} height={window.innerHeight} numberOfPieces={400} gravity={0.3} colors={['#C6A15B', '#F4E8C9', activeTheme.hex, '#FFFFFF']} recycle={false} />
// // // //         </div>
// // // //       )}

// // // //       <div className="avatar-container">
// // // //         <Icon.RoyalVine className="royal-vine royal-vine-tl" />
// // // //         <Icon.RoyalVine className="royal-vine royal-vine-tr" />

// // // //         <motion.div className="avatar-header" initial={{ opacity: 0, y: -20 }} animate={{ opacity: 1, y: 0 }}>
// // // //           <Icon.Crest className="header-crest" style={{ color: 'var(--gold, #c6a15b)', width: '48px', marginBottom: '16px' }} />
// // // //           <span className="eyebrow">The Royal Studio</span>
// // // //           <h1>Create Your Avatar</h1>
// // // //           <p>Drop in your photo, adjust the theme color, and download your souvenir.</p>
// // // //         </motion.div>

// // // //         <div className="studio-layout">
          
// // // //           <motion.div className="mirror-section" initial={{ opacity: 0, scale: 0.95 }} animate={{ opacity: 1, scale: 1 }}>
// // // //             <div
// // // //   className={`photo-stage ${photo ? 'has-photo' : 'no-photo'}`}
// // // //   style={{
// // // //     width: previewWidth,
// // // //     height: previewHeight
// // // //   }}

// // // //   onClick={() => {
// // // //     if (!photo) {
// // // //       fileInputRef.current?.click();
// // // //     }
// // // //   }}

// // // //   onPointerDown={handlePointerDown}
// // // //   onPointerMove={handlePointerMove}
// // // //   onPointerUp={handlePointerUp}
// // // //   onPointerCancel={handlePointerUp}
// // // // >

// // // //   {/* -----------------------------------------
// // // //       USER PHOTO
// // // //       This sits below the decorative frame.
// // // //   ----------------------------------------- */}

// // // //   <div
// // // //     className="photo-circle"

// // // //     style={{
// // // //       width:
// // // //         previewHole.r * 2,

// // // //       height:
// // // //         previewHole.r * 2,

// // // //       left:
// // // //         previewHole.cx -
// // // //         previewHole.r,

// // // //       top:
// // // //         previewHole.cy -
// // // //         previewHole.r,

// // // //       touchAction:
// // // //         circleTouchAction
// // // //     }}
// // // //   >

// // // //     {photo && previewPhotoRect ? (
// // // //       <img
// // // //         className="photo-img"

// // // //         src={photo.src}

// // // //         alt="Your uploaded portrait"

// // // //         draggable="false"

// // // //         style={{
// // // //           width:
// // // //             previewPhotoRect.width,

// // // //           height:
// // // //             previewPhotoRect.height,

// // // //           left:
// // // //             previewPhotoRect.offsetXPx -
// // // //             (
// // // //               previewPhotoRect.width -
// // // //               previewHole.r * 2
// // // //             ) / 2,

// // // //           top:
// // // //             previewPhotoRect.offsetYPx -
// // // //             (
// // // //               previewPhotoRect.height -
// // // //               previewHole.r * 2
// // // //             ) / 2
// // // //         }}
// // // //       />
// // // //     ) : (
// // // //       <div
// // // //         className="upload-prompt"
// // // //       >
// // // //         <span className="upload-icon-circle">
// // // //           <Icon.Upload
// // // //             width="24"
// // // //             height="34"
// // // //           />
// // // //         </span>

// // // //         <strong>
// // // //           Add Your Photo
// // // //         </strong>

// // // //         <small>
// // // //           Click to upload
// // // //         </small>
// // // //       </div>
// // // //     )}

// // // //   </div>


// // // //   {/* -----------------------------------------
// // // //       DECORATIVE FRAME
// // // //   ----------------------------------------- */}

// // // //   <img
// // // //     className="template-overlay-img"

// // // //     src={
// // // //       processedFrameSrc ||
// // // //       template.src
// // // //     }

// // // //     alt="Royal avatar frame"

// // // //     draggable="false"

// // // //     style={{
// // // //       opacity:
// // // //         isProcessing
// // // //           ? 0.75
// // // //           : 1
// // // //     }}
// // // //   />


// // // //   {/* -----------------------------------------
// // // //       PROCESSING INDICATOR
// // // //   ----------------------------------------- */}

// // // //   {isProcessing && (
// // // //     <div className="frame-processing">
// // // //       <span className="processing-spinner" />

// // // //       <span>
// // // //         Applying colour…
// // // //       </span>
// // // //     </div>
// // // //   )}


// // // //   <input
// // // //     type="file"
// // // //     ref={fileInputRef}
// // // //     onChange={handleImageUpload}
// // // //     accept="image/png,image/jpeg,image/jpg,image/webp"
// // // //     className="hidden-file-input"
// // // //   />

// // // // </div>
 
// // // //           </motion.div>

// // // //           <motion.div className="wardrobe-section" initial={{ opacity: 0, x: 20 }} animate={{ opacity: 1, x: 0 }}>
// // // //             <form onSubmit={handleDownload}>
              
// // // //               <div className="control-group">
// // // //                 <label>1. Frame Color Theme</label>
// // // //                 <div className="theme-picker">
// // // //                   {FRAME_THEMES.map((theme) => (
// // // //                     <button
// // // //                       key={theme.name}
// // // //                       type="button"
// // // //                       className={`color-swatch ${activeTheme.name === theme.name ? 'active' : ''}`}
// // // //                       style={{ backgroundColor: theme.hex }}
// // // //                       onClick={() => setActiveTheme(theme)}
// // // //                       title={theme.name}
// // // //                     />
// // // //                   ))}
// // // //                 </div>
// // // //               </div>

// // // //               <div className="control-group">
// // // //                 <label>2. Position Your Photo</label>
// // // //                 {!photo ? (
// // // //                   <button type="button" className="btn-outline photo-picker-btn" onClick={() => fileInputRef.current.click()}>
// // // //                     <Icon.Upload width="18" height="18" /> Upload a Photo
// // // //                   </button>
// // // //                 ) : (
// // // //                   <>
// // // //                     <button type="button" className="btn-outline photo-picker-btn" onClick={() => fileInputRef.current.click()}>
// // // //                       Replace Photo
// // // //                     </button>
// // // //                     <div className="zoom-control">
// // // //                       <Icon.ZoomOut width="18" height="18" />
// // // //                       <input type="range" min={MIN_ZOOM} max={MAX_ZOOM} step={0.01} value={zoom} onChange={(e) => handleZoomChange(parseFloat(e.target.value))} />
// // // //                       <Icon.ZoomIn width="18" height="18" />
// // // //                     </div>
// // // //                     <p className="drag-hint">Drag your photo inside the frame to adjust the position.</p>
// // // //                   </>
// // // //                 )}
// // // //               </div>

// // // //               <AnimatePresence>
// // // //                 {errorMessage && (
// // // //                   <motion.div className="error-message" initial={{ opacity: 0, y: -10 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0 }}>
// // // //                     {errorMessage}
// // // //                   </motion.div>
// // // //                 )}
// // // //               </AnimatePresence>

// // // //               <motion.button type="submit" className="btn-gold download-btn" disabled={isDownloading || isProcessing} whileHover={{ scale: 1.02 }} whileTap={{ scale: 0.98 }}>
// // // //                 {isDownloading || isProcessing ? 'Processing Image...' : <><Icon.Download width="20" height="20" /> Download Royal Avatar</>}
// // // //               </motion.button>
// // // //             </form>
// // // //           </motion.div>
// // // //         </div>
// // // //       </div>
// // // //     </div>
// // // //   );
// // // // }


// // // import React, { useState, useRef, useEffect, useCallback, useMemo } from 'react';
// // // import { motion, AnimatePresence } from 'framer-motion';
// // // import { Link } from 'react-router-dom';
// // // import Confetti from 'react-confetti';
// // // import './AvatarCreator.css';
// // // //MIN_ZOOM
// // // const Icon = {
// // //   Crest: (p) => (
// // //     <svg viewBox="0 0 48 48" fill="none" stroke="currentColor" strokeWidth="1.3" {...p}>
// // //       <path d="M24 6c-4 5-9 6-14 5 1 9 4 16 14 21 10-5 13-12 14-21-5 1-10 0-14-5Z" strokeLinejoin="round" />
// // //       <path d="M18 22c2 2 4 3 6 3s4-1 6-3M24 25v8" strokeLinecap="round" />
// // //     </svg>
// // //   ),
// // //   Upload: (p) => (
// // //     <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" {...p}>
// // //       <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4M17 8l-5-5-5 5M12 3v12" strokeLinecap="round" strokeLinejoin="round" />
// // //     </svg>
// // //   ),
// // //   Download: (p) => (
// // //     <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" {...p}>
// // //       <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4M7 10l5 5 5-5M12 15V3" strokeLinecap="round" strokeLinejoin="round" />
// // //     </svg>
// // //   ),
// // //   ZoomOut: (p) => (
// // //     <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" {...p}>
// // //       <circle cx="11" cy="11" r="7" /><path d="m21 21-4.35-4.35M8 11h6" strokeLinecap="round" />
// // //     </svg>
// // //   ),
// // //   ZoomIn: (p) => (
// // //     <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" {...p}>
// // //       <circle cx="11" cy="11" r="7" /><path d="m21 21-4.35-4.35M11 8v6M8 11h6" strokeLinecap="round" />
// // //     </svg>
// // //   ),
// // //   ArrowLeft: (p) => (
// // //     <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" {...p}>
// // //       <path d="M19 12H5M12 19l-7-7 7-7" strokeLinecap="round" strokeLinejoin="round" />
// // //     </svg>
// // //   ),
// // //   RoyalVine: (p) => (
// // //     <svg viewBox="0 0 160 160" fill="none" {...p}>
// // //       <path d="M14 150 C10 110 28 70 66 46 C90 31 118 24 146 14" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" />
// // //       <g fill="currentColor">
// // //         <ellipse cx="34" cy="126" rx="11" ry="5" transform="rotate(-35 34 126)" opacity="0.75" />
// // //         <ellipse cx="55" cy="98" rx="10" ry="4.5" transform="rotate(-20 55 98)" opacity="0.7" />
// // //         <ellipse cx="78" cy="70" rx="10" ry="4.5" transform="rotate(5 78 70)" opacity="0.65" />
// // //         <ellipse cx="103" cy="45" rx="9" ry="4" transform="rotate(25 103 45)" opacity="0.6" />
// // //         <ellipse cx="128" cy="24" rx="8" ry="3.5" transform="rotate(45 128 24)" opacity="0.55" />
// // //         <circle cx="146" cy="14" r="3" opacity="0.8" />
// // //         <circle cx="14" cy="150" r="3" opacity="0.8" />
// // //       </g>
// // //     </svg>
// // //   ),
// // // };

// // // const AmbientGlow = ({ secondaryHex }) => (
// // //   <div style={{ position: 'fixed', inset: 0, overflow: 'hidden', pointerEvents: 'none', zIndex: 0 }}>
// // //     <div style={{ position: 'absolute', top: '-10%', left: '-10%', width: '60vw', height: '60vw', background: 'radial-gradient(circle, rgba(198, 161, 91, 0.15) 0%, transparent 70%)', filter: 'blur(60px)' }} />
// // //     <div style={{ position: 'absolute', bottom: '-20%', right: '-10%', width: '70vw', height: '70vw', background: `radial-gradient(circle, ${secondaryHex}40 0%, transparent 70%)`, filter: 'blur(60px)', transition: 'background 0.3s ease' }} />
// // //     <div style={{ position: 'absolute', top: '30%', left: '50%', transform: 'translateX(-50%)', width: '50vw', height: '50vw', background: 'radial-gradient(circle, rgba(255, 215, 0, 0.08) 0%, transparent 70%)', filter: 'blur(40px)' }} />
// // //   </div>
// // // );

// // // const TEMPLATES = [
// // //   {
// // //     id: 'royal-majesty',
// // //     name: 'Royal Majesty',
// // //     src: '/assets/photos/ChatGPT_Image_Sep_21_2026_03_11_16_PM.png',
// // //     width: 1024,
// // //     height: 1024,
// // //     hole: { cx: 0.5, cy: 0.46, r: 0.32 }, 
// // //   }
// // // ];

// // // const FRAME_THEMES = [
// // //   {
// // //     name: 'Royal Purple',
// // //     hueShift: 0,
// // //     hex: '#6b21a8'
// // //   },
// // //   {
// // //     name: 'Sapphire Blue',
// // //     hueShift: -52,
// // //     hex: '#2563eb'
// // //   },
// // //   {
// // //     name: 'Emerald Green',
// // //     hueShift: -112,
// // //     hex: '#059669'
// // //   },
// // //   {
// // //     name: 'Ruby Red',
// // //     hueShift: 74,
// // //     hex: '#e11d48'
// // //   },
// // //   {
// // //     name: 'Rose Pink',
// // //     hueShift: 60,
// // //     hex: '#db2777'
// // //   },
// // //   {
// // //     name: 'Luxury Teal',
// // //     hueShift: -98,
// // //     hex: '#0d9488'
// // //   },
// // //   {
// // //     name: 'Burnt Orange',
// // //     hueShift: 108,
// // //     hex: '#ea580c'
// // //   },
// // //   {
// // //     name: 'Royal Indigo',
// // //     hueShift: -30,
// // //     hex: '#4f46e5'
// // //   },
// // //   {
// // //     name: 'Champagne Gold',
// // //     hueShift: 133,
// // //     hex: '#d4af37'
// // //   },
// // //   {
// // //     name: 'Midnight Blue',
// // //     hueShift: -47,
// // //     hex: '#172554'
// // //   },
// // //   {
// // //     name: 'Royal Fuchsia',
// // //     hueShift: 21,
// // //     hex: '#c026d3'
// // //   },
// // //   {
// // //     name: 'Turquoise',
// // //     hueShift: -81,
// // //     hex: '#0891b2'
// // //   },
// // //   {
// // //     name: 'Wine',
// // //     hueShift: 87,
// // //     hex: '#7f1d1d'
// // //   },
// // //   {
// // //     name: 'Forest Green',
// // //     hueShift: -130,
// // //     hex: '#166534'
// // //   },
// // //   {
// // //     name: 'Coral',
// // //     hueShift: 112,
// // //     hex: '#f97316'
// // //   },
// // //   {
// // //     name: 'Lavender',
// // //     hueShift: -15,
// // //     hex: '#8b5cf6'
// // //   }
// // // ];
// // // //processFrame
// // // /* ── COLOR MATH UTILITIES ── */
// // // function rgbToHsl(r, g, b) {
// // //   r /= 255; g /= 255; b /= 255;
// // //   const max = Math.max(r, g, b), min = Math.min(r, g, b);
// // //   let h = 0, s = 0, l = (max + min) / 2;
// // //   if (max !== min) {
// // //     const d = max - min;
// // //     s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
// // //     switch (max) {
// // //       case r: h = (g - b) / d + (g < b ? 6 : 0); break;
// // //       case g: h = (b - r) / d + 2; break;
// // //       case b: h = (r - g) / d + 4; break;
// // //       default: break;
// // //     }
// // //     h /= 6;
// // //   }
// // //   return [h * 360, s, l];
// // // }

// // // function hslToRgb(h, s, l) {
// // //   h /= 360;
// // //   let r, g, b;
// // //   if (s === 0) {
// // //     r = g = b = l;
// // //   } else {
// // //     const hue2rgb = (p, q, t) => {
// // //       if (t < 0) t += 1;
// // //       if (t > 1) t -= 1;
// // //       if (t < 1 / 6) return p + (q - p) * 6 * t;
// // //       if (t < 1 / 2) return q;
// // //       if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
// // //       return p;
// // //     };
// // //     const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
// // //     const p = 2 * l - q;
// // //     r = hue2rgb(p, q, h + 1 / 3);
// // //     g = hue2rgb(p, q, h);
// // //     b = hue2rgb(p, q, h - 1 / 3);
// // //   }
// // //   return [r * 255, g * 255, b * 255];
// // // }

// // // const MIN_ZOOM = 1;
// // // const MAX_ZOOM = 4;
// // // const EXPORT_SCALE = 1;

// // // function clamp(value, min, max) {
// // //   return Math.min(Math.max(value, min), max);
// // // }

// // // export default function AvatarCreator() {
// // //   const template = TEMPLATES[0];
// // //   const [activeTheme, setActiveTheme] = useState(FRAME_THEMES[0]);
  
// // //   const [processedFrameSrc, setProcessedFrameSrc] = useState(null);
// // //   const [isProcessing, setIsProcessing] = useState(true);

// // //   const [photo, setPhoto] = useState(null);
// // //   const [zoom, setZoom] = useState(1);
// // //   const [offset, setOffset] = useState({ x: 0, y: 0 });

// // //   const [isDownloading, setIsDownloading] = useState(false);
// // //   const [showConfetti, setShowConfetti] = useState(false);
// // //   const [errorMessage, setErrorMessage] = useState('');
// // //   const [previewWidth, setPreviewWidth] = useState(420);

// // //   const fileInputRef = useRef(null);
// // //   const dragState = useRef(null);
// // //   const processedCache = useRef({});

// // //   useEffect(() => {
// // //     window.scrollTo(0, 0);
// // //   }, []);

// // //   useEffect(() => {
// // //     const computeWidth = () => {
// // //       const available = Math.min(window.innerWidth * 0.9, 460);
// // //       setPreviewWidth(Math.max(260, available));
// // //     };
// // //     computeWidth();
// // //     window.addEventListener('resize', computeWidth);
// // //     return () => window.removeEventListener('resize', computeWidth);
// // //   }, []);

// // //   const previewHeight = previewWidth * (template.height / template.width);
// // //   const previewHole = {
// // //     cx: template.hole.cx * previewWidth,
// // //     cy: template.hole.cy * previewHeight,
// // //     r: template.hole.r * previewWidth,
// // //   };

// // //   //     const img = new Image();
// // //   //     img.crossOrigin = "anonymous";
// // //   //     img.onload = () => {
// // //   //       const canvas = document.createElement('canvas');
// // //   //       canvas.width = img.width;
// // //   //       canvas.height = img.height;
// // //   //       const ctx = canvas.getContext('2d', { willReadFrequently: true });
// // //   //       ctx.drawImage(img, 0, 0);

// // //   //       const imgData = ctx.getImageData(0, 0, canvas.width, canvas.height);
// // //   //       const data = imgData.data;

// // //   //       const cx = template.hole.cx * canvas.width;
// // //   //       const cy = template.hole.cy * canvas.height;
// // //   //       const rSq = (template.hole.r * canvas.width) ** 2;

// // //   //       for (let i = 0; i < data.length; i += 4) {
// // //   //         const red = data[i], green = data[i+1], blue = data[i+2], a = data[i+3];
// // //   //         if (a === 0) continue;
          
// // //   //         let [h, s, l] = rgbToHsl(red, green, blue);

// // //   //         const px = (i / 4) % canvas.width;
// // //   //         const py = Math.floor((i / 4) / canvas.width);
// // //   //         const distSq = (px - cx) ** 2 + (py - cy) ** 2;

// // //   //         // 1. CLEAR THE CIRCLE: Make the white center transparent, but protect the Gold Text
// // //   //         if (distSq < rSq) {
// // //   //           // White pixels have high lightness and low saturation
// // //   //           if (l > 0.80 && s < 0.3) {
// // //   //             data[i + 3] = 0; 
// // //   //             continue;
// // //   //           }
// // //   //         }

// // //   //         // 2. SHIFT THE THEME: Shift the purples/pinks, but strictly avoid Gold hues (20 to 70)
// // //   //         const isGold = (h > 15 && h < 75) && s > 0.25;
// // //   //         const isWhiteOrBlack = l > 0.9 || l < 0.1;

// // //   //         if (shift !== 0 && !isGold && !isWhiteOrBlack) {
// // //   //           let newH = (h + shift + 360) % 360;
// // //   //           const [nR, nG, nB] = hslToRgb(newH, s, l);
// // //   //           data[i] = nR;
// // //   //           data[i+1] = nG;
// // //   //           data[i+2] = nB;
// // //   //         }
// // //   //       }

// // //   //       ctx.putImageData(imgData, 0, 0);
// // //   //       resolve(canvas.toDataURL('image/png'));
// // //   //     };
// // //   //     img.src = template.src;
// // //   //   });
// // //   // }, [template]);

// // // const processFrame = useCallback(async (shift) => {
// // //   return new Promise((resolve, reject) => {
// // //     const img = new Image();

// // //     img.crossOrigin = 'anonymous';

// // //     img.onload = () => {
// // //       try {
// // //         const canvas = document.createElement('canvas');

// // //         canvas.width = img.naturalWidth || img.width;
// // //         canvas.height = img.naturalHeight || img.height;

// // //         const ctx = canvas.getContext('2d', {
// // //           willReadFrequently: true
// // //         });

// // //         if (!ctx) {
// // //           reject(new Error('Could not create canvas context.'));
// // //           return;
// // //         }

// // //         ctx.drawImage(
// // //           img,
// // //           0,
// // //           0,
// // //           canvas.width,
// // //           canvas.height
// // //         );

// // //         const imgData = ctx.getImageData(
// // //           0,
// // //           0,
// // //           canvas.width,
// // //           canvas.height
// // //         );

// // //         const data = imgData.data;

// // //         /* -----------------------------------------
// // //            CIRCULAR PHOTO OPENING
// // //         ----------------------------------------- */

// // //         const cx =
// // //           template.hole.cx * canvas.width;

// // //         const cy =
// // //           template.hole.cy * canvas.height;

// // //         const radius =
// // //           template.hole.r * canvas.width;

// // //         const radiusSq =
// // //           radius * radius;

// // //         /*
// // //           Gives the circular opening a slightly
// // //           anti-aliased edge instead of a harsh cut.
// // //         */
// // //         const feather =
// // //           Math.max(2, canvas.width * 0.003);

// // //         /* -----------------------------------------
// // //            PROCESS EVERY PIXEL
// // //         ----------------------------------------- */

// // //         for (let i = 0; i < data.length; i += 4) {
// // //           const red = data[i];
// // //           const green = data[i + 1];
// // //           const blue = data[i + 2];
// // //           const alpha = data[i + 3];

// // //           if (alpha === 0) {
// // //             continue;
// // //           }

// // //           let [h, s, l] =
// // //             rgbToHsl(red, green, blue);

// // //           const pixelIndex =
// // //             i / 4;

// // //           const px =
// // //             pixelIndex % canvas.width;

// // //           const py =
// // //             Math.floor(
// // //               pixelIndex / canvas.width
// // //             );

// // //           const dx =
// // //             px - cx;

// // //           const dy =
// // //             py - cy;

// // //           const distSq =
// // //             dx * dx + dy * dy;

// // //           /*
// // //              Protect original gold design elements.

// // //              This allows gold typography/artwork to
// // //              remain above the person's photograph.
// // //           */
// // //           const isGold =
// // //             h >= 15 &&
// // //             h <= 75 &&
// // //             s > 0.20 &&
// // //             l > 0.15;

// // //           /*
// // //              FIX:
// // //              Make the photo opening genuinely
// // //              transparent.

// // //              Previously only WHITE pixels were removed,
// // //              which meant a purple/dark center could
// // //              continue covering the uploaded image.
// // //           */
// // //           if (distSq < radiusSq && !isGold) {
// // //             const distance =
// // //               Math.sqrt(distSq);

// // //             /*
// // //                Full transparency throughout almost
// // //                the entire hole.
// // //             */
// // //             if (distance <= radius - feather) {
// // //               data[i + 3] = 0;
// // //             }

// // //             /*
// // //                Slight feather at edge.
// // //             */
// // //             else {
// // //               const edgeOpacity =
// // //                 (distance - (radius - feather)) /
// // //                 feather;

// // //               data[i + 3] =
// // //                 Math.round(
// // //                   alpha *
// // //                   Math.max(
// // //                     0,
// // //                     Math.min(1, edgeOpacity)
// // //                   )
// // //                 );
// // //             }

// // //             continue;
// // //           }

// // //           /* -----------------------------------------
// // //              COLOR THEME PROCESSING
// // //           ----------------------------------------- */

// // //           const isNearWhite =
// // //             l > 0.92;

// // //           const isNearBlack =
// // //             l < 0.08;

// // //           /*
// // //              Do NOT recolor:
// // //              - original gold
// // //              - pure whites
// // //              - deep blacks

// // //              Everything else can follow the selected
// // //              color theme.
// // //           */
// // //           if (
// // //             shift !== 0 &&
// // //             !isGold &&
// // //             !isNearWhite &&
// // //             !isNearBlack
// // //           ) {
// // //             let newHue =
// // //               (h + shift + 360) % 360;

// // //             /*
// // //                Slight saturation boost keeps themes
// // //                looking rich rather than dull.
// // //             */
// // //             const newSaturation =
// // //               Math.min(
// // //                 1,
// // //                 Math.max(
// // //                   0.15,
// // //                   s * 1.08
// // //                 )
// // //               );

// // //             const [nr, ng, nb] =
// // //               hslToRgb(
// // //                 newHue,
// // //                 newSaturation,
// // //                 l
// // //               );

// // //             data[i] =
// // //               Math.round(nr);

// // //             data[i + 1] =
// // //               Math.round(ng);

// // //             data[i + 2] =
// // //               Math.round(nb);
// // //           }
// // //         }

// // //         ctx.putImageData(
// // //           imgData,
// // //           0,
// // //           0
// // //         );

// // //         resolve(
// // //           canvas.toDataURL(
// // //             'image/png'
// // //           )
// // //         );

// // //       } catch (error) {
// // //         console.error(
// // //           'Frame processing failed:',
// // //           error
// // //         );

// // //         reject(error);
// // //       }
// // //     };


// // //     img.onerror = () => {
// // //       reject(
// // //         new Error(
// // //           `Unable to load frame: ${template.src}`
// // //         )
// // //       );
// // //     };


// // //     img.src =
// // //       template.src;
// // //   });

// // // }, [template]);
// // // //handleImageUpload

// // // function getSmartInitialCrop(naturalWidth, naturalHeight) {
// // //   const aspect = naturalWidth / naturalHeight;

// // //   // Start by showing the whole photo.
// // //   // Slight vertical bias only helps common portrait photos.
// // //   if (aspect < 0.85) {
// // //     return { zoom: 1, offset: { x: 0, y: 0.06 } };
// // //   }

// // //   return { zoom: 1, offset: { x: 0, y: 0 } };
// // // }


// // //   // useEffect(() => {
// // //   //   const applyTheme = async () => {
// // //   //     setIsProcessing(true);
// // //   //     if (processedCache.current[activeTheme.hueShift]) {
// // //   //       setProcessedFrameSrc(processedCache.current[activeTheme.hueShift]);
// // //   //       setIsProcessing(false);
// // //   //       return;
// // //   //     }

// // //   //     // Small timeout allows UI to render loading state
// // //   //     setTimeout(async () => {
// // //   //       const processed = await processFrame(activeTheme.hueShift);
// // //   //       processedCache.current[activeTheme.hueShift] = processed;
// // //   //       setProcessedFrameSrc(processed);
// // //   //       setIsProcessing(false);
// // //   //     }, 50);
// // //   //   };

// // //   //   applyTheme();
// // //   // }, [activeTheme, processFrame]);


// // //   useEffect(() => {
// // //   let cancelled = false;

// // //   const applyTheme = async () => {
// // //     setIsProcessing(true);
// // //     setErrorMessage('');

// // //     try {
// // //       const cacheKey =
// // //         `${template.id}-${activeTheme.hueShift}`;

// // //       /*
// // //         Use cached image if already generated.
// // //       */
// // //       if (
// // //         processedCache.current[cacheKey]
// // //       ) {
// // //         if (!cancelled) {
// // //           setProcessedFrameSrc(
// // //             processedCache.current[cacheKey]
// // //           );

// // //           setIsProcessing(false);
// // //         }

// // //         return;
// // //       }

// // //       const processed =
// // //         await processFrame(
// // //           activeTheme.hueShift
// // //         );

// // //       processedCache.current[cacheKey] =
// // //         processed;

// // //       if (!cancelled) {
// // //         setProcessedFrameSrc(
// // //           processed
// // //         );
// // //       }

// // //     } catch (error) {
// // //       console.error(error);

// // //       if (!cancelled) {
// // //         /*
// // //           Fall back to original frame rather
// // //           than leaving the preview blank.
// // //         */
// // //         setProcessedFrameSrc(
// // //           template.src
// // //         );

// // //         setErrorMessage(
// // //           'Unable to process this frame color.'
// // //         );
// // //       }

// // //     } finally {
// // //       if (!cancelled) {
// // //         setIsProcessing(false);
// // //       }
// // //     }
// // //   };


// // //   applyTheme();


// // //   return () => {
// // //     cancelled = true;
// // //   };

// // // }, [
// // //   activeTheme,
// // //   processFrame,
// // //   template
// // // ]);



// // //   /*
// // //    * The foreground portrait uses CONTAIN at zoom 1.
// // //    * That means the whole uploaded photo is visible instead of looking
// // //    * excessively zoomed. A blurred COVER copy sits behind it, so the
// // //    * circular opening is always visually filled and no rectangular gaps
// // //    * are exposed.
// // //    */
// // //   const clampOffset = useCallback((candidate) => {
// // //     return {
// // //       x: clamp(candidate.x, -1, 1),
// // //       y: clamp(candidate.y, -1, 1)
// // //     };
// // //   }, []);

// // //   const handleZoomChange = (nextZoom) => {
// // //     const safeZoom = clamp(nextZoom, MIN_ZOOM, MAX_ZOOM);
// // //     setZoom(safeZoom);
// // //     setOffset((prev) => clampOffset(prev));
// // //   };

// // //   const resetCrop = useCallback((targetPhoto = photo) => {
// // //     if (!targetPhoto) {
// // //       setZoom(1);
// // //       setOffset({ x: 0, y: 0 });
// // //       return;
// // //     }

// // //     const initial = getSmartInitialCrop(
// // //       targetPhoto.naturalWidth,
// // //       targetPhoto.naturalHeight
// // //     );

// // //     setZoom(initial.zoom);
// // //     setOffset(initial.offset);
// // //   }, [photo]);

// // //   const handleImageUpload = (e) => {
// // //     const file = e.target.files?.[0];

// // //     if (!file) return;

// // //     setErrorMessage('');

// // //     if (!file.type.startsWith('image/')) {
// // //       setErrorMessage('Please select a valid image file.');
// // //       e.target.value = '';
// // //       return;
// // //     }

// // //     const MAX_FILE_SIZE = 15 * 1024 * 1024;

// // //     if (file.size > MAX_FILE_SIZE) {
// // //       setErrorMessage(
// // //         'Your image is too large. Please choose an image smaller than 15MB.'
// // //       );
// // //       e.target.value = '';
// // //       return;
// // //     }

// // //     const reader = new FileReader();

// // //     reader.onload = (event) => {
// // //       const imageSource = event.target?.result;
// // //       if (!imageSource) return;

// // //       const img = new Image();

// // //       img.onload = () => {
// // //         const nextPhoto = {
// // //           src: imageSource,
// // //           naturalWidth: img.naturalWidth,
// // //           naturalHeight: img.naturalHeight
// // //         };

// // //         setPhoto(nextPhoto);

// // //         const initial = getSmartInitialCrop(
// // //           img.naturalWidth,
// // //           img.naturalHeight
// // //         );

// // //         setZoom(initial.zoom);
// // //         setOffset(initial.offset);
// // //       };

// // //       img.onerror = () => {
// // //         setErrorMessage(
// // //           'We could not read this image. Please select another photo.'
// // //         );
// // //       };

// // //       img.src = imageSource;
// // //     };

// // //     reader.onerror = () => {
// // //       setErrorMessage('We could not open this file.');
// // //     };

// // //     reader.readAsDataURL(file);

// // //     // Allows choosing the same file again.
// // //     e.target.value = '';
// // //   };

// // //   const handlePointerDown = (e) => {
// // //     if (!photo) return;

// // //     e.currentTarget.setPointerCapture?.(e.pointerId);

// // //     dragState.current = {
// // //       startX: e.clientX,
// // //       startY: e.clientY,
// // //       startOffset: { ...offset }
// // //     };
// // //   };

// // //   const handlePointerMove = (e) => {
// // //     if (!dragState.current || !photo) return;

// // //     const radius = Math.max(previewHole.r, 1);

// // //     const deltaX = e.clientX - dragState.current.startX;
// // //     const deltaY = e.clientY - dragState.current.startY;

// // //     const candidate = {
// // //       x: dragState.current.startOffset.x + deltaX / radius,
// // //       y: dragState.current.startOffset.y + deltaY / radius
// // //     };

// // //     setOffset(clampOffset(candidate));
// // //   };

// // //   const handlePointerUp = (e) => {
// // //     if (
// // //       e.currentTarget.hasPointerCapture &&
// // //       e.currentTarget.hasPointerCapture(e.pointerId)
// // //     ) {
// // //       e.currentTarget.releasePointerCapture(e.pointerId);
// // //     }

// // //     dragState.current = null;
// // //   };

// // //   /*
// // //    * Foreground portrait rectangle.
// // //    *
// // //    * zoom === 1  -> contain (whole image visible)
// // //    * zoom > 1    -> user can zoom in
// // //    *
// // //    * Empty space that contain would normally create is hidden by the
// // //    * blurred cover background layer.
// // //    */
// // //   function getPhotoRect(holeDiameterPx, customZoom = zoom, customOffset = offset) {
// // //     if (!photo) return null;

// // //     const imageWidth = photo.naturalWidth;
// // //     const imageHeight = photo.naturalHeight;

// // //     const containScale = Math.min(
// // //       holeDiameterPx / imageWidth,
// // //       holeDiameterPx / imageHeight
// // //     );

// // //     const finalScale =
// // //       containScale * clamp(customZoom, MIN_ZOOM, MAX_ZOOM);

// // //     const width = imageWidth * finalScale;
// // //     const height = imageHeight * finalScale;

// // //     const maxShift = holeDiameterPx * 0.46;

// // //     const offsetXPx = clamp(
// // //       customOffset.x * (holeDiameterPx / 2),
// // //       -maxShift,
// // //       maxShift
// // //     );

// // //     const offsetYPx = clamp(
// // //       customOffset.y * (holeDiameterPx / 2),
// // //       -maxShift,
// // //       maxShift
// // //     );

// // //     return {
// // //       width,
// // //       height,
// // //       offsetXPx,
// // //       offsetYPx
// // //     };
// // //   }

// // //   const previewPhotoRect = photo ? getPhotoRect(previewHole.r * 2) : null;

// // //   const handleDownload = async (e) => {
// // //     e.preventDefault();
// // //     if (!photo) {
// // //       setErrorMessage('Please upload a photo to create your avatar.');
// // //       setTimeout(() => setErrorMessage(''), 4000);
// // //       return;
// // //     }

// // //     setIsDownloading(true);
// // //     try {
// // //       const exportWidth = template.width * EXPORT_SCALE;
// // //       const exportHeight = template.height * EXPORT_SCALE;
// // //       const holeCxPx = template.hole.cx * exportWidth;
// // //       const holeCyPx = template.hole.cy * exportHeight;
// // //       const holeRPx = template.hole.r * exportWidth;

// // //       const canvas = document.createElement('canvas');
// // //       canvas.width = exportWidth;
// // //       canvas.height = exportHeight;
// // //       const ctx = canvas.getContext('2d');

// // //       const photoImg = new Image();
// // //       photoImg.src = photo.src;

// // //       await new Promise((resolve, reject) => {
// // //         photoImg.onload = resolve;
// // //         photoImg.onerror = reject;
// // //       });

// // //       const holeDiameter = holeRPx * 2;

// // //       // ---------------------------------------------------------
// // //       // 1. BLURRED COVER BACKGROUND
// // //       // Always fills the circle so the user can zoom out safely.
// // //       // ---------------------------------------------------------
// // //       const coverScale = Math.max(
// // //         holeDiameter / photo.naturalWidth,
// // //         holeDiameter / photo.naturalHeight
// // //       );

// // //       const coverWidth = photo.naturalWidth * coverScale;
// // //       const coverHeight = photo.naturalHeight * coverScale;

// // //       ctx.save();
// // //       ctx.beginPath();
// // //       ctx.arc(holeCxPx, holeCyPx, holeRPx, 0, Math.PI * 2);
// // //       ctx.clip();

// // //       ctx.filter = `blur(${Math.max(12, exportWidth * 0.014)}px)`;
// // //       ctx.globalAlpha = 0.82;

// // //       const blurOverscan = 1.12;

// // //       ctx.drawImage(
// // //         photoImg,
// // //         holeCxPx - (coverWidth * blurOverscan) / 2,
// // //         holeCyPx - (coverHeight * blurOverscan) / 2,
// // //         coverWidth * blurOverscan,
// // //         coverHeight * blurOverscan
// // //       );

// // //       // Darken slightly so the foreground portrait stays clear.
// // //       ctx.filter = 'none';
// // //       ctx.globalAlpha = 0.14;
// // //       ctx.fillStyle = '#0b080d';
// // //       ctx.fillRect(
// // //         holeCxPx - holeRPx,
// // //         holeCyPx - holeRPx,
// // //         holeDiameter,
// // //         holeDiameter
// // //       );

// // //       ctx.restore();

// // //       // ---------------------------------------------------------
// // //       // 2. FOREGROUND PHOTO
// // //       // At zoom 1, the WHOLE image fits inside the circle.
// // //       // ---------------------------------------------------------
// // //       const {
// // //         width,
// // //         height,
// // //         offsetXPx,
// // //         offsetYPx
// // //       } = getPhotoRect(holeDiameter);

// // //       ctx.save();
// // //       ctx.beginPath();
// // //       ctx.arc(holeCxPx, holeCyPx, holeRPx, 0, Math.PI * 2);
// // //       ctx.clip();

// // //       ctx.drawImage(
// // //         photoImg,
// // //         holeCxPx - width / 2 + offsetXPx,
// // //         holeCyPx - height / 2 + offsetYPx,
// // //         width,
// // //         height
// // //       );

// // //       ctx.restore();

// // //       // 2. Draw Processed Frame ON TOP (The gold text overlaps the photo perfectly!)
// // //       const frameImg = new Image();
// // //       frameImg.src = processedFrameSrc || template.src;
// // //       await new Promise((resolve) => { frameImg.onload = resolve; });
// // //       ctx.drawImage(frameImg, 0, 0, exportWidth, exportHeight);

// // //       const dataUrl = canvas.toDataURL('image/png');
// // //       const link = document.createElement('a');
// // //       link.download = `Royal_Avatar_${activeTheme.name.replace(/\s+/g, '_')}.png`;
// // //       link.href = dataUrl;
// // //       link.click();

// // //       setShowConfetti(true);
// // //       setTimeout(() => setShowConfetti(false), 6000);
// // //     } catch (err) {
// // //       console.error(err);
// // //       setErrorMessage('Something went wrong generating your avatar.');
// // //     } finally {
// // //       setIsDownloading(false);
// // //     }
// // //   };

// // //   const circleTouchAction = photo ? 'none' : 'auto';

// // //   return (
// // //     <div className="royal-avatar-page">
// // //       <AmbientGlow secondaryHex={activeTheme.hex} />

// // //       <div className="royal-nav">
// // //         <Link to="/" className="back-link">
// // //           <Icon.ArrowLeft width="16" height="16" /> Back to Home
// // //         </Link>
// // //       </div>

// // //       {showConfetti && (
// // //         <div className="fixed-confetti-wrapper">
// // //           <Confetti width={window.innerWidth} height={window.innerHeight} numberOfPieces={400} gravity={0.3} colors={['#C6A15B', '#F4E8C9', activeTheme.hex, '#FFFFFF']} recycle={false} />
// // //         </div>
// // //       )}

// // //       <div className="avatar-container">
// // //         <Icon.RoyalVine className="royal-vine royal-vine-tl" />
// // //         <Icon.RoyalVine className="royal-vine royal-vine-tr" />

// // //         <motion.div className="avatar-header" initial={{ opacity: 0, y: -20 }} animate={{ opacity: 1, y: 0 }}>
// // //           <Icon.Crest className="header-crest" style={{ color: 'var(--gold, #c6a15b)', width: '48px', marginBottom: '16px' }} />
// // //           <span className="eyebrow">The Royal Studio</span>
// // //           <h1>Create Your Avatar</h1>
// // //           <p>Drop in your photo, adjust the theme color, and download your souvenir.</p>
// // //         </motion.div>

// // //         <div className="studio-layout">
          
// // //           <motion.div className="mirror-section" initial={{ opacity: 0, scale: 0.95 }} animate={{ opacity: 1, scale: 1 }}>
// // //             <div
// // //   className={`photo-stage ${photo ? 'has-photo' : 'no-photo'}`}
// // //   style={{
// // //     width: previewWidth,
// // //     height: previewHeight
// // //   }}

// // //   onClick={() => {
// // //     if (!photo) {
// // //       fileInputRef.current?.click();
// // //     }
// // //   }}

// // //   onPointerDown={handlePointerDown}
// // //   onPointerMove={handlePointerMove}
// // //   onPointerUp={handlePointerUp}
// // //   onPointerCancel={handlePointerUp}
// // // >

// // //   {/* -----------------------------------------
// // //       USER PHOTO
// // //       This sits below the decorative frame.
// // //   ----------------------------------------- */}

// // //   <div
// // //     className="photo-circle"

// // //     style={{
// // //       width:
// // //         previewHole.r * 2,

// // //       height:
// // //         previewHole.r * 2,

// // //       left:
// // //         previewHole.cx -
// // //         previewHole.r,

// // //       top:
// // //         previewHole.cy -
// // //         previewHole.r,

// // //       touchAction:
// // //         circleTouchAction
// // //     }}
// // //   >

// // //     {photo && previewPhotoRect ? (
// // //       <>
// // //         <img
// // //           className="photo-backdrop-img"
// // //           src={photo.src}
// // //           alt=""
// // //           aria-hidden="true"
// // //           draggable="false"
// // //         />

// // //         <img
// // //           className="photo-img"

// // //         src={photo.src}

// // //         alt="Your uploaded portrait"

// // //         draggable="false"

// // //         style={{
// // //           width:
// // //             previewPhotoRect.width,

// // //           height:
// // //             previewPhotoRect.height,

// // //           left:
// // //             previewPhotoRect.offsetXPx -
// // //             (
// // //               previewPhotoRect.width -
// // //               previewHole.r * 2
// // //             ) / 2,

// // //           top:
// // //             previewPhotoRect.offsetYPx -
// // //             (
// // //               previewPhotoRect.height -
// // //               previewHole.r * 2
// // //             ) / 2
// // //         }}
// // //         />
// // //       </>
// // //     ) : (
// // //       <div
// // //         className="upload-prompt"
// // //       >
// // //         <span className="upload-icon-circle">
// // //           <Icon.Upload
// // //             width="24"
// // //             height="34"
// // //           />
// // //         </span>

// // //         <strong>
// // //           Add Your Photo
// // //         </strong>

// // //         <small>
// // //           Click to upload
// // //         </small>
// // //       </div>
// // //     )}

// // //   </div>


// // //   {/* -----------------------------------------
// // //       DECORATIVE FRAME
// // //   ----------------------------------------- */}

// // //   <img
// // //     className="template-overlay-img"

// // //     src={
// // //       processedFrameSrc ||
// // //       template.src
// // //     }

// // //     alt="Royal avatar frame"

// // //     draggable="false"

// // //     style={{
// // //       opacity:
// // //         isProcessing
// // //           ? 0.75
// // //           : 1
// // //     }}
// // //   />


// // //   {/* -----------------------------------------
// // //       PROCESSING INDICATOR
// // //   ----------------------------------------- */}

// // //   {isProcessing && (
// // //     <div className="frame-processing">
// // //       <span className="processing-spinner" />

// // //       <span>
// // //         Applying colour…
// // //       </span>
// // //     </div>
// // //   )}


// // //   <input
// // //     type="file"
// // //     ref={fileInputRef}
// // //     onChange={handleImageUpload}
// // //     accept="image/png,image/jpeg,image/jpg,image/webp"
// // //     className="hidden-file-input"
// // //   />

// // // </div>
 
// // //           </motion.div>

// // //           <motion.div className="wardrobe-section" initial={{ opacity: 0, x: 20 }} animate={{ opacity: 1, x: 0 }}>
// // //             <form onSubmit={handleDownload}>
              
// // //               <div className="control-group">
// // //                 <label>1. Frame Color Theme</label>
// // //                 <div className="theme-picker">
// // //                   {FRAME_THEMES.map((theme) => (
// // //                     <button
// // //                       key={theme.name}
// // //                       type="button"
// // //                       className={`color-swatch ${activeTheme.name === theme.name ? 'active' : ''}`}
// // //                       style={{ backgroundColor: theme.hex }}
// // //                       onClick={() => setActiveTheme(theme)}
// // //                       title={theme.name}
// // //                     />
// // //                   ))}
// // //                 </div>
// // //               </div>

// // //               <div className="control-group">
// // //                 <label>2. Position Your Photo</label>
// // //                 {!photo ? (
// // //                   <button type="button" className="btn-outline photo-picker-btn" onClick={() => fileInputRef.current.click()}>
// // //                     <Icon.Upload width="18" height="18" /> Upload a Photo
// // //                   </button>
// // //                 ) : (
// // //                   <>
// // //                     <div className="photo-action-row">
// // //                       <button
// // //                         type="button"
// // //                         className="btn-outline photo-picker-btn"
// // //                         onClick={() => fileInputRef.current?.click()}
// // //                       >
// // //                         Replace Photo
// // //                       </button>

// // //                       <button
// // //                         type="button"
// // //                         className="btn-outline reset-photo-btn"
// // //                         onClick={() => resetCrop()}
// // //                       >
// // //                         Reset Fit
// // //                       </button>
// // //                     </div>

// // //                     <div className="zoom-control">
// // //                       <Icon.ZoomOut width="18" height="18" />
// // //                       <input type="range" min={MIN_ZOOM} max={MAX_ZOOM} step={0.01} value={zoom} onChange={(e) => handleZoomChange(parseFloat(e.target.value))} />
// // //                       <Icon.ZoomIn width="18" height="18" />
// // //                     </div>
// // //                     <p className="drag-hint">At the left end, the whole photo is visible. Zoom in only when needed, and drag to reposition.</p>
// // //                   </>
// // //                 )}
// // //               </div>

// // //               <AnimatePresence>
// // //                 {errorMessage && (
// // //                   <motion.div className="error-message" initial={{ opacity: 0, y: -10 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0 }}>
// // //                     {errorMessage}
// // //                   </motion.div>
// // //                 )}
// // //               </AnimatePresence>

// // //               <motion.button type="submit" className="btn-gold download-btn" disabled={isDownloading || isProcessing} whileHover={{ scale: 1.02 }} whileTap={{ scale: 0.98 }}>
// // //                 {isDownloading || isProcessing ? 'Processing Image...' : <><Icon.Download width="20" height="20" /> Download Royal Avatar</>}
// // //               </motion.button>
// // //             </form>
// // //           </motion.div>
// // //         </div>
// // //       </div>
// // //     </div>
// // //   );
// // // }




// // import React, { useState, useRef, useEffect, useCallback } from 'react';
// // import { motion, AnimatePresence } from 'framer-motion';
// // import { Link } from 'react-router-dom';
// // import Confetti from 'react-confetti';
// // import './AvatarCreator.css';
// // //MIN_ZOOM
// // const Icon = {
// //   Crest: (p) => (
// //     <svg viewBox="0 0 48 48" fill="none" stroke="currentColor" strokeWidth="1.3" {...p}>
// //       <path d="M24 6c-4 5-9 6-14 5 1 9 4 16 14 21 10-5 13-12 14-21-5 1-10 0-14-5Z" strokeLinejoin="round" />
// //       <path d="M18 22c2 2 4 3 6 3s4-1 6-3M24 25v8" strokeLinecap="round" />
// //     </svg>
// //   ),
// //   Upload: (p) => (
// //     <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" {...p}>
// //       <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4M17 8l-5-5-5 5M12 3v12" strokeLinecap="round" strokeLinejoin="round" />
// //     </svg>
// //   ),
// //   Download: (p) => (
// //     <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" {...p}>
// //       <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4M7 10l5 5 5-5M12 15V3" strokeLinecap="round" strokeLinejoin="round" />
// //     </svg>
// //   ),
// //   ZoomOut: (p) => (
// //     <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" {...p}>
// //       <circle cx="11" cy="11" r="7" /><path d="m21 21-4.35-4.35M8 11h6" strokeLinecap="round" />
// //     </svg>
// //   ),
// //   ZoomIn: (p) => (
// //     <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" {...p}>
// //       <circle cx="11" cy="11" r="7" /><path d="m21 21-4.35-4.35M11 8v6M8 11h6" strokeLinecap="round" />
// //     </svg>
// //   ),
// //   ArrowLeft: (p) => (
// //     <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" {...p}>
// //       <path d="M19 12H5M12 19l-7-7 7-7" strokeLinecap="round" strokeLinejoin="round" />
// //     </svg>
// //   ),
// //   RoyalVine: (p) => (
// //     <svg viewBox="0 0 160 160" fill="none" {...p}>
// //       <path d="M14 150 C10 110 28 70 66 46 C90 31 118 24 146 14" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" />
// //       <g fill="currentColor">
// //         <ellipse cx="34" cy="126" rx="11" ry="5" transform="rotate(-35 34 126)" opacity="0.75" />
// //         <ellipse cx="55" cy="98" rx="10" ry="4.5" transform="rotate(-20 55 98)" opacity="0.7" />
// //         <ellipse cx="78" cy="70" rx="10" ry="4.5" transform="rotate(5 78 70)" opacity="0.65" />
// //         <ellipse cx="103" cy="45" rx="9" ry="4" transform="rotate(25 103 45)" opacity="0.6" />
// //         <ellipse cx="128" cy="24" rx="8" ry="3.5" transform="rotate(45 128 24)" opacity="0.55" />
// //         <circle cx="146" cy="14" r="3" opacity="0.8" />
// //         <circle cx="14" cy="150" r="3" opacity="0.8" />
// //       </g>
// //     </svg>
// //   ),
// // };

// // const AmbientGlow = ({ secondaryHex }) => (
// //   <div style={{ position: 'fixed', inset: 0, overflow: 'hidden', pointerEvents: 'none', zIndex: 0 }}>
// //     <div style={{ position: 'absolute', top: '-10%', left: '-10%', width: '60vw', height: '60vw', background: 'radial-gradient(circle, rgba(198, 161, 91, 0.15) 0%, transparent 70%)', filter: 'blur(60px)' }} />
// //     <div style={{ position: 'absolute', bottom: '-20%', right: '-10%', width: '70vw', height: '70vw', background: `radial-gradient(circle, ${secondaryHex}40 0%, transparent 70%)`, filter: 'blur(60px)', transition: 'background 0.3s ease' }} />
// //     <div style={{ position: 'absolute', top: '30%', left: '50%', transform: 'translateX(-50%)', width: '50vw', height: '50vw', background: 'radial-gradient(circle, rgba(255, 215, 0, 0.08) 0%, transparent 70%)', filter: 'blur(40px)' }} />
// //   </div>
// // );

// // const TEMPLATES = [
// //   {
// //     id: 'royal-majesty',
// //     name: 'Royal Majesty',
// //     src: '/assets/photos/ChatGPT_Image_Sep_21_2026_03_11_16_PM.png',
// //     width: 1024,
// //     height: 1024,

// //     // ONLY the real inner portrait opening.
// //     // The old radius (0.32) was too large and cut into decorations.
// //     hole: {
// //       cx: 0.512,
// //       cy: 0.505,
// //       r: 0.207
// //     }
// //   }
// // ];

// // const FRAME_THEMES = [
//   { name: 'Royal Purple',   hex: '#A855F7' },
//   { name: 'Sapphire Blue',  hex: '#3B82F6' },
//   { name: 'Emerald Green',  hex: '#10B981' },
//   { name: 'Ruby Red',       hex: '#F43F5E' },
//   { name: 'Rose Pink',      hex: '#F472B6' },
// //   { name: 'Luxury Teal',    hex: '#14B8A6' },
// //   { name: 'Tangerine',      hex: '#FB923C' },
// //   { name: 'Royal Indigo',   hex: '#818CF8' },
// //   { name: 'Sunshine Gold',  hex: '#F6C945' },
// //   { name: 'Sky Blue',       hex: '#38BDF8' },
// //   { name: 'Royal Fuchsia',  hex: '#E879F9' },
// //   { name: 'Turquoise',      hex: '#2DD4BF' },
// //   { name: 'Berry Wine',     hex: '#D94675' },
// //   { name: 'Fresh Green',    hex: '#4ADE80' },
// //   { name: 'Coral',          hex: '#FB7185' },
// //   { name: 'Lavender',       hex: '#C084FC' }
// // ];
// // //processFrame
// // /* ── COLOR MATH UTILITIES ── */
// // function rgbToHsl(r, g, b) {
// //   r /= 255; g /= 255; b /= 255;
// //   const max = Math.max(r, g, b), min = Math.min(r, g, b);
// //   let h = 0, s = 0, l = (max + min) / 2;
// //   if (max !== min) {
// //     const d = max - min;
// //     s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
// //     switch (max) {
// //       case r: h = (g - b) / d + (g < b ? 6 : 0); break;
// //       case g: h = (b - r) / d + 2; break;
// //       case b: h = (r - g) / d + 4; break;
// //       default: break;
// //     }
// //     h /= 6;
// //   }
// //   return [h * 360, s, l];
// // }

// // function hslToRgb(h, s, l) {
// //   h /= 360;
// //   let r, g, b;
// //   if (s === 0) {
// //     r = g = b = l;
// //   } else {
// //     const hue2rgb = (p, q, t) => {
// //       if (t < 0) t += 1;
// //       if (t > 1) t -= 1;
// //       if (t < 1 / 6) return p + (q - p) * 6 * t;
// //       if (t < 1 / 2) return q;
// //       if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
// //       return p;
// //     };
// //     const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
// //     const p = 2 * l - q;
// //     r = hue2rgb(p, q, h + 1 / 3);
// //     g = hue2rgb(p, q, h);
// //     b = hue2rgb(p, q, h - 1 / 3);
// //   }
// //   return [r * 255, g * 255, b * 255];
// // }


// // function hexToHsl(hex) {
// //   const clean = hex.replace('#', '').trim();

// //   const normalized =
// //     clean.length === 3
// //       ? clean.split('').map((char) => char + char).join('')
// //       : clean;

// //   const r = parseInt(normalized.slice(0, 2), 16);
// //   const g = parseInt(normalized.slice(2, 4), 16);
// //   const b = parseInt(normalized.slice(4, 6), 16);

// //   return rgbToHsl(r, g, b);
// // }

// // function isGoldPixel(h, s, l) {
// //   return (
// //     h >= 15 &&
// //     h <= 75 &&
// //     s > 0.18 &&
// //     l > 0.10
// //   );
// // }

// // /*
// //   Only the original purple/violet/magenta design areas
// //   are themeable. Gold, cream, white and neutral areas
// //   stay untouched.
// // */
// // function isThemeSourcePixel(h, s, l) {
// //   if (s < 0.14) return false;
// //   if (l < 0.04 || l > 0.97) return false;

// //   return h >= 220 && h <= 355;
// // }

// // function createIdleScheduler(callback) {
// //   if (
// //     typeof window !== 'undefined' &&
// //     'requestIdleCallback' in window
// //   ) {
// //     const id = window.requestIdleCallback(
// //       callback,
// //       { timeout: 500 }
// //     );

// //     return () => {
// //       window.cancelIdleCallback?.(id);
// //     };
// //   }

// //   const id = window.setTimeout(callback, 80);

// //   return () => {
// //     window.clearTimeout(id);
// //   };
// // }

// // const MIN_ZOOM = 1;
// // const MAX_ZOOM = 4;
// // const EXPORT_SCALE = 1;

// // function clamp(value, min, max) {
// //   return Math.min(Math.max(value, min), max);
// // }

// // /*
// //  * Choose a sensible starting crop whenever a new image is uploaded
// //  * or the user presses "Reset Fit".
// //  *
// //  * zoom: 1 works with the contain-style foreground photo,
// //  * so the complete uploaded picture is visible initially.
// //  *
// //  * A small downward offset for tall portrait photos gives a more
// //  * natural starting composition without forcing extra zoom.
// //  */
// // function getSmartInitialCrop(naturalWidth, naturalHeight) {
// //   if (
// //     !naturalWidth ||
// //     !naturalHeight ||
// //     naturalWidth <= 0 ||
// //     naturalHeight <= 0
// //   ) {
// //     return {
// //       zoom: 1,
// //       offset: { x: 0, y: 0 }
// //     };
// //   }

// //   const aspect = naturalWidth / naturalHeight;

// //   // Tall / portrait image
// //   if (aspect < 0.85) {
// //     return {
// //       zoom: 1,
// //       offset: { x: 0, y: 0.06 }
// //     };
// //   }

// //   // Square or landscape image
// //   return {
// //     zoom: 1,
// //     offset: { x: 0, y: 0 }
// //   };
// // }

// // export default function AvatarCreator() {
// //   const template = TEMPLATES[0];
// //   const [activeTheme, setActiveTheme] = useState(FRAME_THEMES[0]);
  
// //   const [processedFrameSrc, setProcessedFrameSrc] = useState(null);
// //   const [isProcessing, setIsProcessing] = useState(true);

// //   const [photo, setPhoto] = useState(null);
// //   const [zoom, setZoom] = useState(1);
// //   const [offset, setOffset] = useState({ x: 0, y: 0 });

// //   const [isDownloading, setIsDownloading] = useState(false);
// //   const [showConfetti, setShowConfetti] = useState(false);
// //   const [errorMessage, setErrorMessage] = useState('');
// //   const [previewWidth, setPreviewWidth] = useState(420);

// //   const fileInputRef = useRef(null);
// //   const dragState = useRef(null);

// //   // Prepared frame + fast theme caches.
// //   const frameProcessorRef = useRef(null);
// //   const frameProcessorPromiseRef = useRef(null);
// //   const themeCacheRef = useRef(new Map());
// //   const themeInFlightRef = useRef(new Map());
// //   const themeRequestIdRef = useRef(0);

// //   useEffect(() => {
// //     window.scrollTo(0, 0);
// //   }, []);

// //   useEffect(() => {
// //     const computeWidth = () => {
// //       const available = Math.min(window.innerWidth * 0.9, 460);
// //       setPreviewWidth(Math.max(260, available));
// //     };
// //     computeWidth();
// //     window.addEventListener('resize', computeWidth);
// //     return () => window.removeEventListener('resize', computeWidth);
// //   }, []);

// //   const previewHeight =
// //     previewWidth * (template.height / template.width);

// //   const previewHole = {
// //     cx: template.hole.cx * previewWidth,
// //     cy: template.hole.cy * previewHeight,
// //     r: template.hole.r * previewWidth
// //   };

// //   //     const img = new Image();
// //   //     img.crossOrigin = "anonymous";
// //   //     img.onload = () => {
// //   //       const canvas = document.createElement('canvas');
// //   //       canvas.width = img.width;
// //   //       canvas.height = img.height;
// //   //       const ctx = canvas.getContext('2d', { willReadFrequently: true });
// //   //       ctx.drawImage(img, 0, 0);

// //   //       const imgData = ctx.getImageData(0, 0, canvas.width, canvas.height);
// //   //       const data = imgData.data;

// //   //       const cx = template.hole.cx * canvas.width;
// //   //       const cy = template.hole.cy * canvas.height;
// //   //       const rSq = (template.hole.r * canvas.width) ** 2;

// //   //       for (let i = 0; i < data.length; i += 4) {
// //   //         const red = data[i], green = data[i+1], blue = data[i+2], a = data[i+3];
// //   //         if (a === 0) continue;
          
// //   //         let [h, s, l] = rgbToHsl(red, green, blue);

// //   //         const px = (i / 4) % canvas.width;
// //   //         const py = Math.floor((i / 4) / canvas.width);
// //   //         const distSq = (px - cx) ** 2 + (py - cy) ** 2;

// //   //         // 1. CLEAR THE CIRCLE: Make the white center transparent, but protect the Gold Text
// //   //         if (distSq < rSq) {
// //   //           // White pixels have high lightness and low saturation
// //   //           if (l > 0.80 && s < 0.3) {
// //   //             data[i + 3] = 0; 
// //   //             continue;
// //   //           }
// //   //         }

// //   //         // 2. SHIFT THE THEME: Shift the purples/pinks, but strictly avoid Gold hues (20 to 70)
// //   //         const isGold = (h > 15 && h < 75) && s > 0.25;
// //   //         const isWhiteOrBlack = l > 0.9 || l < 0.1;

// //   //         if (shift !== 0 && !isGold && !isWhiteOrBlack) {
// //   //           let newH = (h + shift + 360) % 360;
// //   //           const [nR, nG, nB] = hslToRgb(newH, s, l);
// //   //           data[i] = nR;
// //   //           data[i+1] = nG;
// //   //           data[i+2] = nB;
// //   //         }
// //   //       }

// //   //       ctx.putImageData(imgData, 0, 0);
// //   //       resolve(canvas.toDataURL('image/png'));
// //   //     };
// //   //     img.src = template.src;
// //   //   });
// //   // }, [template]);

// //   /*
// //    * ==========================================================
// //    * FAST FRAME PROCESSOR
// //    * ==========================================================
// //    *
// //    * The expensive source-frame analysis runs once.
// //    * Theme changes then recolor only known theme pixels.
// //    */
// //   const initialiseFrameProcessor = useCallback(() => {
// //     if (frameProcessorRef.current) {
// //       return Promise.resolve(frameProcessorRef.current);
// //     }

// //     if (frameProcessorPromiseRef.current) {
// //       return frameProcessorPromiseRef.current;
// //     }

// //     frameProcessorPromiseRef.current =
// //       new Promise((resolve, reject) => {
// //         const img = new Image();
// //         img.crossOrigin = 'anonymous';

// //         img.onload = () => {
// //           try {
// //             const width =
// //               img.naturalWidth || img.width;

// //             const height =
// //               img.naturalHeight || img.height;

// //             const canvas =
// //               document.createElement('canvas');

// //             canvas.width = width;
// //             canvas.height = height;

// //             const ctx = canvas.getContext(
// //               '2d',
// //               { willReadFrequently: true }
// //             );

// //             if (!ctx) {
// //               reject(
// //                 new Error(
// //                   'Could not create frame canvas.'
// //                 )
// //               );
// //               return;
// //             }

// //             ctx.drawImage(
// //               img,
// //               0,
// //               0,
// //               width,
// //               height
// //             );

// //             const imageData =
// //               ctx.getImageData(
// //                 0,
// //                 0,
// //                 width,
// //                 height
// //               );

// //             const pixels =
// //               new Uint8ClampedArray(
// //                 imageData.data
// //               );

// //             const themeOffsets = [];
// //             const themeLightness = [];

// //             /*
// //               Exact INNER portrait opening.

// //               This is the key fix for the unwanted
// //               opening beside the upper-right flowers.
// //             */
// //             const cx =
// //               template.hole.cx * width;

// //             const cy =
// //               template.hole.cy * height;

// //             const radius =
// //               template.hole.r * width;

// //             const radiusSq =
// //               radius * radius;

// //             const feather =
// //               Math.max(
// //                 1.5,
// //                 width * 0.0015
// //               );

// //             for (
// //               let i = 0;
// //               i < pixels.length;
// //               i += 4
// //             ) {
// //               const alpha =
// //                 pixels[i + 3];

// //               if (alpha === 0) continue;

// //               const red = pixels[i];
// //               const green = pixels[i + 1];
// //               const blue = pixels[i + 2];

// //               const [h, s, l] =
// //                 rgbToHsl(
// //                   red,
// //                   green,
// //                   blue
// //                 );

// //               const pixelIndex =
// //                 i / 4;

// //               const px =
// //                 pixelIndex % width;

// //               const py =
// //                 Math.floor(
// //                   pixelIndex / width
// //                 );

// //               const dx = px - cx;
// //               const dy = py - cy;

// //               const distSq =
// //                 dx * dx +
// //                 dy * dy;

// //               const isGold =
// //                 isGoldPixel(h, s, l);

// //               /*
// //                 Keep lower dark typography/shadow
// //                 that intentionally overlaps the photo.
// //               */
// //               const isLowerTextShadow =
// //                 py >
// //                   cy +
// //                     radius * 0.30 &&
// //                 l < 0.34 &&
// //                 s > 0.08;

// //               /*
// //                 OPEN ONLY THE TRUE CENTER.

// //                 Nothing outside this exact small circle
// //                 can become transparent.
// //               */
// //               if (
// //                 distSq < radiusSq &&
// //                 !isGold &&
// //                 !isLowerTextShadow
// //               ) {
// //                 const distance =
// //                   Math.sqrt(distSq);

// //                 if (
// //                   distance <=
// //                   radius - feather
// //                 ) {
// //                   pixels[i + 3] = 0;
// //                 } else {
// //                   const edge =
// //                     (
// //                       distance -
// //                       (radius - feather)
// //                     ) /
// //                     feather;

// //                   pixels[i + 3] =
// //                     Math.round(
// //                       alpha *
// //                         clamp(
// //                           edge,
// //                           0,
// //                           1
// //                         )
// //                     );
// //                 }

// //                 continue;
// //               }

// //               /*
// //                 Save editable pixels ONCE.
// //               */
// //               if (
// //                 !isGold &&
// //                 isThemeSourcePixel(
// //                   h,
// //                   s,
// //                   l
// //                 )
// //               ) {
// //                 themeOffsets.push(i);

// //                 themeLightness.push(
// //                   Math.round(
// //                     clamp(
// //                       l,
// //                       0,
// //                       1
// //                     ) * 255
// //                   )
// //                 );
// //               }
// //             }

// //             const processor = {
// //               width,
// //               height,
// //               basePixels: pixels,
// //               themeOffsets:
// //                 Uint32Array.from(
// //                   themeOffsets
// //                 ),
// //               themeLightness:
// //                 Uint8Array.from(
// //                   themeLightness
// //                 )
// //             };

// //             frameProcessorRef.current =
// //               processor;

// //             resolve(processor);
// //           } catch (error) {
// //             reject(error);
// //           }
// //         };

// //         img.onerror = () => {
// //           reject(
// //             new Error(
// //               `Unable to load frame: ${template.src}`
// //             )
// //           );
// //         };

// //         img.src = template.src;
// //       });

// //     return frameProcessorPromiseRef.current;
// //   }, [template]);


// //   /*
// //    * Render a selected color.
// //    *
// //    * The selected HEX controls the exact HUE.
// //    * Only highlights/shadows vary in lightness.
// //    */
// //   const renderThemeFrame =
// //     useCallback(
// //       async (theme) => {
// //         const cacheKey =
// //           theme.hex.toUpperCase();

// //         const cached =
// //           themeCacheRef.current.get(
// //             cacheKey
// //           );

// //         if (cached) {
// //           return cached;
// //         }

// //         const existing =
// //           themeInFlightRef.current.get(
// //             cacheKey
// //           );

// //         if (existing) {
// //           return existing;
// //         }

// //         const renderPromise =
// //           (async () => {
// //             const processor =
// //               await initialiseFrameProcessor();

// //             const pixels =
// //               new Uint8ClampedArray(
// //                 processor.basePixels
// //               );

// //             const [
// //               targetHue,
// //               targetSaturation,
// //               targetLightness
// //             ] =
// //               hexToHsl(theme.hex);

// //             /*
// //               256-entry LUT makes recoloring
// //               much faster than HSL conversion
// //               for every pixel.
// //             */
// //             const rgbLookup =
// //               new Uint8ClampedArray(
// //                 256 * 3
// //               );

// //             for (
// //               let lightByte = 0;
// //               lightByte < 256;
// //               lightByte += 1
// //             ) {
// //               const sourceL =
// //                 lightByte / 255;

// //               /*
// //                 Bright/vivid output while keeping
// //                 realistic fabric and flower shading.
// //               */
// //               const saturation =
// //                 clamp(
// //                   Math.max(
// //                     targetSaturation,
// //                     0.72
// //                   ),
// //                   0,
// //                   1
// //                 );

// //               const lightness =
// //                 clamp(
// //                   sourceL * 0.68 +
// //                     targetLightness *
// //                       0.22 +
// //                     0.10,
// //                   0.16,
// //                   0.94
// //                 );

// //               const [r, g, b] =
// //                 hslToRgb(
// //                   targetHue,
// //                   saturation,
// //                   lightness
// //                 );

// //               const lutIndex =
// //                 lightByte * 3;

// //               rgbLookup[lutIndex] =
// //                 Math.round(r);

// //               rgbLookup[
// //                 lutIndex + 1
// //               ] =
// //                 Math.round(g);

// //               rgbLookup[
// //                 lutIndex + 2
// //               ] =
// //                 Math.round(b);
// //             }

// //             const offsets =
// //               processor.themeOffsets;

// //             const lightnessValues =
// //               processor.themeLightness;

// //             for (
// //               let index = 0;
// //               index < offsets.length;
// //               index += 1
// //             ) {
// //               const pixelOffset =
// //                 offsets[index];

// //               const lutIndex =
// //                 lightnessValues[
// //                   index
// //                 ] * 3;

// //               pixels[pixelOffset] =
// //                 rgbLookup[lutIndex];

// //               pixels[
// //                 pixelOffset + 1
// //               ] =
// //                 rgbLookup[
// //                   lutIndex + 1
// //                 ];

// //               pixels[
// //                 pixelOffset + 2
// //               ] =
// //                 rgbLookup[
// //                   lutIndex + 2
// //                 ];
// //             }

// //             const canvas =
// //               document.createElement(
// //                 'canvas'
// //               );

// //             canvas.width =
// //               processor.width;

// //             canvas.height =
// //               processor.height;

// //             const ctx =
// //               canvas.getContext('2d');

// //             if (!ctx) {
// //               throw new Error(
// //                 'Could not create theme canvas.'
// //               );
// //             }

// //             const outputData =
// //               ctx.createImageData(
// //                 processor.width,
// //                 processor.height
// //               );

// //             outputData.data.set(
// //               pixels
// //             );

// //             ctx.putImageData(
// //               outputData,
// //               0,
// //               0
// //             );

// //             /*
// //               Fast preview format with alpha.
// //               Falls back to PNG automatically.
// //             */
// //             const blob =
// //               await new Promise(
// //                 (resolve) => {
// //                   canvas.toBlob(
// //                     (webpBlob) => {
// //                       if (webpBlob) {
// //                         resolve(
// //                           webpBlob
// //                         );
// //                         return;
// //                       }

// //                       canvas.toBlob(
// //                         resolve,
// //                         'image/png'
// //                       );
// //                     },
// //                     'image/webp',
// //                     0.96
// //                   );
// //                 }
// //               );

// //             if (!blob) {
// //               throw new Error(
// //                 'Could not create theme preview.'
// //               );
// //             }

// //             const objectUrl =
// //               URL.createObjectURL(blob);

// //             themeCacheRef.current.set(
// //               cacheKey,
// //               objectUrl
// //             );

// //             return objectUrl;
// //           })();

// //         themeInFlightRef.current.set(
// //           cacheKey,
// //           renderPromise
// //         );

// //         try {
// //           return await renderPromise;
// //         } finally {
// //           themeInFlightRef.current.delete(
// //             cacheKey
// //           );
// //         }
// //       },
// //       [initialiseFrameProcessor]
// //     );


// //   /*
// //    * Apply selected theme.
// //    * Cached selections appear virtually instantly.
// //    */
// //   useEffect(() => {
// //     let cancelled = false;

// //     const requestId =
// //       ++themeRequestIdRef.current;

// //     const applyTheme = async () => {
// //       const cacheKey =
// //         activeTheme.hex.toUpperCase();

// //       const cached =
// //         themeCacheRef.current.get(
// //           cacheKey
// //         );

// //       if (cached) {
// //         setProcessedFrameSrc(
// //           cached
// //         );

// //         setIsProcessing(false);
// //         return;
// //       }

// //       setIsProcessing(true);
// //       setErrorMessage('');

// //       try {
// //         const themedFrame =
// //           await renderThemeFrame(
// //             activeTheme
// //           );

// //         if (
// //           !cancelled &&
// //           requestId ===
// //             themeRequestIdRef.current
// //         ) {
// //           setProcessedFrameSrc(
// //             themedFrame
// //           );
// //         }
// //       } catch (error) {
// //         console.error(error);

// //         if (!cancelled) {
// //           setErrorMessage(
// //             'Unable to prepare this frame colour.'
// //           );
// //         }
// //       } finally {
// //         if (
// //           !cancelled &&
// //           requestId ===
// //             themeRequestIdRef.current
// //         ) {
// //           setIsProcessing(false);
// //         }
// //       }
// //     };

// //     applyTheme();

// //     return () => {
// //       cancelled = true;
// //     };
// //   }, [
// //     activeTheme,
// //     renderThemeFrame
// //   ]);


// //   /*
// //    * Pre-cache all remaining colors during idle time.
// //    * After warm-up, switching is instant.
// //    */
// //   useEffect(() => {
// //     let cancelled = false;
// //     let cancelScheduled = null;
// //     let index = 0;

// //     const warmNext = async () => {
// //       if (cancelled) return;

// //       while (
// //         index <
// //           FRAME_THEMES.length &&
// //         themeCacheRef.current.has(
// //           FRAME_THEMES[
// //             index
// //           ].hex.toUpperCase()
// //         )
// //       ) {
// //         index += 1;
// //       }

// //       if (
// //         index >=
// //         FRAME_THEMES.length
// //       ) {
// //         return;
// //       }

// //       const theme =
// //         FRAME_THEMES[index];

// //       index += 1;

// //       try {
// //         await renderThemeFrame(
// //           theme
// //         );
// //       } catch {
// //         // Background warm-up is optional.
// //       }

// //       if (!cancelled) {
// //         cancelScheduled =
// //           createIdleScheduler(
// //             warmNext
// //           );
// //       }
// //     };

// //     cancelScheduled =
// //       createIdleScheduler(
// //         warmNext
// //       );

// //     return () => {
// //       cancelled = true;
// //       cancelScheduled?.();
// //     };
// //   }, [renderThemeFrame]);


// //   /*
// //    * Clean up cached blob URLs.
// //    */
// //   useEffect(() => {
// //     return () => {
// //       themeCacheRef.current.forEach(
// //         (url) => {
// //           URL.revokeObjectURL(url);
// //         }
// //       );

// //       themeCacheRef.current.clear();
// //       themeInFlightRef.current.clear();
// //     };
// //   }, []);




// //   /*
// //    * The foreground portrait uses CONTAIN at zoom 1.
// //    * That means the whole uploaded photo is visible instead of looking
// //    * excessively zoomed. A blurred COVER copy sits behind it, so the
// //    * circular opening is always visually filled and no rectangular gaps
// //    * are exposed.
// //    */
// //   const clampOffset = useCallback((candidate) => {
// //     return {
// //       x: clamp(candidate.x, -1, 1),
// //       y: clamp(candidate.y, -1, 1)
// //     };
// //   }, []);

// //   const handleZoomChange = (nextZoom) => {
// //     const safeZoom = clamp(nextZoom, MIN_ZOOM, MAX_ZOOM);
// //     setZoom(safeZoom);
// //     setOffset((prev) => clampOffset(prev));
// //   };

// //   const resetCrop = useCallback((targetPhoto = photo) => {
// //     if (!targetPhoto) {
// //       setZoom(1);
// //       setOffset({ x: 0, y: 0 });
// //       return;
// //     }

// //     const initial = getSmartInitialCrop(
// //       targetPhoto.naturalWidth,
// //       targetPhoto.naturalHeight
// //     );

// //     setZoom(initial.zoom);
// //     setOffset(initial.offset);
// //   }, [photo]);

// //   const handleImageUpload = (e) => {
// //     const file = e.target.files?.[0];

// //     if (!file) return;

// //     setErrorMessage('');

// //     if (!file.type.startsWith('image/')) {
// //       setErrorMessage('Please select a valid image file.');
// //       e.target.value = '';
// //       return;
// //     }

// //     const MAX_FILE_SIZE = 15 * 1024 * 1024;

// //     if (file.size > MAX_FILE_SIZE) {
// //       setErrorMessage(
// //         'Your image is too large. Please choose an image smaller than 15MB.'
// //       );
// //       e.target.value = '';
// //       return;
// //     }

// //     const reader = new FileReader();

// //     reader.onload = (event) => {
// //       const imageSource = event.target?.result;
// //       if (!imageSource) return;

// //       const img = new Image();

// //       img.onload = () => {
// //         const nextPhoto = {
// //           src: imageSource,
// //           naturalWidth: img.naturalWidth,
// //           naturalHeight: img.naturalHeight
// //         };

// //         setPhoto(nextPhoto);

// //         const initial = getSmartInitialCrop(
// //           img.naturalWidth,
// //           img.naturalHeight
// //         );

// //         setZoom(initial.zoom);
// //         setOffset(initial.offset);
// //       };

// //       img.onerror = () => {
// //         setErrorMessage(
// //           'We could not read this image. Please select another photo.'
// //         );
// //       };

// //       img.src = imageSource;
// //     };

// //     reader.onerror = () => {
// //       setErrorMessage('We could not open this file.');
// //     };

// //     reader.readAsDataURL(file);

// //     // Allows choosing the same file again.
// //     e.target.value = '';
// //   };

// //   const handlePointerDown = (e) => {
// //     if (!photo) return;

// //     e.currentTarget.setPointerCapture?.(e.pointerId);

// //     dragState.current = {
// //       startX: e.clientX,
// //       startY: e.clientY,
// //       startOffset: { ...offset }
// //     };
// //   };

// //   const handlePointerMove = (e) => {
// //     if (!dragState.current || !photo) return;

// //     const radius = Math.max(previewHole.r, 1);

// //     const deltaX = e.clientX - dragState.current.startX;
// //     const deltaY = e.clientY - dragState.current.startY;

// //     const candidate = {
// //       x: dragState.current.startOffset.x + deltaX / radius,
// //       y: dragState.current.startOffset.y + deltaY / radius
// //     };

// //     setOffset(clampOffset(candidate));
// //   };

// //   const handlePointerUp = (e) => {
// //     if (
// //       e.currentTarget.hasPointerCapture &&
// //       e.currentTarget.hasPointerCapture(e.pointerId)
// //     ) {
// //       e.currentTarget.releasePointerCapture(e.pointerId);
// //     }

// //     dragState.current = null;
// //   };

// //   /*
// //    * Foreground portrait rectangle.
// //    *
// //    * zoom === 1  -> contain (whole image visible)
// //    * zoom > 1    -> user can zoom in
// //    *
// //    * Empty space that contain would normally create is hidden by the
// //    * blurred cover background layer.
// //    */
// //   function getPhotoRect(holeDiameterPx, customZoom = zoom, customOffset = offset) {
// //     if (!photo) return null;

// //     const imageWidth = photo.naturalWidth;
// //     const imageHeight = photo.naturalHeight;

// //     const containScale = Math.min(
// //       holeDiameterPx / imageWidth,
// //       holeDiameterPx / imageHeight
// //     );

// //     const finalScale =
// //       containScale * clamp(customZoom, MIN_ZOOM, MAX_ZOOM);

// //     const width = imageWidth * finalScale;
// //     const height = imageHeight * finalScale;

// //     const maxShift = holeDiameterPx * 0.46;

// //     const offsetXPx = clamp(
// //       customOffset.x * (holeDiameterPx / 2),
// //       -maxShift,
// //       maxShift
// //     );

// //     const offsetYPx = clamp(
// //       customOffset.y * (holeDiameterPx / 2),
// //       -maxShift,
// //       maxShift
// //     );

// //     return {
// //       width,
// //       height,
// //       offsetXPx,
// //       offsetYPx
// //     };
// //   }

// //   const previewPhotoRect = photo ? getPhotoRect(previewHole.r * 2) : null;

// //   const handleDownload = async (e) => {
// //     e.preventDefault();
// //     if (!photo) {
// //       setErrorMessage('Please upload a photo to create your avatar.');
// //       setTimeout(() => setErrorMessage(''), 4000);
// //       return;
// //     }

// //     setIsDownloading(true);
// //     try {
// //       const exportWidth = template.width * EXPORT_SCALE;
// //       const exportHeight = template.height * EXPORT_SCALE;
// //       const holeCxPx = template.hole.cx * exportWidth;
// //       const holeCyPx = template.hole.cy * exportHeight;
// //       const holeRPx = template.hole.r * exportWidth;

// //       const canvas = document.createElement('canvas');
// //       canvas.width = exportWidth;
// //       canvas.height = exportHeight;
// //       const ctx = canvas.getContext('2d');

// //       const photoImg = new Image();
// //       photoImg.src = photo.src;

// //       await new Promise((resolve, reject) => {
// //         photoImg.onload = resolve;
// //         photoImg.onerror = reject;
// //       });

// //       const holeDiameter = holeRPx * 2;

// //       // ---------------------------------------------------------
// //       // 1. BLURRED COVER BACKGROUND
// //       // Always fills the circle so the user can zoom out safely.
// //       // ---------------------------------------------------------
// //       const coverScale = Math.max(
// //         holeDiameter / photo.naturalWidth,
// //         holeDiameter / photo.naturalHeight
// //       );

// //       const coverWidth = photo.naturalWidth * coverScale;
// //       const coverHeight = photo.naturalHeight * coverScale;

// //       ctx.save();
// //       ctx.beginPath();
// //       ctx.arc(holeCxPx, holeCyPx, holeRPx, 0, Math.PI * 2);
// //       ctx.clip();

// //       ctx.filter = `blur(${Math.max(12, exportWidth * 0.014)}px)`;
// //       ctx.globalAlpha = 0.82;

// //       const blurOverscan = 1.12;

// //       ctx.drawImage(
// //         photoImg,
// //         holeCxPx - (coverWidth * blurOverscan) / 2,
// //         holeCyPx - (coverHeight * blurOverscan) / 2,
// //         coverWidth * blurOverscan,
// //         coverHeight * blurOverscan
// //       );

// //       // Darken slightly so the foreground portrait stays clear.
// //       ctx.filter = 'none';
// //       ctx.globalAlpha = 0.14;
// //       ctx.fillStyle = '#0b080d';
// //       ctx.fillRect(
// //         holeCxPx - holeRPx,
// //         holeCyPx - holeRPx,
// //         holeDiameter,
// //         holeDiameter
// //       );

// //       ctx.restore();

// //       // ---------------------------------------------------------
// //       // 2. FOREGROUND PHOTO
// //       // At zoom 1, the WHOLE image fits inside the circle.
// //       // ---------------------------------------------------------
// //       const {
// //         width,
// //         height,
// //         offsetXPx,
// //         offsetYPx
// //       } = getPhotoRect(holeDiameter);

// //       ctx.save();
// //       ctx.beginPath();
// //       ctx.arc(holeCxPx, holeCyPx, holeRPx, 0, Math.PI * 2);
// //       ctx.clip();

// //       ctx.drawImage(
// //         photoImg,
// //         holeCxPx - width / 2 + offsetXPx,
// //         holeCyPx - height / 2 + offsetYPx,
// //         width,
// //         height
// //       );

// //       ctx.restore();

// //       // 2. Draw Processed Frame ON TOP (The gold text overlaps the photo perfectly!)
// //       const frameImg = new Image();
// //       frameImg.src = processedFrameSrc || template.src;
// //       await new Promise((resolve, reject) => {
// //         frameImg.onload = resolve;
// //         frameImg.onerror = reject;
// //       });
// //       ctx.drawImage(frameImg, 0, 0, exportWidth, exportHeight);

// //       const dataUrl = canvas.toDataURL('image/png');
// //       const link = document.createElement('a');
// //       link.download = `Royal_Avatar_${activeTheme.name.replace(/\s+/g, '_')}.png`;
// //       link.href = dataUrl;
// //       link.click();

// //       setShowConfetti(true);
// //       setTimeout(() => setShowConfetti(false), 6000);
// //     } catch (err) {
// //       console.error(err);
// //       setErrorMessage('Something went wrong generating your avatar.');
// //     } finally {
// //       setIsDownloading(false);
// //     }
// //   };

// //   const circleTouchAction = photo ? 'none' : 'auto';

// //   return (
// //     <div className="royal-avatar-page">
// //       <AmbientGlow secondaryHex={activeTheme.hex} />

// //       <div className="royal-nav">
// //         <Link to="/" className="back-link">
// //           <Icon.ArrowLeft width="16" height="16" /> Back to Home
// //         </Link>
// //       </div>

// //       {showConfetti && (
// //         <div className="fixed-confetti-wrapper">
// //           <Confetti width={window.innerWidth} height={window.innerHeight} numberOfPieces={400} gravity={0.3} colors={['#C6A15B', '#F4E8C9', activeTheme.hex, '#FFFFFF']} recycle={false} />
// //         </div>
// //       )}

// //       <div className="avatar-container">
// //         <Icon.RoyalVine className="royal-vine royal-vine-tl" />
// //         <Icon.RoyalVine className="royal-vine royal-vine-tr" />

// //         <motion.div className="avatar-header" initial={{ opacity: 0, y: -20 }} animate={{ opacity: 1, y: 0 }}>
// //           <Icon.Crest className="header-crest" style={{ color: 'var(--gold, #c6a15b)', width: '48px', marginBottom: '16px' }} />
// //           <span className="eyebrow">The Royal Studio</span>
// //           <h1>Create Your Avatar</h1>
// //           <p>Drop in your photo, adjust the theme color, and download your souvenir.</p>
// //         </motion.div>

// //         <div className="studio-layout">
          
// //           <motion.div className="mirror-section" initial={{ opacity: 0, scale: 0.95 }} animate={{ opacity: 1, scale: 1 }}>
// //             <div
// //   className={`photo-stage ${photo ? 'has-photo' : 'no-photo'}`}
// //   style={{
// //     width: previewWidth,
// //     height: previewHeight
// //   }}

// //   onClick={() => {
// //     if (!photo) {
// //       fileInputRef.current?.click();
// //     }
// //   }}

// //   onPointerDown={handlePointerDown}
// //   onPointerMove={handlePointerMove}
// //   onPointerUp={handlePointerUp}
// //   onPointerCancel={handlePointerUp}
// // >

// //   {/* -----------------------------------------
// //       USER PHOTO
// //       This sits below the decorative frame.
// //   ----------------------------------------- */}

// //   <div
// //     className="photo-circle"

// //     style={{
// //       width:
// //         previewHole.r * 2,

// //       height:
// //         previewHole.r * 2,

// //       left:
// //         previewHole.cx -
// //         previewHole.r,

// //       top:
// //         previewHole.cy -
// //         previewHole.r,

// //       touchAction:
// //         circleTouchAction
// //     }}
// //   >

// //     {photo && previewPhotoRect ? (
// //       <>
// //         <img
// //           className="photo-backdrop-img"
// //           src={photo.src}
// //           alt=""
// //           aria-hidden="true"
// //           draggable="false"
// //         />

// //         <img
// //           className="photo-img"

// //         src={photo.src}

// //         alt="Your uploaded portrait"

// //         draggable="false"

// //         style={{
// //           width:
// //             previewPhotoRect.width,

// //           height:
// //             previewPhotoRect.height,

// //           left:
// //             previewPhotoRect.offsetXPx -
// //             (
// //               previewPhotoRect.width -
// //               previewHole.r * 2
// //             ) / 2,

// //           top:
// //             previewPhotoRect.offsetYPx -
// //             (
// //               previewPhotoRect.height -
// //               previewHole.r * 2
// //             ) / 2
// //         }}
// //         />
// //       </>
// //     ) : (
// //       <div
// //         className="upload-prompt"
// //       >
// //         <span className="upload-icon-circle">
// //           <Icon.Upload
// //             width="24"
// //             height="34"
// //           />
// //         </span>

// //         <strong>
// //           Add Your Photo
// //         </strong>

// //         <small>
// //           Click to upload
// //         </small>
// //       </div>
// //     )}

// //   </div>


// //   {/* -----------------------------------------
// //       DECORATIVE FRAME
// //   ----------------------------------------- */}

// //   <img
// //     className="template-overlay-img"

// //     src={
// //       processedFrameSrc ||
// //       template.src
// //     }

// //     alt="Royal avatar frame"

// //     draggable="false"

// //     style={{ opacity: 1 }}
// //   />


// //   {/* -----------------------------------------
// //       PROCESSING INDICATOR
// //   ----------------------------------------- */}

// //   {isProcessing && (
// //     <div className="frame-processing">
// //       <span className="processing-spinner" />

// //       <span>
// //         Updating theme…
// //       </span>
// //     </div>
// //   )}


// //   <input
// //     type="file"
// //     ref={fileInputRef}
// //     onChange={handleImageUpload}
// //     accept="image/png,image/jpeg,image/jpg,image/webp"
// //     className="hidden-file-input"
// //   />

// // </div>
 
// //           </motion.div>

// //           <motion.div className="wardrobe-section" initial={{ opacity: 0, x: 20 }} animate={{ opacity: 1, x: 0 }}>
// //             <form onSubmit={handleDownload}>
              
// //               <div className="control-group">
// //                 <label>1. Frame Color Theme</label>
// //                 <div className="theme-picker">
// //                   {FRAME_THEMES.map((theme) => (
// //                     <button
// //                       key={theme.name}
// //                       type="button"
// //                       className={`color-swatch ${activeTheme.name === theme.name ? 'active' : ''}`}
// //                       style={{
// //                         backgroundColor: theme.hex,
// //                         '--swatch-color': theme.hex
// //                       }}
// //                       onClick={() => setActiveTheme(theme)}
// //                       title={theme.name}
// //                       aria-label={`Use ${theme.name} theme`}
// //                       aria-pressed={activeTheme.name === theme.name}
// //                     />
// //                   ))}
// //                 </div>
// //               </div>

// //               <div className="control-group">
// //                 <label>2. Position Your Photo</label>
// //                 {!photo ? (
// //                   <button type="button" className="btn-outline photo-picker-btn" onClick={() => fileInputRef.current.click()}>
// //                     <Icon.Upload width="18" height="18" /> Upload a Photo
// //                   </button>
// //                 ) : (
// //                   <>
// //                     <div className="photo-action-row">
// //                       <button
// //                         type="button"
// //                         className="btn-outline photo-picker-btn"
// //                         onClick={() => fileInputRef.current?.click()}
// //                       >
// //                         Replace Photo
// //                       </button>

// //                       <button
// //                         type="button"
// //                         className="btn-outline reset-photo-btn"
// //                         onClick={() => resetCrop()}
// //                       >
// //                         Reset Fit
// //                       </button>
// //                     </div>

// //                     <div className="zoom-control">
// //                       <Icon.ZoomOut width="18" height="18" />
// //                       <input type="range" min={MIN_ZOOM} max={MAX_ZOOM} step={0.01} value={zoom} onChange={(e) => handleZoomChange(parseFloat(e.target.value))} />
// //                       <Icon.ZoomIn width="18" height="18" />
// //                     </div>
// //                     <p className="drag-hint">At the left end, the whole photo is visible. Zoom in only when needed, and drag to reposition.</p>
// //                   </>
// //                 )}
// //               </div>

// //               <AnimatePresence>
// //                 {errorMessage && (
// //                   <motion.div className="error-message" initial={{ opacity: 0, y: -10 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0 }}>
// //                     {errorMessage}
// //                   </motion.div>
// //                 )}
// //               </AnimatePresence>

// //               <motion.button type="submit" className="btn-gold download-btn" disabled={isDownloading || isProcessing} whileHover={{ scale: 1.02 }} whileTap={{ scale: 0.98 }}>
// //                 {isDownloading || isProcessing ? 'Processing Image...' : <><Icon.Download width="20" height="20" /> Download Royal Avatar</>}
// //               </motion.button>
// //             </form>
// //           </motion.div>
// //         </div>
// //       </div>
// //     </div>
// //   );
// // }





// import React, { useState, useRef, useEffect, useCallback } from 'react';
// import { motion, AnimatePresence } from 'framer-motion';
// import { Link } from 'react-router-dom';
// import Confetti from 'react-confetti';
// import './AvatarCreator.css';
// //MIN_ZOOM
// const Icon = {
//   Crest: (p) => (
//     <svg viewBox="0 0 48 48" fill="none" stroke="currentColor" strokeWidth="1.3" {...p}>
//       <path d="M24 6c-4 5-9 6-14 5 1 9 4 16 14 21 10-5 13-12 14-21-5 1-10 0-14-5Z" strokeLinejoin="round" />
//       <path d="M18 22c2 2 4 3 6 3s4-1 6-3M24 25v8" strokeLinecap="round" />
//     </svg>
//   ),
//   Upload: (p) => (
//     <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" {...p}>
//       <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4M17 8l-5-5-5 5M12 3v12" strokeLinecap="round" strokeLinejoin="round" />
//     </svg>
//   ),
//   Download: (p) => (
//     <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" {...p}>
//       <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4M7 10l5 5 5-5M12 15V3" strokeLinecap="round" strokeLinejoin="round" />
//     </svg>
//   ),
//   ZoomOut: (p) => (
//     <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" {...p}>
//       <circle cx="11" cy="11" r="7" /><path d="m21 21-4.35-4.35M8 11h6" strokeLinecap="round" />
//     </svg>
//   ),
//   ZoomIn: (p) => (
//     <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" {...p}>
//       <circle cx="11" cy="11" r="7" /><path d="m21 21-4.35-4.35M11 8v6M8 11h6" strokeLinecap="round" />
//     </svg>
//   ),
//   ArrowLeft: (p) => (
//     <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" {...p}>
//       <path d="M19 12H5M12 19l-7-7 7-7" strokeLinecap="round" strokeLinejoin="round" />
//     </svg>
//   ),
//   RoyalVine: (p) => (
//     <svg viewBox="0 0 160 160" fill="none" {...p}>
//       <path d="M14 150 C10 110 28 70 66 46 C90 31 118 24 146 14" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" />
//       <g fill="currentColor">
//         <ellipse cx="34" cy="126" rx="11" ry="5" transform="rotate(-35 34 126)" opacity="0.75" />
//         <ellipse cx="55" cy="98" rx="10" ry="4.5" transform="rotate(-20 55 98)" opacity="0.7" />
//         <ellipse cx="78" cy="70" rx="10" ry="4.5" transform="rotate(5 78 70)" opacity="0.65" />
//         <ellipse cx="103" cy="45" rx="9" ry="4" transform="rotate(25 103 45)" opacity="0.6" />
//         <ellipse cx="128" cy="24" rx="8" ry="3.5" transform="rotate(45 128 24)" opacity="0.55" />
//         <circle cx="146" cy="14" r="3" opacity="0.8" />
//         <circle cx="14" cy="150" r="3" opacity="0.8" />
//       </g>
//     </svg>
//   ),
// };

// const AmbientGlow = ({ secondaryHex }) => (
//   <div style={{ position: 'fixed', inset: 0, overflow: 'hidden', pointerEvents: 'none', zIndex: 0 }}>
//     <div style={{ position: 'absolute', top: '-10%', left: '-10%', width: '60vw', height: '60vw', background: 'radial-gradient(circle, rgba(198, 161, 91, 0.15) 0%, transparent 70%)', filter: 'blur(60px)' }} />
//     <div style={{ position: 'absolute', bottom: '-20%', right: '-10%', width: '70vw', height: '70vw', background: `radial-gradient(circle, ${secondaryHex}40 0%, transparent 70%)`, filter: 'blur(60px)', transition: 'background 0.3s ease' }} />
//     <div style={{ position: 'absolute', top: '30%', left: '50%', transform: 'translateX(-50%)', width: '50vw', height: '50vw', background: 'radial-gradient(circle, rgba(255, 215, 0, 0.08) 0%, transparent 70%)', filter: 'blur(40px)' }} />
//   </div>
// );

// const TEMPLATES = [
//   {
//     id: 'royal-majesty',
//     name: 'Royal Majesty',
//     src: '/assets/photos/ChatGPT_Image_Sep_21_2026_03_11_16_PM.png',
//     width: 1024,
//     height: 1024,

//     // ONLY the real inner portrait opening.
//     // The old radius (0.32) was too large and cut into decorations.
//     hole: {
//       cx: 0.512,
//       cy: 0.505,
//       r: 0.207
//     }
//   }
// ];
// //1. Frame Color Theme
// const FRAME_THEMES = [
  // { name: 'Royal Purple',   hex: '#A3A380' },
  // { name: 'Emerald Green',  hex: '#D8A48F' },
  // { name: 'Sapphire Blue',  hex: '#D6CF93' },
  // { name: 'Ruby Red',       hex: '#E3F1FB' },
  // { name: 'Rose Pink',      hex: '#809671' },
  // { name: 'Luxury Teal',    hex: '#EFEBCE' },
  // { name: 'Tangerine',      hex: '#F8F3EF' },
  // { name: 'Royal Indigo',   hex: '#e1d1a6' },
  // { name: 'Sunshine Gold',  hex: '#F7D6D0' },
  // { name: 'Sky Blue',       hex: '#E2B4BD' },
//   { name: 'Black',  hex: '#4A4A4A' },
//   { name: 'Turquoise',      hex: '#2DD4BF' },
//   { name: 'Berry Wine',     hex: '#D94675' },
//   { name: 'Fresh Green',    hex: '#4ADE80' },
//   { name: 'Coral',          hex: '#FB7185' },
//   { name: 'Lavender',       hex: '#C084FC' }
// ];
// //processFrame
// /* ── COLOR MATH UTILITIES ── */
// function rgbToHsl(r, g, b) {
//   r /= 255; g /= 255; b /= 255;
//   const max = Math.max(r, g, b), min = Math.min(r, g, b);
//   let h = 0, s = 0, l = (max + min) / 2;
//   if (max !== min) {
//     const d = max - min;
//     s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
//     switch (max) {
//       case r: h = (g - b) / d + (g < b ? 6 : 0); break;
//       case g: h = (b - r) / d + 2; break;
//       case b: h = (r - g) / d + 4; break;
//       default: break;
//     }
//     h /= 6;
//   }
//   return [h * 360, s, l];
// }

// function hslToRgb(h, s, l) {
//   h /= 360;
//   let r, g, b;
//   if (s === 0) {
//     r = g = b = l;
//   } else {
//     const hue2rgb = (p, q, t) => {
//       if (t < 0) t += 1;
//       if (t > 1) t -= 1;
//       if (t < 1 / 6) return p + (q - p) * 6 * t;
//       if (t < 1 / 2) return q;
//       if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
//       return p;
//     };
//     const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
//     const p = 2 * l - q;
//     r = hue2rgb(p, q, h + 1 / 3);
//     g = hue2rgb(p, q, h);
//     b = hue2rgb(p, q, h - 1 / 3);
//   }
//   return [r * 255, g * 255, b * 255];
// }


// function hexToHsl(hex) {
//   const clean = hex.replace('#', '').trim();

//   const normalized =
//     clean.length === 3
//       ? clean.split('').map((char) => char + char).join('')
//       : clean;

//   const r = parseInt(normalized.slice(0, 2), 16);
//   const g = parseInt(normalized.slice(2, 4), 16);
//   const b = parseInt(normalized.slice(4, 6), 16);

//   return rgbToHsl(r, g, b);
// }

// function isGoldPixel(h, s, l) {
//   return (
//     h >= 15 &&
//     h <= 75 &&
//     s > 0.18 &&
//     l > 0.10
//   );
// }

// /*
//   Detect the ACTUAL colored theme parts of the frame.

//   Your current source artwork contains green / teal / blue accents,
//   while earlier versions contained purple / violet accents.

//   The old detector only accepted hue 220..355, so a green/teal source
//   was ignored. That is why only the webpage AmbientGlow changed while
//   the main frame stayed green.

//   This detector accepts the full cool/accent range:
//   green -> teal -> cyan -> blue -> indigo -> purple -> magenta,
//   while still protecting gold, cream, beige, white and neutrals.
// */
// function isThemeSourcePixel(h, s, l) {
//   if (s < 0.16) return false;
//   if (l < 0.035 || l > 0.975) return false;

//   // Gold / bronze / warm architecture is protected separately,
//   // but we also keep this range out of the theme mask.
//   if (h >= 12 && h <= 78) return false;

//   // Main editable design family:
//   // green, teal, cyan, blue, violet, purple, magenta.
//   if (h >= 80 && h <= 359) return true;

//   // Strong near-red accent pixels can also follow red/coral themes
//   // without pulling neutral beige into the recolor mask.
//   return h < 12 && s > 0.58;
// }

// function createIdleScheduler(callback) {
//   if (
//     typeof window !== 'undefined' &&
//     'requestIdleCallback' in window
//   ) {
//     const id = window.requestIdleCallback(
//       callback,
//       { timeout: 500 }
//     );

//     return () => {
//       window.cancelIdleCallback?.(id);
//     };
//   }

//   const id = window.setTimeout(callback, 80);

//   return () => {
//     window.clearTimeout(id);
//   };
// }

// const FRAME_PROCESSOR_VERSION = 'theme-engine-v3-green-blue-purple';

// const MIN_ZOOM = 1;
// const MAX_ZOOM = 4;
// const EXPORT_SCALE = 1;

// function clamp(value, min, max) {
//   return Math.min(Math.max(value, min), max);
// }

// /*
//  * Choose a sensible starting crop whenever a new image is uploaded
//  * or the user presses "Reset Fit".
//  *
//  * zoom: 1 works with the contain-style foreground photo,
//  * so the complete uploaded picture is visible initially.
//  *
//  * A small downward offset for tall portrait photos gives a more
//  * natural starting composition without forcing extra zoom.
//  */
// function getSmartInitialCrop(naturalWidth, naturalHeight) {
//   if (
//     !naturalWidth ||
//     !naturalHeight ||
//     naturalWidth <= 0 ||
//     naturalHeight <= 0
//   ) {
//     return {
//       zoom: 1,
//       offset: { x: 0, y: 0 }
//     };
//   }

//   const aspect = naturalWidth / naturalHeight;

//   // Tall / portrait image
//   if (aspect < 0.85) {
//     return {
//       zoom: 1,
//       offset: { x: 0, y: 0.06 }
//     };
//   }

//   // Square or landscape image
//   return {
//     zoom: 1,
//     offset: { x: 0, y: 0 }
//   };
// }

// export default function AvatarCreator() {
//   const template = TEMPLATES[0];
//   const [activeTheme, setActiveTheme] = useState(FRAME_THEMES[0]);
  
//   const [processedFrameSrc, setProcessedFrameSrc] = useState(null);
//   const [isProcessing, setIsProcessing] = useState(true);

//   const [photo, setPhoto] = useState(null);
//   const [zoom, setZoom] = useState(1);
//   const [offset, setOffset] = useState({ x: 0, y: 0 });

//   const [isDownloading, setIsDownloading] = useState(false);
//   const [showConfetti, setShowConfetti] = useState(false);
//   const [errorMessage, setErrorMessage] = useState('');
//   const [previewWidth, setPreviewWidth] = useState(420);

//   const fileInputRef = useRef(null);
//   const dragState = useRef(null);

//   // Prepared frame + fast theme caches.
//   const frameProcessorRef = useRef(null);
//   const frameProcessorPromiseRef = useRef(null);
//   const themeCacheRef = useRef(new Map());
//   const themeInFlightRef = useRef(new Map());
//   const themeRequestIdRef = useRef(0);

//   useEffect(() => {
//     window.scrollTo(0, 0);
//   }, []);

//   useEffect(() => {
//     const computeWidth = () => {
//       const available = Math.min(window.innerWidth * 0.9, 460);
//       setPreviewWidth(Math.max(260, available));
//     };
//     computeWidth();
//     window.addEventListener('resize', computeWidth);
//     return () => window.removeEventListener('resize', computeWidth);
//   }, []);

//   const previewHeight =
//     previewWidth * (template.height / template.width);

//   const previewHole = {
//     cx: template.hole.cx * previewWidth,
//     cy: template.hole.cy * previewHeight,
//     r: template.hole.r * previewWidth
//   };

//   //     const img = new Image();
//   //     img.crossOrigin = "anonymous";
//   //     img.onload = () => {
//   //       const canvas = document.createElement('canvas');
//   //       canvas.width = img.width;
//   //       canvas.height = img.height;
//   //       const ctx = canvas.getContext('2d', { willReadFrequently: true });
//   //       ctx.drawImage(img, 0, 0);

//   //       const imgData = ctx.getImageData(0, 0, canvas.width, canvas.height);
//   //       const data = imgData.data;

//   //       const cx = template.hole.cx * canvas.width;
//   //       const cy = template.hole.cy * canvas.height;
//   //       const rSq = (template.hole.r * canvas.width) ** 2;

//   //       for (let i = 0; i < data.length; i += 4) {
//   //         const red = data[i], green = data[i+1], blue = data[i+2], a = data[i+3];
//   //         if (a === 0) continue;
          
//   //         let [h, s, l] = rgbToHsl(red, green, blue);

//   //         const px = (i / 4) % canvas.width;
//   //         const py = Math.floor((i / 4) / canvas.width);
//   //         const distSq = (px - cx) ** 2 + (py - cy) ** 2;

//   //         // 1. CLEAR THE CIRCLE: Make the white center transparent, but protect the Gold Text
//   //         if (distSq < rSq) {
//   //           // White pixels have high lightness and low saturation
//   //           if (l > 0.80 && s < 0.3) {
//   //             data[i + 3] = 0; 
//   //             continue;
//   //           }
//   //         }

//   //         // 2. SHIFT THE THEME: Shift the purples/pinks, but strictly avoid Gold hues (20 to 70)
//   //         const isGold = (h > 15 && h < 75) && s > 0.25;
//   //         const isWhiteOrBlack = l > 0.9 || l < 0.1;

//   //         if (shift !== 0 && !isGold && !isWhiteOrBlack) {
//   //           let newH = (h + shift + 360) % 360;
//   //           const [nR, nG, nB] = hslToRgb(newH, s, l);
//   //           data[i] = nR;
//   //           data[i+1] = nG;
//   //           data[i+2] = nB;
//   //         }
//   //       }

//   //       ctx.putImageData(imgData, 0, 0);
//   //       resolve(canvas.toDataURL('image/png'));
//   //     };
//   //     img.src = template.src;
//   //   });
//   // }, [template]);

//   /*
//    * ==========================================================
//    * FAST FRAME PROCESSOR
//    * ==========================================================
//    *
//    * The expensive source-frame analysis runs once.
//    * Theme changes then recolor only known theme pixels.
//    */
//   const initialiseFrameProcessor = useCallback(() => {
//     /*
//       React Fast Refresh can preserve refs while you edit this file.
//       If an older processor created the previous purple-only mask,
//       discard it so the new green/teal/blue-aware mask is rebuilt.
//     */
//     if (
//       frameProcessorRef.current &&
//       frameProcessorRef.current.engineVersion !== FRAME_PROCESSOR_VERSION
//     ) {
//       frameProcessorRef.current = null;
//       frameProcessorPromiseRef.current = null;

//       themeCacheRef.current.forEach((url) => {
//         URL.revokeObjectURL(url);
//       });

//       themeCacheRef.current.clear();
//       themeInFlightRef.current.clear();
//     }

//     if (
//       frameProcessorRef.current?.engineVersion ===
//       FRAME_PROCESSOR_VERSION
//     ) {
//       return Promise.resolve(frameProcessorRef.current);
//     }

//     if (frameProcessorPromiseRef.current) {
//       return frameProcessorPromiseRef.current;
//     }

//     frameProcessorPromiseRef.current =
//       new Promise((resolve, reject) => {
//         const img = new Image();
//         img.crossOrigin = 'anonymous';

//         img.onload = () => {
//           try {
//             const width =
//               img.naturalWidth || img.width;

//             const height =
//               img.naturalHeight || img.height;

//             const canvas =
//               document.createElement('canvas');

//             canvas.width = width;
//             canvas.height = height;

//             const ctx = canvas.getContext(
//               '2d',
//               { willReadFrequently: true }
//             );

//             if (!ctx) {
//               reject(
//                 new Error(
//                   'Could not create frame canvas.'
//                 )
//               );
//               return;
//             }

//             ctx.drawImage(
//               img,
//               0,
//               0,
//               width,
//               height
//             );

//             const imageData =
//               ctx.getImageData(
//                 0,
//                 0,
//                 width,
//                 height
//               );

//             const pixels =
//               new Uint8ClampedArray(
//                 imageData.data
//               );

//             const themeOffsets = [];
//             const themeLightness = [];

//             /*
//               Exact INNER portrait opening.

//               This is the key fix for the unwanted
//               opening beside the upper-right flowers.
//             */
//             const cx =
//               template.hole.cx * width;

//             const cy =
//               template.hole.cy * height;

//             const radius =
//               template.hole.r * width;

//             const radiusSq =
//               radius * radius;

//             const feather =
//               Math.max(
//                 1.5,
//                 width * 0.0015
//               );

//             for (
//               let i = 0;
//               i < pixels.length;
//               i += 4
//             ) {
//               const alpha =
//                 pixels[i + 3];

//               if (alpha === 0) continue;

//               const red = pixels[i];
//               const green = pixels[i + 1];
//               const blue = pixels[i + 2];

//               const [h, s, l] =
//                 rgbToHsl(
//                   red,
//                   green,
//                   blue
//                 );

//               const pixelIndex =
//                 i / 4;

//               const px =
//                 pixelIndex % width;

//               const py =
//                 Math.floor(
//                   pixelIndex / width
//                 );

//               const dx = px - cx;
//               const dy = py - cy;

//               const distSq =
//                 dx * dx +
//                 dy * dy;

//               const isGold =
//                 isGoldPixel(h, s, l);

//               /*
//                 Keep lower dark typography/shadow
//                 that intentionally overlaps the photo.
//               */
//               const isLowerTextShadow =
//                 py >
//                   cy +
//                     radius * 0.30 &&
//                 l < 0.34 &&
//                 s > 0.08;

//               /*
//                 OPEN ONLY THE TRUE CENTER.

//                 Nothing outside this exact small circle
//                 can become transparent.
//               */
//               if (
//                 distSq < radiusSq &&
//                 !isGold &&
//                 !isLowerTextShadow
//               ) {
//                 const distance =
//                   Math.sqrt(distSq);

//                 if (
//                   distance <=
//                   radius - feather
//                 ) {
//                   pixels[i + 3] = 0;
//                 } else {
//                   const edge =
//                     (
//                       distance -
//                       (radius - feather)
//                     ) /
//                     feather;

//                   pixels[i + 3] =
//                     Math.round(
//                       alpha *
//                         clamp(
//                           edge,
//                           0,
//                           1
//                         )
//                     );
//                 }

//                 continue;
//               }

//               /*
//                 Save editable pixels ONCE.
//               */
//               if (
//                 !isGold &&
//                 isThemeSourcePixel(
//                   h,
//                   s,
//                   l
//                 )
//               ) {
//                 themeOffsets.push(i);

//                 themeLightness.push(
//                   Math.round(
//                     clamp(
//                       l,
//                       0,
//                       1
//                     ) * 255
//                   )
//                 );
//               }
//             }

//             const processor = {
//               engineVersion: FRAME_PROCESSOR_VERSION,
//               width,
//               height,
//               basePixels: pixels,
//               themeOffsets:
//                 Uint32Array.from(
//                   themeOffsets
//                 ),
//               themeLightness:
//                 Uint8Array.from(
//                   themeLightness
//                 )
//             };

//             frameProcessorRef.current =
//               processor;

//             resolve(processor);
//           } catch (error) {
//             reject(error);
//           }
//         };

//         img.onerror = () => {
//           reject(
//             new Error(
//               `Unable to load frame: ${template.src}`
//             )
//           );
//         };

//         img.src = template.src;
//       });

//     return frameProcessorPromiseRef.current;
//   }, [template]);


//   /*
//    * Render a selected color.
//    *
//    * The selected HEX controls the exact HUE.
//    * Only highlights/shadows vary in lightness.
//    */
//   const renderThemeFrame =
//     useCallback(
//       async (theme) => {
//         const cacheKey =
//           `${FRAME_PROCESSOR_VERSION}-${theme.hex.toUpperCase()}`;

//         const cached =
//           themeCacheRef.current.get(
//             cacheKey
//           );

//         if (cached) {
//           return cached;
//         }

//         const existing =
//           themeInFlightRef.current.get(
//             cacheKey
//           );

//         if (existing) {
//           return existing;
//         }

//         const renderPromise =
//           (async () => {
//             const processor =
//               await initialiseFrameProcessor();

//             const pixels =
//               new Uint8ClampedArray(
//                 processor.basePixels
//               );

//             const [
//               targetHue,
//               targetSaturation,
//               targetLightness
//             ] =
//               hexToHsl(theme.hex);

//             /*
//               256-entry LUT makes recoloring
//               much faster than HSL conversion
//               for every pixel.
//             */
//             const rgbLookup =
//               new Uint8ClampedArray(
//                 256 * 3
//               );

//             for (
//               let lightByte = 0;
//               lightByte < 256;
//               lightByte += 1
//             ) {
//               const sourceL =
//                 lightByte / 255;

//               /*
//                 Bright/vivid output while keeping
//                 realistic fabric and flower shading.
//               */
//               const saturation =
//                 clamp(
//                   targetSaturation * 0.92 + 0.08,
//                   0.62,
//                   1
//                 );

//               const lightness =
//                 clamp(
//                   sourceL * 0.58 +
//                     targetLightness * 0.32 +
//                     0.10,
//                   0.20,
//                   0.94
//                 );

//               const [r, g, b] =
//                 hslToRgb(
//                   targetHue,
//                   saturation,
//                   lightness
//                 );

//               const lutIndex =
//                 lightByte * 3;

//               rgbLookup[lutIndex] =
//                 Math.round(r);

//               rgbLookup[
//                 lutIndex + 1
//               ] =
//                 Math.round(g);

//               rgbLookup[
//                 lutIndex + 2
//               ] =
//                 Math.round(b);
//             }

//             const offsets =
//               processor.themeOffsets;

//             const lightnessValues =
//               processor.themeLightness;

//             for (
//               let index = 0;
//               index < offsets.length;
//               index += 1
//             ) {
//               const pixelOffset =
//                 offsets[index];

//               const lutIndex =
//                 lightnessValues[
//                   index
//                 ] * 3;

//               pixels[pixelOffset] =
//                 rgbLookup[lutIndex];

//               pixels[
//                 pixelOffset + 1
//               ] =
//                 rgbLookup[
//                   lutIndex + 1
//                 ];

//               pixels[
//                 pixelOffset + 2
//               ] =
//                 rgbLookup[
//                   lutIndex + 2
//                 ];
//             }

//             const canvas =
//               document.createElement(
//                 'canvas'
//               );

//             canvas.width =
//               processor.width;

//             canvas.height =
//               processor.height;

//             const ctx =
//               canvas.getContext('2d');

//             if (!ctx) {
//               throw new Error(
//                 'Could not create theme canvas.'
//               );
//             }

//             const outputData =
//               ctx.createImageData(
//                 processor.width,
//                 processor.height
//               );

//             outputData.data.set(
//               pixels
//             );

//             ctx.putImageData(
//               outputData,
//               0,
//               0
//             );

//             /*
//               Fast preview format with alpha.
//               Falls back to PNG automatically.
//             */
//             const blob =
//               await new Promise(
//                 (resolve) => {
//                   canvas.toBlob(
//                     (webpBlob) => {
//                       if (webpBlob) {
//                         resolve(
//                           webpBlob
//                         );
//                         return;
//                       }

//                       canvas.toBlob(
//                         resolve,
//                         'image/png'
//                       );
//                     },
//                     'image/webp',
//                     0.96
//                   );
//                 }
//               );

//             if (!blob) {
//               throw new Error(
//                 'Could not create theme preview.'
//               );
//             }

//             const objectUrl =
//               URL.createObjectURL(blob);

//             themeCacheRef.current.set(
//               cacheKey,
//               objectUrl
//             );

//             return objectUrl;
//           })();

//         themeInFlightRef.current.set(
//           cacheKey,
//           renderPromise
//         );

//         try {
//           return await renderPromise;
//         } finally {
//           themeInFlightRef.current.delete(
//             cacheKey
//           );
//         }
//       },
//       [initialiseFrameProcessor]
//     );


//   /*
//    * Apply selected theme.
//    * Cached selections appear virtually instantly.
//    */
//   useEffect(() => {
//     let cancelled = false;

//     const requestId =
//       ++themeRequestIdRef.current;

//     const applyTheme = async () => {
//       const cacheKey =
//         `${FRAME_PROCESSOR_VERSION}-${activeTheme.hex.toUpperCase()}`;

//       const cached =
//         themeCacheRef.current.get(
//           cacheKey
//         );

//       if (cached) {
//         setProcessedFrameSrc(
//           cached
//         );

//         setIsProcessing(false);
//         return;
//       }

//       setIsProcessing(true);
//       setErrorMessage('');

//       try {
//         const themedFrame =
//           await renderThemeFrame(
//             activeTheme
//           );

//         if (
//           !cancelled &&
//           requestId ===
//             themeRequestIdRef.current
//         ) {
//           setProcessedFrameSrc(
//             themedFrame
//           );
//         }
//       } catch (error) {
//         console.error(error);

//         if (!cancelled) {
//           setErrorMessage(
//             'Unable to prepare this frame colour.'
//           );
//         }
//       } finally {
//         if (
//           !cancelled &&
//           requestId ===
//             themeRequestIdRef.current
//         ) {
//           setIsProcessing(false);
//         }
//       }
//     };

//     applyTheme();

//     return () => {
//       cancelled = true;
//     };
//   }, [
//     activeTheme,
//     renderThemeFrame
//   ]);


//   /*
//    * Pre-cache all remaining colors during idle time.
//    * After warm-up, switching is instant.
//    */
//   useEffect(() => {
//     let cancelled = false;
//     let cancelScheduled = null;
//     let index = 0;

//     const warmNext = async () => {
//       if (cancelled) return;

//       while (
//         index <
//           FRAME_THEMES.length &&
//         themeCacheRef.current.has(
//           `${FRAME_PROCESSOR_VERSION}-${FRAME_THEMES[
//             index
//           ].hex.toUpperCase()}`
//         )
//       ) {
//         index += 1;
//       }

//       if (
//         index >=
//         FRAME_THEMES.length
//       ) {
//         return;
//       }

//       const theme =
//         FRAME_THEMES[index];

//       index += 1;

//       try {
//         await renderThemeFrame(
//           theme
//         );
//       } catch {
//         // Background warm-up is optional.
//       }

//       if (!cancelled) {
//         cancelScheduled =
//           createIdleScheduler(
//             warmNext
//           );
//       }
//     };

//     cancelScheduled =
//       createIdleScheduler(
//         warmNext
//       );

//     return () => {
//       cancelled = true;
//       cancelScheduled?.();
//     };
//   }, [renderThemeFrame]);


//   /*
//    * Clean up cached blob URLs.
//    */
//   useEffect(() => {
//     return () => {
//       themeCacheRef.current.forEach(
//         (url) => {
//           URL.revokeObjectURL(url);
//         }
//       );

//       themeCacheRef.current.clear();
//       themeInFlightRef.current.clear();
//     };
//   }, []);




//   /*
//    * The foreground portrait uses CONTAIN at zoom 1.
//    * That means the whole uploaded photo is visible instead of looking
//    * excessively zoomed. A blurred COVER copy sits behind it, so the
//    * circular opening is always visually filled and no rectangular gaps
//    * are exposed.
//    */
//   const clampOffset = useCallback((candidate) => {
//     return {
//       x: clamp(candidate.x, -1, 1),
//       y: clamp(candidate.y, -1, 1)
//     };
//   }, []);

//   const handleZoomChange = (nextZoom) => {
//     const safeZoom = clamp(nextZoom, MIN_ZOOM, MAX_ZOOM);
//     setZoom(safeZoom);
//     setOffset((prev) => clampOffset(prev));
//   };

//   const resetCrop = useCallback((targetPhoto = photo) => {
//     if (!targetPhoto) {
//       setZoom(1);
//       setOffset({ x: 0, y: 0 });
//       return;
//     }

//     const initial = getSmartInitialCrop(
//       targetPhoto.naturalWidth,
//       targetPhoto.naturalHeight
//     );

//     setZoom(initial.zoom);
//     setOffset(initial.offset);
//   }, [photo]);

//   const handleImageUpload = (e) => {
//     const file = e.target.files?.[0];

//     if (!file) return;

//     setErrorMessage('');

//     if (!file.type.startsWith('image/')) {
//       setErrorMessage('Please select a valid image file.');
//       e.target.value = '';
//       return;
//     }

//     const MAX_FILE_SIZE = 15 * 1024 * 1024;

//     if (file.size > MAX_FILE_SIZE) {
//       setErrorMessage(
//         'Your image is too large. Please choose an image smaller than 15MB.'
//       );
//       e.target.value = '';
//       return;
//     }

//     const reader = new FileReader();

//     reader.onload = (event) => {
//       const imageSource = event.target?.result;
//       if (!imageSource) return;

//       const img = new Image();

//       img.onload = () => {
//         const nextPhoto = {
//           src: imageSource,
//           naturalWidth: img.naturalWidth,
//           naturalHeight: img.naturalHeight
//         };

//         setPhoto(nextPhoto);

//         const initial = getSmartInitialCrop(
//           img.naturalWidth,
//           img.naturalHeight
//         );

//         setZoom(initial.zoom);
//         setOffset(initial.offset);
//       };

//       img.onerror = () => {
//         setErrorMessage(
//           'We could not read this image. Please select another photo.'
//         );
//       };

//       img.src = imageSource;
//     };

//     reader.onerror = () => {
//       setErrorMessage('We could not open this file.');
//     };

//     reader.readAsDataURL(file);

//     // Allows choosing the same file again.
//     e.target.value = '';
//   };

//   const handlePointerDown = (e) => {
//     if (!photo) return;

//     e.currentTarget.setPointerCapture?.(e.pointerId);

//     dragState.current = {
//       startX: e.clientX,
//       startY: e.clientY,
//       startOffset: { ...offset }
//     };
//   };

//   const handlePointerMove = (e) => {
//     if (!dragState.current || !photo) return;

//     const radius = Math.max(previewHole.r, 1);

//     const deltaX = e.clientX - dragState.current.startX;
//     const deltaY = e.clientY - dragState.current.startY;

//     const candidate = {
//       x: dragState.current.startOffset.x + deltaX / radius,
//       y: dragState.current.startOffset.y + deltaY / radius
//     };

//     setOffset(clampOffset(candidate));
//   };

//   const handlePointerUp = (e) => {
//     if (
//       e.currentTarget.hasPointerCapture &&
//       e.currentTarget.hasPointerCapture(e.pointerId)
//     ) {
//       e.currentTarget.releasePointerCapture(e.pointerId);
//     }

//     dragState.current = null;
//   };

//   /*
//    * Foreground portrait rectangle.
//    *
//    * zoom === 1  -> contain (whole image visible)
//    * zoom > 1    -> user can zoom in
//    *
//    * Empty space that contain would normally create is hidden by the
//    * blurred cover background layer.
//    */
//   function getPhotoRect(holeDiameterPx, customZoom = zoom, customOffset = offset) {
//     if (!photo) return null;

//     const imageWidth = photo.naturalWidth;
//     const imageHeight = photo.naturalHeight;

//     const containScale = Math.min(
//       holeDiameterPx / imageWidth,
//       holeDiameterPx / imageHeight
//     );

//     const finalScale =
//       containScale * clamp(customZoom, MIN_ZOOM, MAX_ZOOM);

//     const width = imageWidth * finalScale;
//     const height = imageHeight * finalScale;

//     const maxShift = holeDiameterPx * 0.46;

//     const offsetXPx = clamp(
//       customOffset.x * (holeDiameterPx / 2),
//       -maxShift,
//       maxShift
//     );

//     const offsetYPx = clamp(
//       customOffset.y * (holeDiameterPx / 2),
//       -maxShift,
//       maxShift
//     );

//     return {
//       width,
//       height,
//       offsetXPx,
//       offsetYPx
//     };
//   }

//   const previewPhotoRect = photo ? getPhotoRect(previewHole.r * 2) : null;

//   const handleDownload = async (e) => {
//     e.preventDefault();
//     if (!photo) {
//       setErrorMessage('Please upload a photo to create your avatar.');
//       setTimeout(() => setErrorMessage(''), 4000);
//       return;
//     }

//     setIsDownloading(true);
//     try {
//       const exportWidth = template.width * EXPORT_SCALE;
//       const exportHeight = template.height * EXPORT_SCALE;
//       const holeCxPx = template.hole.cx * exportWidth;
//       const holeCyPx = template.hole.cy * exportHeight;
//       const holeRPx = template.hole.r * exportWidth;

//       const canvas = document.createElement('canvas');
//       canvas.width = exportWidth;
//       canvas.height = exportHeight;
//       const ctx = canvas.getContext('2d');

//       const photoImg = new Image();
//       photoImg.src = photo.src;

//       await new Promise((resolve, reject) => {
//         photoImg.onload = resolve;
//         photoImg.onerror = reject;
//       });

//       const holeDiameter = holeRPx * 2;

//       // ---------------------------------------------------------
//       // 1. BLURRED COVER BACKGROUND
//       // Always fills the circle so the user can zoom out safely.
//       // ---------------------------------------------------------
//       const coverScale = Math.max(
//         holeDiameter / photo.naturalWidth,
//         holeDiameter / photo.naturalHeight
//       );

//       const coverWidth = photo.naturalWidth * coverScale;
//       const coverHeight = photo.naturalHeight * coverScale;

//       ctx.save();
//       ctx.beginPath();
//       ctx.arc(holeCxPx, holeCyPx, holeRPx, 0, Math.PI * 2);
//       ctx.clip();

//       ctx.filter = `blur(${Math.max(12, exportWidth * 0.014)}px)`;
//       ctx.globalAlpha = 0.82;

//       const blurOverscan = 1.12;

//       ctx.drawImage(
//         photoImg,
//         holeCxPx - (coverWidth * blurOverscan) / 2,
//         holeCyPx - (coverHeight * blurOverscan) / 2,
//         coverWidth * blurOverscan,
//         coverHeight * blurOverscan
//       );

//       // Darken slightly so the foreground portrait stays clear.
//       ctx.filter = 'none';
//       ctx.globalAlpha = 0.14;
//       ctx.fillStyle = '#0b080d';
//       ctx.fillRect(
//         holeCxPx - holeRPx,
//         holeCyPx - holeRPx,
//         holeDiameter,
//         holeDiameter
//       );

//       ctx.restore();

//       // ---------------------------------------------------------
//       // 2. FOREGROUND PHOTO
//       // At zoom 1, the WHOLE image fits inside the circle.
//       // ---------------------------------------------------------
//       const {
//         width,
//         height,
//         offsetXPx,
//         offsetYPx
//       } = getPhotoRect(holeDiameter);

//       ctx.save();
//       ctx.beginPath();
//       ctx.arc(holeCxPx, holeCyPx, holeRPx, 0, Math.PI * 2);
//       ctx.clip();

//       ctx.drawImage(
//         photoImg,
//         holeCxPx - width / 2 + offsetXPx,
//         holeCyPx - height / 2 + offsetYPx,
//         width,
//         height
//       );

//       ctx.restore();

//       // 2. Draw Processed Frame ON TOP (The gold text overlaps the photo perfectly!)
//       const frameImg = new Image();
//       frameImg.src = processedFrameSrc || template.src;
//       await new Promise((resolve, reject) => {
//         frameImg.onload = resolve;
//         frameImg.onerror = reject;
//       });
//       ctx.drawImage(frameImg, 0, 0, exportWidth, exportHeight);

//       const dataUrl = canvas.toDataURL('image/png');
//       const link = document.createElement('a');
//       link.download = `Royal_Avatar_${activeTheme.name.replace(/\s+/g, '_')}.png`;
//       link.href = dataUrl;
//       link.click();

//       setShowConfetti(true);
//       setTimeout(() => setShowConfetti(false), 6000);
//     } catch (err) {
//       console.error(err);
//       setErrorMessage('Something went wrong generating your avatar.');
//     } finally {
//       setIsDownloading(false);
//     }
//   };

//   const circleTouchAction = photo ? 'none' : 'auto';

//   return (
//     <div className="royal-avatar-page">
//       <AmbientGlow secondaryHex={activeTheme.hex} />

//       <div className="royal-nav">
//         <Link to="/" className="back-link">
//           <Icon.ArrowLeft width="16" height="16" /> Back to Home
//         </Link>
//       </div>

//       {showConfetti && (
//         <div className="fixed-confetti-wrapper">
//           <Confetti width={window.innerWidth} height={window.innerHeight} numberOfPieces={400} gravity={0.3} colors={['#C6A15B', '#F4E8C9', activeTheme.hex, '#FFFFFF']} recycle={false} />
//         </div>
//       )}

//       <div className="avatar-container">
//         <Icon.RoyalVine className="royal-vine royal-vine-tl" />
//         <Icon.RoyalVine className="royal-vine royal-vine-tr" />

//         <motion.div className="avatar-header" initial={{ opacity: 0, y: -20 }} animate={{ opacity: 1, y: 0 }}>
//           {/* <Icon.Crest className="header-crest" style={{ color: 'var(--gold, #c6a15b)', width: '48px', marginBottom: '16px' }} /> */}
//           <span className="eyebrow">The Royal Studio</span>
//           <h1>Create Your Avatar</h1>
//           <p>Drop in your photo, adjust the theme color, and download your avatar.</p>
//         </motion.div>

//         <div className="studio-layout">
          
//           <motion.div className="mirror-section" initial={{ opacity: 0, scale: 0.95 }} animate={{ opacity: 1, scale: 1 }}>
//             <div
//   className={`photo-stage ${photo ? 'has-photo' : 'no-photo'}`}
//   style={{
//     width: previewWidth,
//     height: previewHeight
//   }}

//   onClick={() => {
//     if (!photo) {
//       fileInputRef.current?.click();
//     }
//   }}

//   onPointerDown={handlePointerDown}
//   onPointerMove={handlePointerMove}
//   onPointerUp={handlePointerUp}
//   onPointerCancel={handlePointerUp}
// >

//   {/* -----------------------------------------
//       USER PHOTO
//       This sits below the decorative frame.
//   ----------------------------------------- */}

//   <div
//     className="photo-circle"

//     style={{
//       width:
//         previewHole.r * 2,

//       height:
//         previewHole.r * 2,

//       left:
//         previewHole.cx -
//         previewHole.r,

//       top:
//         previewHole.cy -
//         previewHole.r,

//       touchAction:
//         circleTouchAction
//     }}
//   >

//     {photo && previewPhotoRect ? (
//       <>
//         <img
//           className="photo-backdrop-img"
//           src={photo.src}
//           alt=""
//           aria-hidden="true"
//           draggable="false"
//         />

//         <img
//           className="photo-img"

//         src={photo.src}

//         alt="Your uploaded portrait"

//         draggable="false"

//         style={{
//           width:
//             previewPhotoRect.width,

//           height:
//             previewPhotoRect.height,

//           left:
//             previewPhotoRect.offsetXPx -
//             (
//               previewPhotoRect.width -
//               previewHole.r * 2
//             ) / 2,

//           top:
//             previewPhotoRect.offsetYPx -
//             (
//               previewPhotoRect.height -
//               previewHole.r * 2
//             ) / 2
//         }}
//         />
//       </>
//     ) : (
//       <div
//         className="upload-prompt"
//       >
//         <span className="upload-icon-circle">
//           <Icon.Upload
//             width="24"
//             height="34"
//           />
//         </span>

//         <strong>
//           Add Your Photo
//         </strong>

//         <small>
//           Click to upload
//         </small>
//       </div>
//     )}

//   </div>


//   {/* -----------------------------------------
//       DECORATIVE FRAME
//   ----------------------------------------- */}

//   <img
//     className="template-overlay-img"

//     src={
//       processedFrameSrc ||
//       template.src
//     }

//     alt="Royal avatar frame"

//     draggable="false"

//     style={{ opacity: 1 }}
//   />


//   {/* -----------------------------------------
//       PROCESSING INDICATOR
//   ----------------------------------------- */}

//   {isProcessing && (
//     <div className="frame-processing">
//       <span className="processing-spinner" />

//       <span>
//         Updating theme…
//       </span>
//     </div>
//   )}


//   <input
//     type="file"
//     ref={fileInputRef}
//     onChange={handleImageUpload}
//     accept="image/png,image/jpeg,image/jpg,image/webp"
//     className="hidden-file-input"
//   />

// </div>
 
//           </motion.div>

//           <motion.div className="wardrobe-section" initial={{ opacity: 0, x: 20 }} animate={{ opacity: 1, x: 0 }}>
//             <form onSubmit={handleDownload}>
              
//               <div className="control-group">
//                 <label>1. Frame Color Theme</label>
//                 <div className="theme-picker">
//                   {FRAME_THEMES.map((theme) => (
//                     <button
//                       key={theme.name}
//                       type="button"
//                       className={`color-swatch ${activeTheme.name === theme.name ? 'active' : ''}`}
//                       style={{
//                         backgroundColor: theme.hex,
//                         // '--swatch-color': theme.hex
//                       }}
//                       onClick={() => setActiveTheme(theme)}
//                       title={theme.name}
//                       aria-label={`Use ${theme.name} theme`}
//                       aria-pressed={activeTheme.name === theme.name}
//                     />
//                   ))}
//                 </div>
//               </div>

//               <div className="control-group">
//                 <label>2. Position Your Photo</label>
//                 {!photo ? (
//                   <button type="button" className="btn-outline photo-picker-btn" onClick={() => fileInputRef.current.click()}>
//                     <Icon.Upload width="18" height="18" /> Upload a Photo
//                   </button>
//                 ) : (
//                   <>
//                     <div className="photo-action-row">
//                       <button
//                         type="button"
//                         className="btn-outline photo-picker-btn"
//                         onClick={() => fileInputRef.current?.click()}
//                       >
//                         Replace Photo
//                       </button>

//                       <button
//                         type="button"
//                         className="btn-outline reset-photo-btn"
//                         onClick={() => resetCrop()}
//                       >
//                         Reset Fit
//                       </button>
//                     </div>

//                     <div className="zoom-control">
//                       <Icon.ZoomOut width="18" height="18" />
//                       <input type="range" min={MIN_ZOOM} max={MAX_ZOOM} step={0.01} value={zoom} onChange={(e) => handleZoomChange(parseFloat(e.target.value))} />
//                       <Icon.ZoomIn width="18" height="18" />
//                     </div>
//                     <p className="drag-hint">At the left end, the whole photo is visible. Zoom in only when needed, and drag to reposition.</p>
//                   </>
//                 )}
//               </div>

//               <AnimatePresence>
//                 {errorMessage && (
//                   <motion.div className="error-message" initial={{ opacity: 0, y: -10 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0 }}>
//                     {errorMessage}
//                   </motion.div>
//                 )}
//               </AnimatePresence>

//               <motion.button type="submit" className="btn-gold download-btn" disabled={isDownloading || isProcessing} whileHover={{ scale: 1.02 }} whileTap={{ scale: 0.98 }}>
//                 {isDownloading || isProcessing ? 'Processing Image...' : <><Icon.Download width="20" height="20" /> Download Royal Avatar</>}
//               </motion.button>
//             </form>
//           </motion.div>
//         </div>
//       </div>
//     </div>
//   );
// }




import React, { useState, useRef, useEffect, useCallback } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Link } from 'react-router-dom';
import Confetti from 'react-confetti';
import './AvatarCreator.css';
//MIN_ZOOM
const Icon = {
  Crest: (p) => (
    <svg viewBox="0 0 48 48" fill="none" stroke="currentColor" strokeWidth="1.3" {...p}>
      <path d="M24 6c-4 5-9 6-14 5 1 9 4 16 14 21 10-5 13-12 14-21-5 1-10 0-14-5Z" strokeLinejoin="round" />
      <path d="M18 22c2 2 4 3 6 3s4-1 6-3M24 25v8" strokeLinecap="round" />
    </svg>
  ),
  Upload: (p) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" {...p}>
      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4M17 8l-5-5-5 5M12 3v12" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  Download: (p) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" {...p}>
      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4M7 10l5 5 5-5M12 15V3" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  ZoomOut: (p) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" {...p}>
      <circle cx="11" cy="11" r="7" /><path d="m21 21-4.35-4.35M8 11h6" strokeLinecap="round" />
    </svg>
  ),
  ZoomIn: (p) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" {...p}>
      <circle cx="11" cy="11" r="7" /><path d="m21 21-4.35-4.35M11 8v6M8 11h6" strokeLinecap="round" />
    </svg>
  ),
  ArrowLeft: (p) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" {...p}>
      <path d="M19 12H5M12 19l-7-7 7-7" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  RoyalVine: (p) => (
    <svg viewBox="0 0 160 160" fill="none" {...p}>
      <path d="M14 150 C10 110 28 70 66 46 C90 31 118 24 146 14" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" />
      <g fill="currentColor">
        <ellipse cx="34" cy="126" rx="11" ry="5" transform="rotate(-35 34 126)" opacity="0.75" />
        <ellipse cx="55" cy="98" rx="10" ry="4.5" transform="rotate(-20 55 98)" opacity="0.7" />
        <ellipse cx="78" cy="70" rx="10" ry="4.5" transform="rotate(5 78 70)" opacity="0.65" />
        <ellipse cx="103" cy="45" rx="9" ry="4" transform="rotate(25 103 45)" opacity="0.6" />
        <ellipse cx="128" cy="24" rx="8" ry="3.5" transform="rotate(45 128 24)" opacity="0.55" />
        <circle cx="146" cy="14" r="3" opacity="0.8" />
        <circle cx="14" cy="150" r="3" opacity="0.8" />
      </g>
    </svg>
  ),
};

const AmbientGlow = ({ secondaryHex }) => (
  <div style={{ position: 'fixed', inset: 0, overflow: 'hidden', pointerEvents: 'none', zIndex: 0 }}>
    <div style={{ position: 'absolute', top: '-10%', left: '-10%', width: '60vw', height: '60vw', background: 'radial-gradient(circle, rgba(198, 161, 91, 0.15) 0%, transparent 70%)', filter: 'blur(60px)' }} />
    <div style={{ position: 'absolute', bottom: '-20%', right: '-10%', width: '70vw', height: '70vw', background: `radial-gradient(circle, ${secondaryHex}40 0%, transparent 70%)`, filter: 'blur(60px)', transition: 'background 0.3s ease' }} />
    <div style={{ position: 'absolute', top: '30%', left: '50%', transform: 'translateX(-50%)', width: '50vw', height: '50vw', background: 'radial-gradient(circle, rgba(255, 215, 0, 0.08) 0%, transparent 70%)', filter: 'blur(40px)' }} />
  </div>
);

const TEMPLATES = [
  {
    id: 'royal-majesty',
    name: 'Royal Majesty',
    src: '/assets/photos/chief-of-staff-avatar-frame-v2.png.png',
    width: 1024,
    height: 1024,

    // ONLY the real inner portrait opening.
    // The old radius (0.32) was too large and cut into decorations.
    hole: {
      cx: 0.512,
      cy: 0.505,
      r: 0.207
    }
  }
];

const FRAME_THEMES = [
    { name: 'Royal Purple',   hex: '#A855F7' },
  { name: 'Royal Purple',   hex: '#A3A380' },
  { name: 'Ruby Red',       hex: '#E3F1FB' },
  { name: 'Emerald Green',  hex: '#10B981' },
  { name: 'Ruby Red',       hex: '#F43F5E' },
  { name: 'Rose Pink',      hex: '#F472B6' },
     { name: 'Sapphire Blue',  hex: '#3B82F6' },
  { name: 'Emerald Green',  hex: '#D8A48F' },
  { name: 'Sapphire Blue',  hex: '#D6CF93' },
  
  { name: 'Rose Pink',      hex: '#809671' },
  { name: 'Luxury Teal',    hex: '#EFEBCE' },
  { name: 'Tangerine',      hex: '#F8F3EF' },
  { name: 'Royal Indigo',   hex: '#e1d1a6' },
  { name: 'Sunshine Gold',  hex: '#F7D6D0' },
  { name: 'Sky Blue',       hex: '#E2B4BD' },
  { name: 'Soft Lavender',    hex: '#B79AF2' },
  { name: 'Powder Blue',      hex: '#7DB8EE' },
  { name: 'Mint Green',       hex: '#79CFAE' },
  { name: 'Blush Rose',       hex: '#E8899D' },
  { name: 'Dusty Pink',       hex: '#E7A0BE' },
  { name: 'Soft Teal',        hex: '#70C9BE' },
  { name: 'Peach',            hex: '#F1A777' },
  { name: 'Periwinkle',       hex: '#9EA9EE' },
  { name: 'Champagne',        hex: '#DCC477' },
  { name: 'Sky Blue',         hex: '#86C7E7' },
  { name: 'Lilac',            hex: '#C99BDA' },
  { name: 'Aqua Mist',        hex: '#7ED2CA' },
  { name: 'Dusty Rose',       hex: '#D889A0' },
  { name: 'Sage Green',       hex: '#93C6A2' },
  { name: 'Soft Coral',       hex: '#EE9D8D' },
  { name: 'Soft Violet',      hex: '#BDA3EA' }
];
//processFrame
/* ── COLOR MATH UTILITIES ── */
function rgbToHsl(r, g, b) {
  r /= 255; g /= 255; b /= 255;
  const max = Math.max(r, g, b), min = Math.min(r, g, b);
  let h = 0, s = 0, l = (max + min) / 2;
  if (max !== min) {
    const d = max - min;
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
    switch (max) {
      case r: h = (g - b) / d + (g < b ? 6 : 0); break;
      case g: h = (b - r) / d + 2; break;
      case b: h = (r - g) / d + 4; break;
      default: break;
    }
    h /= 6;
  }
  return [h * 360, s, l];
}

function hslToRgb(h, s, l) {
  h /= 360;
  let r, g, b;
  if (s === 0) {
    r = g = b = l;
  } else {
    const hue2rgb = (p, q, t) => {
      if (t < 0) t += 1;
      if (t > 1) t -= 1;
      if (t < 1 / 6) return p + (q - p) * 6 * t;
      if (t < 1 / 2) return q;
      if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
      return p;
    };
    const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
    const p = 2 * l - q;
    r = hue2rgb(p, q, h + 1 / 3);
    g = hue2rgb(p, q, h);
    b = hue2rgb(p, q, h - 1 / 3);
  }
  return [r * 255, g * 255, b * 255];
}


function hexToHsl(hex) {
  const clean = hex.replace('#', '').trim();

  const normalized =
    clean.length === 3
      ? clean.split('').map((char) => char + char).join('')
      : clean;

  const r = parseInt(normalized.slice(0, 2), 16);
  const g = parseInt(normalized.slice(2, 4), 16);
  const b = parseInt(normalized.slice(4, 6), 16);

  return rgbToHsl(r, g, b);
}

function isGoldPixel(h, s, l) {
  return (
    h >= 15 &&
    h <= 75 &&
    s > 0.18 &&
    l > 0.10
  );
}

/*
  Detect the ACTUAL colored theme parts of the frame.

  Your current source artwork contains green / teal / blue accents,
  while earlier versions contained purple / violet accents.

  The old detector only accepted hue 220..355, so a green/teal source
  was ignored. That is why only the webpage AmbientGlow changed while
  the main frame stayed green.

  This detector accepts the full cool/accent range:
  green -> teal -> cyan -> blue -> indigo -> purple -> magenta,
  while still protecting gold, cream, beige, white and neutrals.
*/
function isThemeSourcePixel(h, s, l) {
  if (s < 0.16) return false;
  if (l < 0.035 || l > 0.975) return false;

  // Gold / bronze / warm architecture is protected separately,
  // but we also keep this range out of the theme mask.
  if (h >= 12 && h <= 78) return false;

  // Main editable design family:
  // green, teal, cyan, blue, violet, purple, magenta.
  if (h >= 80 && h <= 359) return true;

  // Strong near-red accent pixels can also follow red/coral themes
  // without pulling neutral beige into the recolor mask.
  return h < 12 && s > 0.58;
}

function createIdleScheduler(callback) {
  if (
    typeof window !== 'undefined' &&
    'requestIdleCallback' in window
  ) {
    const id = window.requestIdleCallback(
      callback,
      { timeout: 500 }
    );

    return () => {
      window.cancelIdleCallback?.(id);
    };
  }

  const id = window.setTimeout(callback, 80);

  return () => {
    window.clearTimeout(id);
  };
}

const FRAME_PROCESSOR_VERSION = 'theme-engine-v4-soft-luxury';

const MIN_ZOOM = 1;
const MAX_ZOOM = 4;
const EXPORT_SCALE = 1;

function clamp(value, min, max) {
  return Math.min(Math.max(value, min), max);
}

/*
 * Choose a sensible starting crop whenever a new image is uploaded
 * or the user presses "Reset Fit".
 *
 * zoom: 1 works with the contain-style foreground photo,
 * so the complete uploaded picture is visible initially.
 *
 * A small downward offset for tall portrait photos gives a more
 * natural starting composition without forcing extra zoom.
 */
function getSmartInitialCrop(naturalWidth, naturalHeight) {
  if (
    !naturalWidth ||
    !naturalHeight ||
    naturalWidth <= 0 ||
    naturalHeight <= 0
  ) {
    return {
      zoom: 1,
      offset: { x: 0, y: 0 }
    };
  }

  const aspect = naturalWidth / naturalHeight;

  // Tall / portrait image
  if (aspect < 0.85) {
    return {
      zoom: 1,
      offset: { x: 0, y: 0.06 }
    };
  }

  // Square or landscape image
  return {
    zoom: 1,
    offset: { x: 0, y: 0 }
  };
}

export default function AvatarCreator() {
  const template = TEMPLATES[0];
  const [activeTheme, setActiveTheme] = useState(FRAME_THEMES[0]);
  
  const [processedFrameSrc, setProcessedFrameSrc] = useState(null);
  const [isProcessing, setIsProcessing] = useState(true);

  const [photo, setPhoto] = useState(null);
  const [zoom, setZoom] = useState(1);
  const [offset, setOffset] = useState({ x: 0, y: 0 });

  const [isDownloading, setIsDownloading] = useState(false);
  const [showConfetti, setShowConfetti] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [previewWidth, setPreviewWidth] = useState(420);

  const fileInputRef = useRef(null);
  const dragState = useRef(null);

  // Prepared frame + fast theme caches.
  const frameProcessorRef = useRef(null);
  const frameProcessorPromiseRef = useRef(null);
  const themeCacheRef = useRef(new Map());
  const themeInFlightRef = useRef(new Map());
  const themeRequestIdRef = useRef(0);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const computeWidth = () => {
      const available = Math.min(window.innerWidth * 0.9, 460);
      setPreviewWidth(Math.max(260, available));
    };
    computeWidth();
    window.addEventListener('resize', computeWidth);
    return () => window.removeEventListener('resize', computeWidth);
  }, []);

  const previewHeight =
    previewWidth * (template.height / template.width);

  const previewHole = {
    cx: template.hole.cx * previewWidth,
    cy: template.hole.cy * previewHeight,
    r: template.hole.r * previewWidth
  };

  //     const img = new Image();
  //     img.crossOrigin = "anonymous";
  //     img.onload = () => {
  //       const canvas = document.createElement('canvas');
  //       canvas.width = img.width;
  //       canvas.height = img.height;
  //       const ctx = canvas.getContext('2d', { willReadFrequently: true });
  //       ctx.drawImage(img, 0, 0);

  //       const imgData = ctx.getImageData(0, 0, canvas.width, canvas.height);
  //       const data = imgData.data;

  //       const cx = template.hole.cx * canvas.width;
  //       const cy = template.hole.cy * canvas.height;
  //       const rSq = (template.hole.r * canvas.width) ** 2;

  //       for (let i = 0; i < data.length; i += 4) {
  //         const red = data[i], green = data[i+1], blue = data[i+2], a = data[i+3];
  //         if (a === 0) continue;
          
  //         let [h, s, l] = rgbToHsl(red, green, blue);

  //         const px = (i / 4) % canvas.width;
  //         const py = Math.floor((i / 4) / canvas.width);
  //         const distSq = (px - cx) ** 2 + (py - cy) ** 2;

  //         // 1. CLEAR THE CIRCLE: Make the white center transparent, but protect the Gold Text
  //         if (distSq < rSq) {
  //           // White pixels have high lightness and low saturation
  //           if (l > 0.80 && s < 0.3) {
  //             data[i + 3] = 0; 
  //             continue;
  //           }
  //         }

  //         // 2. SHIFT THE THEME: Shift the purples/pinks, but strictly avoid Gold hues (20 to 70)
  //         const isGold = (h > 15 && h < 75) && s > 0.25;
  //         const isWhiteOrBlack = l > 0.9 || l < 0.1;

  //         if (shift !== 0 && !isGold && !isWhiteOrBlack) {
  //           let newH = (h + shift + 360) % 360;
  //           const [nR, nG, nB] = hslToRgb(newH, s, l);
  //           data[i] = nR;
  //           data[i+1] = nG;
  //           data[i+2] = nB;
  //         }
  //       }

  //       ctx.putImageData(imgData, 0, 0);
  //       resolve(canvas.toDataURL('image/png'));
  //     };
  //     img.src = template.src;
  //   });
  // }, [template]);

  /*
   * ==========================================================
   * FAST FRAME PROCESSOR
   * ==========================================================
   *
   * The expensive source-frame analysis runs once.
   * Theme changes then recolor only known theme pixels.
   */
  const initialiseFrameProcessor = useCallback(() => {
    /*
      React Fast Refresh can preserve refs while you edit this file.
      If an older processor created the previous purple-only mask,
      discard it so the new green/teal/blue-aware mask is rebuilt.
    */
    if (
      frameProcessorRef.current &&
      frameProcessorRef.current.engineVersion !== FRAME_PROCESSOR_VERSION
    ) {
      frameProcessorRef.current = null;
      frameProcessorPromiseRef.current = null;

      themeCacheRef.current.forEach((url) => {
        URL.revokeObjectURL(url);
      });

      themeCacheRef.current.clear();
      themeInFlightRef.current.clear();
    }

    if (
      frameProcessorRef.current?.engineVersion ===
      FRAME_PROCESSOR_VERSION
    ) {
      return Promise.resolve(frameProcessorRef.current);
    }

    if (frameProcessorPromiseRef.current) {
      return frameProcessorPromiseRef.current;
    }

    frameProcessorPromiseRef.current =
      new Promise((resolve, reject) => {
        const img = new Image();
        img.crossOrigin = 'anonymous';

        img.onload = () => {
          try {
            const width =
              img.naturalWidth || img.width;

            const height =
              img.naturalHeight || img.height;

            const canvas =
              document.createElement('canvas');

            canvas.width = width;
            canvas.height = height;

            const ctx = canvas.getContext(
              '2d',
              { willReadFrequently: true }
            );

            if (!ctx) {
              reject(
                new Error(
                  'Could not create frame canvas.'
                )
              );
              return;
            }

            ctx.drawImage(
              img,
              0,
              0,
              width,
              height
            );

            const imageData =
              ctx.getImageData(
                0,
                0,
                width,
                height
              );

            const pixels =
              new Uint8ClampedArray(
                imageData.data
              );

            const themeOffsets = [];
            const themeLightness = [];

            /*
              Exact INNER portrait opening.

              This is the key fix for the unwanted
              opening beside the upper-right flowers.
            */
            const cx =
              template.hole.cx * width;

            const cy =
              template.hole.cy * height;

            const radius =
              template.hole.r * width;

            const radiusSq =
              radius * radius;

            const feather =
              Math.max(
                1.5,
                width * 0.0015
              );

            for (
              let i = 0;
              i < pixels.length;
              i += 4
            ) {
              const alpha =
                pixels[i + 3];

              if (alpha === 0) continue;

              const red = pixels[i];
              const green = pixels[i + 1];
              const blue = pixels[i + 2];

              const [h, s, l] =
                rgbToHsl(
                  red,
                  green,
                  blue
                );

              const pixelIndex =
                i / 4;

              const px =
                pixelIndex % width;

              const py =
                Math.floor(
                  pixelIndex / width
                );

              const dx = px - cx;
              const dy = py - cy;

              const distSq =
                dx * dx +
                dy * dy;

              const isGold =
                isGoldPixel(h, s, l);

              /*
                Keep lower dark typography/shadow
                that intentionally overlaps the photo.
              */
              const isLowerTextShadow =
                py >
                  cy +
                    radius * 0.30 &&
                l < 0.34 &&
                s > 0.08;

              /*
                OPEN ONLY THE TRUE CENTER.

                Nothing outside this exact small circle
                can become transparent.
              */
              if (
                distSq < radiusSq &&
                !isGold &&
                !isLowerTextShadow
              ) {
                const distance =
                  Math.sqrt(distSq);

                if (
                  distance <=
                  radius - feather
                ) {
                  pixels[i + 3] = 0;
                } else {
                  const edge =
                    (
                      distance -
                      (radius - feather)
                    ) /
                    feather;

                  pixels[i + 3] =
                    Math.round(
                      alpha *
                        clamp(
                          edge,
                          0,
                          1
                        )
                    );
                }

                continue;
              }

              /*
                Save editable pixels ONCE.
              */
              if (
                !isGold &&
                isThemeSourcePixel(
                  h,
                  s,
                  l
                )
              ) {
                themeOffsets.push(i);

                themeLightness.push(
                  Math.round(
                    clamp(
                      l,
                      0,
                      1
                    ) * 255
                  )
                );
              }
            }

            const processor = {
              engineVersion: FRAME_PROCESSOR_VERSION,
              width,
              height,
              basePixels: pixels,
              themeOffsets:
                Uint32Array.from(
                  themeOffsets
                ),
              themeLightness:
                Uint8Array.from(
                  themeLightness
                )
            };

            frameProcessorRef.current =
              processor;

            resolve(processor);
          } catch (error) {
            reject(error);
          }
        };

        img.onerror = () => {
          reject(
            new Error(
              `Unable to load frame: ${template.src}`
            )
          );
        };

        img.src = template.src;
      });

    return frameProcessorPromiseRef.current;
  }, [template]);


  /*
   * Render a selected color.
   *
   * The selected HEX controls the exact HUE.
   * Only highlights/shadows vary in lightness.
   */
  const renderThemeFrame =
    useCallback(
      async (theme) => {
        const cacheKey =
          `${FRAME_PROCESSOR_VERSION}-${theme.hex.toUpperCase()}`;

        const cached =
          themeCacheRef.current.get(
            cacheKey
          );

        if (cached) {
          return cached;
        }

        const existing =
          themeInFlightRef.current.get(
            cacheKey
          );

        if (existing) {
          return existing;
        }

        const renderPromise =
          (async () => {
            const processor =
              await initialiseFrameProcessor();

            const pixels =
              new Uint8ClampedArray(
                processor.basePixels
              );

            const [
              targetHue,
              targetSaturation,
              targetLightness
            ] =
              hexToHsl(theme.hex);

            /*
              256-entry LUT makes recoloring
              much faster than HSL conversion
              for every pixel.
            */
            const rgbLookup =
              new Uint8ClampedArray(
                256 * 3
              );

            for (
              let lightByte = 0;
              lightByte < 256;
              lightByte += 1
            ) {
              const sourceL =
                lightByte / 255;

              /*
                Bright/vivid output while keeping
                realistic fabric and flower shading.
              */
              const saturation =
                clamp(
                  targetSaturation * 0.72 + 0.08,
                  0.38,
                  0.72
                );

              const lightness =
                clamp(
                  sourceL * 0.52 +
                    targetLightness * 0.38 +
                    0.10,
                  0.34,
                  0.92
                );

              const [r, g, b] =
                hslToRgb(
                  targetHue,
                  saturation,
                  lightness
                );

              const lutIndex =
                lightByte * 3;

              rgbLookup[lutIndex] =
                Math.round(r);

              rgbLookup[
                lutIndex + 1
              ] =
                Math.round(g);

              rgbLookup[
                lutIndex + 2
              ] =
                Math.round(b);
            }

            const offsets =
              processor.themeOffsets;

            const lightnessValues =
              processor.themeLightness;

            for (
              let index = 0;
              index < offsets.length;
              index += 1
            ) {
              const pixelOffset =
                offsets[index];

              const lutIndex =
                lightnessValues[
                  index
                ] * 3;

              pixels[pixelOffset] =
                rgbLookup[lutIndex];

              pixels[
                pixelOffset + 1
              ] =
                rgbLookup[
                  lutIndex + 1
                ];

              pixels[
                pixelOffset + 2
              ] =
                rgbLookup[
                  lutIndex + 2
                ];
            }

            const canvas =
              document.createElement(
                'canvas'
              );

            canvas.width =
              processor.width;

            canvas.height =
              processor.height;

            const ctx =
              canvas.getContext('2d');

            if (!ctx) {
              throw new Error(
                'Could not create theme canvas.'
              );
            }

            const outputData =
              ctx.createImageData(
                processor.width,
                processor.height
              );

            outputData.data.set(
              pixels
            );

            ctx.putImageData(
              outputData,
              0,
              0
            );

            /*
              Fast preview format with alpha.
              Falls back to PNG automatically.
            */
            const blob =
              await new Promise(
                (resolve) => {
                  canvas.toBlob(
                    (webpBlob) => {
                      if (webpBlob) {
                        resolve(
                          webpBlob
                        );
                        return;
                      }

                      canvas.toBlob(
                        resolve,
                        'image/png'
                      );
                    },
                    'image/webp',
                    0.96
                  );
                }
              );

            if (!blob) {
              throw new Error(
                'Could not create theme preview.'
              );
            }

            const objectUrl =
              URL.createObjectURL(blob);

            themeCacheRef.current.set(
              cacheKey,
              objectUrl
            );

            return objectUrl;
          })();

        themeInFlightRef.current.set(
          cacheKey,
          renderPromise
        );

        try {
          return await renderPromise;
        } finally {
          themeInFlightRef.current.delete(
            cacheKey
          );
        }
      },
      [initialiseFrameProcessor]
    );


  /*
   * Apply selected theme.
   * Cached selections appear virtually instantly.
   */
  useEffect(() => {
    let cancelled = false;

    const requestId =
      ++themeRequestIdRef.current;

    const applyTheme = async () => {
      const cacheKey =
        `${FRAME_PROCESSOR_VERSION}-${activeTheme.hex.toUpperCase()}`;

      const cached =
        themeCacheRef.current.get(
          cacheKey
        );

      if (cached) {
        setProcessedFrameSrc(
          cached
        );

        setIsProcessing(false);
        return;
      }

      setIsProcessing(true);
      setErrorMessage('');

      try {
        const themedFrame =
          await renderThemeFrame(
            activeTheme
          );

        if (
          !cancelled &&
          requestId ===
            themeRequestIdRef.current
        ) {
          setProcessedFrameSrc(
            themedFrame
          );
        }
      } catch (error) {
        console.error(error);

        if (!cancelled) {
          setErrorMessage(
            'Unable to prepare this frame colour.'
          );
        }
      } finally {
        if (
          !cancelled &&
          requestId ===
            themeRequestIdRef.current
        ) {
          setIsProcessing(false);
        }
      }
    };

    applyTheme();

    return () => {
      cancelled = true;
    };
  }, [
    activeTheme,
    renderThemeFrame
  ]);


  /*
   * Pre-cache all remaining colors during idle time.
   * After warm-up, switching is instant.
   */
  useEffect(() => {
    let cancelled = false;
    let cancelScheduled = null;
    let index = 0;

    const warmNext = async () => {
      if (cancelled) return;

      while (
        index <
          FRAME_THEMES.length &&
        themeCacheRef.current.has(
          `${FRAME_PROCESSOR_VERSION}-${FRAME_THEMES[
            index
          ].hex.toUpperCase()}`
        )
      ) {
        index += 1;
      }

      if (
        index >=
        FRAME_THEMES.length
      ) {
        return;
      }

      const theme =
        FRAME_THEMES[index];

      index += 1;

      try {
        await renderThemeFrame(
          theme
        );
      } catch {
        // Background warm-up is optional.
      }

      if (!cancelled) {
        cancelScheduled =
          createIdleScheduler(
            warmNext
          );
      }
    };

    cancelScheduled =
      createIdleScheduler(
        warmNext
      );

    return () => {
      cancelled = true;
      cancelScheduled?.();
    };
  }, [renderThemeFrame]);


  /*
   * Clean up cached blob URLs.
   */
  useEffect(() => {
    return () => {
      themeCacheRef.current.forEach(
        (url) => {
          URL.revokeObjectURL(url);
        }
      );

      themeCacheRef.current.clear();
      themeInFlightRef.current.clear();
    };
  }, []);




  /*
   * The foreground portrait uses CONTAIN at zoom 1.
   * That means the whole uploaded photo is visible instead of looking
   * excessively zoomed. A blurred COVER copy sits behind it, so the
   * circular opening is always visually filled and no rectangular gaps
   * are exposed.
   */
  const clampOffset = useCallback((candidate) => {
    return {
      x: clamp(candidate.x, -1, 1),
      y: clamp(candidate.y, -1, 1)
    };
  }, []);

  const handleZoomChange = (nextZoom) => {
    const safeZoom = clamp(nextZoom, MIN_ZOOM, MAX_ZOOM);
    setZoom(safeZoom);
    setOffset((prev) => clampOffset(prev));
  };

  const resetCrop = useCallback((targetPhoto = photo) => {
    if (!targetPhoto) {
      setZoom(1);
      setOffset({ x: 0, y: 0 });
      return;
    }

    const initial = getSmartInitialCrop(
      targetPhoto.naturalWidth,
      targetPhoto.naturalHeight
    );

    setZoom(initial.zoom);
    setOffset(initial.offset);
  }, [photo]);

  const handleImageUpload = (e) => {
    const file = e.target.files?.[0];

    if (!file) return;

    setErrorMessage('');

    if (!file.type.startsWith('image/')) {
      setErrorMessage('Please select a valid image file.');
      e.target.value = '';
      return;
    }

    const MAX_FILE_SIZE = 15 * 1024 * 1024;

    if (file.size > MAX_FILE_SIZE) {
      setErrorMessage(
        'Your image is too large. Please choose an image smaller than 15MB.'
      );
      e.target.value = '';
      return;
    }

    const reader = new FileReader();

    reader.onload = (event) => {
      const imageSource = event.target?.result;
      if (!imageSource) return;

      const img = new Image();

      img.onload = () => {
        const nextPhoto = {
          src: imageSource,
          naturalWidth: img.naturalWidth,
          naturalHeight: img.naturalHeight
        };

        setPhoto(nextPhoto);

        const initial = getSmartInitialCrop(
          img.naturalWidth,
          img.naturalHeight
        );

        setZoom(initial.zoom);
        setOffset(initial.offset);
      };

      img.onerror = () => {
        setErrorMessage(
          'We could not read this image. Please select another photo.'
        );
      };

      img.src = imageSource;
    };

    reader.onerror = () => {
      setErrorMessage('We could not open this file.');
    };

    reader.readAsDataURL(file);

    // Allows choosing the same file again.
    e.target.value = '';
  };

  const handlePointerDown = (e) => {
    if (!photo) return;

    e.currentTarget.setPointerCapture?.(e.pointerId);

    dragState.current = {
      startX: e.clientX,
      startY: e.clientY,
      startOffset: { ...offset }
    };
  };

  const handlePointerMove = (e) => {
    if (!dragState.current || !photo) return;

    const radius = Math.max(previewHole.r, 1);

    const deltaX = e.clientX - dragState.current.startX;
    const deltaY = e.clientY - dragState.current.startY;

    const candidate = {
      x: dragState.current.startOffset.x + deltaX / radius,
      y: dragState.current.startOffset.y + deltaY / radius
    };

    setOffset(clampOffset(candidate));
  };

  const handlePointerUp = (e) => {
    if (
      e.currentTarget.hasPointerCapture &&
      e.currentTarget.hasPointerCapture(e.pointerId)
    ) {
      e.currentTarget.releasePointerCapture(e.pointerId);
    }

    dragState.current = null;
  };

  /*
   * Foreground portrait rectangle.
   *
   * zoom === 1  -> contain (whole image visible)
   * zoom > 1    -> user can zoom in
   *
   * Empty space that contain would normally create is hidden by the
   * blurred cover background layer.
   */
  function getPhotoRect(holeDiameterPx, customZoom = zoom, customOffset = offset) {
    if (!photo) return null;

    const imageWidth = photo.naturalWidth;
    const imageHeight = photo.naturalHeight;

    const containScale = Math.min(
      holeDiameterPx / imageWidth,
      holeDiameterPx / imageHeight
    );

    const finalScale =
      containScale * clamp(customZoom, MIN_ZOOM, MAX_ZOOM);

    const width = imageWidth * finalScale;
    const height = imageHeight * finalScale;

    const maxShift = holeDiameterPx * 0.46;

    const offsetXPx = clamp(
      customOffset.x * (holeDiameterPx / 2),
      -maxShift,
      maxShift
    );

    const offsetYPx = clamp(
      customOffset.y * (holeDiameterPx / 2),
      -maxShift,
      maxShift
    );

    return {
      width,
      height,
      offsetXPx,
      offsetYPx
    };
  }

  const previewPhotoRect = photo ? getPhotoRect(previewHole.r * 2) : null;

  const handleDownload = async (e) => {
    e.preventDefault();
    if (!photo) {
      setErrorMessage('Please upload a photo to create your avatar.');
      setTimeout(() => setErrorMessage(''), 4000);
      return;
    }

    setIsDownloading(true);
    try {
      const exportWidth = template.width * EXPORT_SCALE;
      const exportHeight = template.height * EXPORT_SCALE;
      const holeCxPx = template.hole.cx * exportWidth;
      const holeCyPx = template.hole.cy * exportHeight;
      const holeRPx = template.hole.r * exportWidth;

      const canvas = document.createElement('canvas');
      canvas.width = exportWidth;
      canvas.height = exportHeight;
      const ctx = canvas.getContext('2d');

      const photoImg = new Image();
      photoImg.src = photo.src;

      await new Promise((resolve, reject) => {
        photoImg.onload = resolve;
        photoImg.onerror = reject;
      });

      const holeDiameter = holeRPx * 2;

      // ---------------------------------------------------------
      // 1. BLURRED COVER BACKGROUND
      // Always fills the circle so the user can zoom out safely.
      // ---------------------------------------------------------
      const coverScale = Math.max(
        holeDiameter / photo.naturalWidth,
        holeDiameter / photo.naturalHeight
      );

      const coverWidth = photo.naturalWidth * coverScale;
      const coverHeight = photo.naturalHeight * coverScale;

      ctx.save();
      ctx.beginPath();
      ctx.arc(holeCxPx, holeCyPx, holeRPx, 0, Math.PI * 2);
      ctx.clip();

      ctx.filter = `blur(${Math.max(12, exportWidth * 0.014)}px)`;
      ctx.globalAlpha = 0.82;

      const blurOverscan = 1.12;

      ctx.drawImage(
        photoImg,
        holeCxPx - (coverWidth * blurOverscan) / 2,
        holeCyPx - (coverHeight * blurOverscan) / 2,
        coverWidth * blurOverscan,
        coverHeight * blurOverscan
      );

      // Darken slightly so the foreground portrait stays clear.
      ctx.filter = 'none';
      ctx.globalAlpha = 0.14;
      ctx.fillStyle = '#0b080d';
      ctx.fillRect(
        holeCxPx - holeRPx,
        holeCyPx - holeRPx,
        holeDiameter,
        holeDiameter
      );

      ctx.restore();

      // ---------------------------------------------------------
      // 2. FOREGROUND PHOTO
      // At zoom 1, the WHOLE image fits inside the circle.
      // ---------------------------------------------------------
      const {
        width,
        height,
        offsetXPx,
        offsetYPx
      } = getPhotoRect(holeDiameter);

      ctx.save();
      ctx.beginPath();
      ctx.arc(holeCxPx, holeCyPx, holeRPx, 0, Math.PI * 2);
      ctx.clip();

      ctx.drawImage(
        photoImg,
        holeCxPx - width / 2 + offsetXPx,
        holeCyPx - height / 2 + offsetYPx,
        width,
        height
      );

      ctx.restore();

      // 2. Draw Processed Frame ON TOP (The gold text overlaps the photo perfectly!)
      const frameImg = new Image();
      frameImg.src = processedFrameSrc || template.src;
      await new Promise((resolve, reject) => {
        frameImg.onload = resolve;
        frameImg.onerror = reject;
      });
      ctx.drawImage(frameImg, 0, 0, exportWidth, exportHeight);

      const dataUrl = canvas.toDataURL('image/png');
      const link = document.createElement('a');
      link.download = `Royal_Avatar_${activeTheme.name.replace(/\s+/g, '_')}.png`;
      link.href = dataUrl;
      link.click();

      setShowConfetti(true);
      setTimeout(() => setShowConfetti(false), 6000);
    } catch (err) {
      console.error(err);
      setErrorMessage('Something went wrong generating your avatar.');
    } finally {
      setIsDownloading(false);
    }
  };

  const circleTouchAction = photo ? 'none' : 'auto';

  return (
    <div className="royal-avatar-page">
      <AmbientGlow secondaryHex={activeTheme.hex} />

      <div className="royal-nav">
        <Link to="/" className="back-link">
          <Icon.ArrowLeft width="16" height="16" /> Back to Home
        </Link>
      </div>

      {showConfetti && (
        <div className="fixed-confetti-wrapper">
          <Confetti width={window.innerWidth} height={window.innerHeight} numberOfPieces={400} gravity={0.3} colors={['#C6A15B', '#F4E8C9', activeTheme.hex, '#FFFFFF']} recycle={false} />
        </div>
      )}

      <div className="avatar-container">
        <Icon.RoyalVine className="royal-vine royal-vine-tl" />
        <Icon.RoyalVine className="royal-vine royal-vine-tr" />

        <motion.div className="avatar-header" initial={{ opacity: 0, y: -20 }} animate={{ opacity: 1, y: 0 }}>
          {/* <Icon.Crest className="header-crest" style={{ color: 'var(--gold, #c6a15b)', width: '48px', marginBottom: '16px' }} /> */}
          <span className="eyebrow">The Royal Studio</span>
          <h1>Create Your Avatar</h1>
          <p>Drop in your photo, adjust the theme color, and download your avatar.</p>
        </motion.div>

        <div className="studio-layout">
          
          <motion.div className="mirror-section" initial={{ opacity: 0, scale: 0.95 }} animate={{ opacity: 1, scale: 1 }}>
            <div
  className={`photo-stage ${photo ? 'has-photo' : 'no-photo'}`}
  style={{
    width: previewWidth,
    height: previewHeight
  }}

  onClick={() => {
    if (!photo) {
      fileInputRef.current?.click();
    }
  }}

  onPointerDown={handlePointerDown}
  onPointerMove={handlePointerMove}
  onPointerUp={handlePointerUp}
  onPointerCancel={handlePointerUp}
>

  {/* -----------------------------------------
      USER PHOTO
      This sits below the decorative frame.
  ----------------------------------------- */}

  <div
    className="photo-circle"

    style={{
      width:
        previewHole.r * 2,

      height:
        previewHole.r * 2,

      left:
        previewHole.cx -
        previewHole.r,

      top:
        previewHole.cy -
        previewHole.r,

      touchAction:
        circleTouchAction
    }}
  >

    {photo && previewPhotoRect ? (
      <>
        <img
          className="photo-backdrop-img"
          src={photo.src}
          alt=""
          aria-hidden="true"
          draggable="false"
        />

        <img
          className="photo-img"

        src={photo.src}

        alt="Your uploaded portrait"

        draggable="false"

        style={{
          width:
            previewPhotoRect.width,

          height:
            previewPhotoRect.height,

          left:
            previewPhotoRect.offsetXPx -
            (
              previewPhotoRect.width -
              previewHole.r * 2
            ) / 2,

          top:
            previewPhotoRect.offsetYPx -
            (
              previewPhotoRect.height -
              previewHole.r * 2
            ) / 2
        }}
        />
      </>
    ) : (
      <div
        className="upload-prompt"
      >
        <span className="upload-icon-circle">
          <Icon.Upload
            width="24"
            height="34"
          />
        </span>

        <strong>
          Add Your Photo
        </strong>

        <small>
          Click to upload
        </small>
      </div>
    )}

  </div>


  {/* -----------------------------------------
      DECORATIVE FRAME
  ----------------------------------------- */}

  <img
    className="template-overlay-img"

    src={
      processedFrameSrc ||
      template.src
    }

    alt="Royal avatar frame"

    draggable="false"

    style={{ opacity: 1 }}
  />


  {/* -----------------------------------------
      PROCESSING INDICATOR
  ----------------------------------------- */}

  {isProcessing && (
    <div className="frame-processing">
      <span className="processing-spinner" />

      <span>
        Updating theme…
      </span>
    </div>
  )}


  <input
    type="file"
    ref={fileInputRef}
    onChange={handleImageUpload}
    accept="image/png,image/jpeg,image/jpg,image/webp"
    className="hidden-file-input"
  />

</div>
 
          </motion.div>

          <motion.div className="wardrobe-section" initial={{ opacity: 0, x: 20 }} animate={{ opacity: 1, x: 0 }}>
            <form onSubmit={handleDownload}>
              
              <div className="control-group">
                <label>1. Frame Color Theme</label>
                <div className="theme-picker">
                  {FRAME_THEMES.map((theme) => (
                    <button
                      key={theme.name}
                      type="button"
                      className={`color-swatch ${activeTheme.name === theme.name ? 'active' : ''}`}
                      style={{
                        backgroundColor: theme.hex,
                        '--swatch-color': theme.hex
                      }}
                      onClick={() => setActiveTheme(theme)}
                      title={theme.name}
                      aria-label={`Use ${theme.name} theme`}
                      aria-pressed={activeTheme.name === theme.name}
                    />
                  ))}
                </div>
              </div>

              <div className="control-group">
                <label>2. Position Your Photo</label>
                {!photo ? (
                  <button type="button" className="btn-outline photo-picker-btn" onClick={() => fileInputRef.current.click()}>
                    <Icon.Upload width="18" height="18" /> Upload a Photo
                  </button>
                ) : (
                  <>
                    <div className="photo-action-row">
                      <button
                        type="button"
                        className="btn-outline photo-picker-btn"
                        onClick={() => fileInputRef.current?.click()}
                      >
                        Replace Photo
                      </button>

                      <button
                        type="button"
                        className="btn-outline reset-photo-btn"
                        onClick={() => resetCrop()}
                      >
                        Reset Fit
                      </button>
                    </div>

                    <div className="zoom-control">
                      <Icon.ZoomOut width="18" height="18" />
                      <input type="range" min={MIN_ZOOM} max={MAX_ZOOM} step={0.01} value={zoom} onChange={(e) => handleZoomChange(parseFloat(e.target.value))} />
                      <Icon.ZoomIn width="18" height="18" />
                    </div>
                    <p className="drag-hint">At the left end, the whole photo is visible. Zoom in only when needed, and drag to reposition.</p>
                  </>
                )}
              </div>

              <AnimatePresence>
                {errorMessage && (
                  <motion.div className="error-message" initial={{ opacity: 0, y: -10 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0 }}>
                    {errorMessage}
                  </motion.div>
                )}
              </AnimatePresence>

              <motion.button type="submit" className="btn-gold download-btn" disabled={isDownloading || isProcessing} whileHover={{ scale: 1.02 }} whileTap={{ scale: 0.98 }}>
                {isDownloading || isProcessing ? 'Processing Image...' : <><Icon.Download width="20" height="20" /> Download Royal Avatar</>}
              </motion.button>
            </form>
          </motion.div>
        </div>
      </div>
    </div>
  );
}